<template>
  <div>
    <a-drawer :title="fieldMap.tlScanPack.displayName+ '('+ (soheaderSearchVal == null || soheaderSearchVal =='' || soheaderSearchVal == undefined ? WareheaderSearchVal : soheaderSearchVal )  + ')'" @close="onClose" :visible="visible" width="95%" :maskClosable="false">
      <a-row type="flex" justify="start" >
        <a-col :span="3" style="margin: 10px 0 0 0">
          <div class="scanpackHeader">
            <div class="scanpackTitle" style="text-align: left; width: 60px">{{ fieldMap.tlRelId.displayName }}:</div>
            <a-input style="width: 70%"
                     ref="relIdRef"
                     :placeholder="$t('publicLang.PleaseEnter')"
                     size="small"
                     v-model="soheaderSearchVal"
                     @pressEnter="soHeaderSearch"/>
          </div>
        </a-col>
        <a-col :span="3" style="margin: 10px 0 0 0">
          <div class="scanpackHeader">
            <div class="scanpackTitle" style="text-align: left; width: 70px">{{ fieldMap.tlWaveId.displayName }}:</div>
            <a-input style="width: 80%" ref="waveIdRef" :placeholder="$t('publicLang.PleaseEnter')" size="small" v-model="WareheaderSearchVal" @pressEnter="WareHeaderSearch"/>
          </div>
        </a-col>

        <a-col :span="4" style="margin: 10px 0 0 0" v-if="(this.amrFlow  == null ? false : this.amrFlow )||this.systemParam.JCWMS_FLOW=='Y'||this.systemParam.DP_FLOW=='Y' " >
          <div class="scanpackHeader" >
            <div class="scanpackTitle" style="text-align: left; width: 110px" v-if="(this.amrFlow  == null ? false : this.amrFlow )">
              {{ fieldMap.tlAmrContainerNo.displayName }}:
            </div>
            <div class="scanpackTitle" style="text-align: left; width: 110px" v-if="this.systemParam.JCWMS_FLOW=='Y'">
              {{ fieldMap.tlIwmsContainerNo.displayName }}:
            </div>
            <div class="scanpackTitle" style="text-align: left; width: 110px" v-if="this.systemParam.DP_FLOW=='Y'">
              {{ fieldMap.tlContainerNo.displayName }}:
            </div>
            <a-input  style="width: 70%" :placeholder="$t('publicLang.PleaseEnter')" ref="containerNo" size="small" v-model="ssccSearchVal" @pressEnter="orderSearch('SSCC')"/>
          </div>
        </a-col>

        <a-col :span="2" style="margin: 10px 0 0 0">
          <div class="scanpackHeader" >
            <div class="scanpackTitle" >{{ fieldMap.tlHiddenTable.displayName }}:</div>
            <a-switch v-model="isHiddenTable" @change="handleSwitchChange" :disabled="isSwitchDisabled"  />
          </div>
        </a-col>

        <!--Partial Pack Order>Click Check Complete Btn>Show This Window>Select No>Show Moving Window-->
        <a-modal v-model="showCompleteTips" :title="$t('scanPack.title')" :footer="null" @cancel="closeCheckCompleteTips">
          <div class="confirm-icon">
            <a-icon type="question-circle" />
          </div>
          <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.cancelCheckCompleteMoveMsg') }}</span>
          <div style="display: flex;justify-content: flex-end;margin-top: 25px">
            <div>
              <a-button style="margin-right: 10px" type="primary" @click="checkCompleteShowMoveWindow(true)">
                {{ $t('scanPack.cancelCheckCompleteNo') }}
              </a-button>
              <a-button type="primary" @click="checkCompleteShowMoveWindow(false)">
                {{ $t('scanPack.cancelCheckCompleteYes') }}
              </a-button>
            </div>
          </div>
        </a-modal>

        <a-modal v-model="cancelPickConfirmVisible" :title="$t('scanPack.title')" :footer="null" @cancel="closeCancelPickConfirm">
          <div class="cancel-pick-confirm-message">
            <div class="confirm-icon">
              <a-icon type="question-circle" />
            </div>
            <span class="cancel-pick-confirm-text">{{ $t('scanPack.cancelPickForCheckCompleteMsg') }}</span>
          </div>
          <div class="cancel-pick-confirm-list">
            <div v-for="(item, index) in cancelPickConfirmList" :key="index" class="cancel-pick-confirm-item">
              <span class="cancel-pick-confirm-sku cancel-pick-confirm-value">{{ item.sku || '' }}</span>
              <span class="cancel-pick-confirm-value">{{ '- ' + (item.qty || 0) + ' pcs' }}</span>
            </div>
          </div>
          <div style="display: flex;justify-content: flex-end;margin-top: 25px">
            <a-button style="margin-right: 10px" type="primary" :disabled="cancelPickConfirmLoading" @click="closeCancelPickConfirm">
              {{ $t('scanPack.cancelCheckCompleteNo') }}
            </a-button>
            <a-button type="primary" :disabled="cancelPickConfirmLoading" @click="confirmCancelPickThenMove">
              {{ $t('scanPack.cancelCheckCompleteYes') }}
            </a-button>
          </div>
        </a-modal>

        <!--confirm/checkComplete-->
        <a-col style="margin-left: 80px;margin: 10px 0 0 0;">
          <a-row type="flex" justify="start">

            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'CheckComplete'" style="margin-left: 4px;">
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    :disabled="checkCompleteDisable"
                    @click="checkPartialPack(item.arr[0])">
                  {{ item.arr[0].name }}
                </a-button>
                <a-dropdown-button v-else-if="item.arr.length  >  1" >
                  {{ $t('publicLang.Confirm').toUpperCase() }}
                  <a-menu slot="overlay" >
                    <a-menu-item v-for="(tt,index) in item.arr" :key="index" :disabled="checkCompleteDisable" @click="checkPartialPack(tt)">{{tt.name}}</a-menu-item>
                  </a-menu>
                </a-dropdown-button>
              </div>
            </a-col>

          </a-row>
        </a-col>

        <!--CancelCheckComplete-->
        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">
            <a-col v-for="item in btnFunArr" :key="item.uid">
              <!-- <div v-if="item.code == 'ob.scan.pack.confirm'" style="margin-left: 4px;">
                                <a-button  size="small" type="primary" @click="cancelCheckComplete">{{ $t('publicLang.CancelCheckComplete') }}</a-button>
                            </div> -->

              <div v-if="item.code == 'CancelCheckComplete'" style="margin-left: 4px;">
                <!-- <a-button
                                        v-if="item.arr.length == 1"
                                        size="small" type="primary"
                                        @click="cancelCheckComplete">
                                  {{ $t('publicLang.CancelCheckComplete') }}
                                </a-button>
                                 <a-dropdown-button v-else-if="item.arr.length  >  1" >
                                   {{ $t('publicLang.CancelCheckComplete') }}
                                   <a-menu slot="overlay" >
                                     <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="batchBtnconfigPrint(tt)">{{tt.name}}</a-menu-item>
                                   </a-menu>
                                 </a-dropdown-button> -->



                <div>
                  <a-button type="primary" size="small" @click="showSelectBox" :disabled="cancelCheckCompleteDisable" v-if="item.code == 'CancelCheckComplete' && item.arr.length > 0">
                    {{ item.arr[0].name   }}
                  </a-button>
                  <a-modal
                      v-model="cancelCheckCompleteVisible" :title="$t('scanPack.title')" :footer="null"   @cancel="closeCancelCheckCompleteVisible"  >
                    <div class="confirm-icon">
                      <a-icon type="question-circle" />
                    </div>
                    <span class="check-complete-confirm-text"> {{ $t('scanPack.cancelCheckCompleteMsg') }}</span>
                    <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                      <div>
                        <a-button style="margin-right: 10px"  type="primary" @click="handleCancel" :disabled="cancelCheckCompleteRequestDisable" >
                          {{ $t('scanPack.cancelCheckCompleteNo') }}
                        </a-button>
                        <a-button type="primary"  @click="handleOk" :disabled="cancelCheckCompleteRequestDisable">
                          {{ $t('scanPack.cancelCheckCompleteYes') }}
                        </a-button>
                      </div>
                    </div>
                  </a-modal>

                  <a-modal
                      v-model="cancelCheckCompleteMoveVisibel" :title="$t('scanPack.title')" :footer="null"  @cancel="closeCancelCheckCompleteMoveVisibel"    >
                    <div class="confirm-icon">
                      <a-icon type="question-circle" />
                    </div>
                    <span class="check-complete-confirm-text"> {{ $t('scanPack.cancelCheckCompleteMoveMsg') }}</span>
                    <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                      <div>
                        <a-button style="margin-right: 10px"  type="primary" @click="handleOkCreateMove" :disabled="cancelCheckCompleteRequestDisable">
                          {{ $t('scanPack.cancelCheckCompleteNo') }}
                        </a-button>
                        <a-button type="primary"  @click="handleCancelNoCreateMove" :disabled="cancelCheckCompleteRequestDisable">
                          {{ $t('scanPack.cancelCheckCompleteYes') }}
                        </a-button>
                      </div>
                    </div>
                  </a-modal>




                  <a-modal
                      v-model="cancelPartCheckCompleteVisibel" :title="$t('scanPack.title')" :footer="null"  @cancel="closeCancelPartCheckCompleteVisibel"    >
                    <div class="confirm-icon">
                      <a-icon type="question-circle" />
                    </div>
                    <span style="text-align: center;margin: 0px;margin-left: 4px;font-size: 16px"> {{ $t('scanPack.firstCancelCheckCompleteThenScanPack') }}</span>
                    <div style="display: flex;justify-content: flex-end;margin-top: 25px">
                      <div>
                        <a-button style="margin-right: 10px"  type="primary" @click="closeCancelPartCheckCompleteVisibel" >
                          {{ $t('scanPack.cancelCheckCompleteNo') }}
                        </a-button>
                        <a-button type="primary"  @click="cancelPartCheckComplete" >
                          {{ $t('scanPack.cancelCheckCompleteYes') }}
                        </a-button>
                      </div>
                    </div>
                  </a-modal>


                </div>


              </div>
            </a-col>
          </a-row>
        </a-col>


        <!--confirm-->
        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">

            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'Confirm'" style="margin-left: 4px;">
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    :disabled="confirmDisable"
                    @click="newConfirmScanpack(item.arr[0])">
                  {{ item.arr[0].name }}
                </a-button>
              </div>
            </a-col>

          </a-row>
        </a-col>

        <!--CloseOrder-->
        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">

            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'CloseOrder'" style="margin-left: 4px;">
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    @keydown.stop.prevent
                    :disabled="closeDisable"
                    @click="scanpackCloseOrder(item.arr[0])">
                  {{ item.arr[0].name }}
                </a-button>
              </div>
            </a-col>

          </a-row>
        </a-col>

        <!--SendEDI-->
        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">

            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'SendEDI'" style="margin-left: 4px;">
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    @click="scanpackSendEDI(item.arr[0])">
                  {{ item.arr[0].name  }}
                </a-button>
              </div>
            </a-col>

          </a-row>
        </a-col>
        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">

            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'Re-print'" style="margin-left: 4px;">
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    @click="rePrintCloseCtnReport()">
                  {{ item.arr[0].name }}
                </a-button>
              </div>
            </a-col>

          </a-row>
        </a-col>

        <a-col style="margin: 10px 0 0 0">
          <a-button size="small" type="primary" style="margin-left: 4px;" v-for="item in btnFunArr" :key="item.code" v-if="item.code == 'Export' && item.arr.length > 0" :disabled="systemParam.scanpack_way == 'Y' && scanPackDtoList.length > 0" @click="exportSkuTable">
            {{ item.arr[0].name }}
          </a-button>
        </a-col>

        <!--Courier Edi-->
        <a-col v-for="item in btnFunArr" :key="item.uid" style="margin: 10px 0 0 0">
          <div v-if="item.code == 'CourierEDI'" id="CourierEdi" style="margin-left: 20px;">
            <a-dropdown-button v-if="item.arr.length  >  0" style="">
              {{  fieldMap.tlCourierEdi.displayName  }}
              <a-menu slot="overlay">

                <!-- <a-menu-item  key="1" @click="GenerateLabel('pack_list')"><a-icon type="printer" />{{ $t('pubGicSet.IntersoftGenerateLabel') }}</a-menu-item>-->
                <!-- <a-menu-item key="2" @click="IntersoftCancelLabel('pack_list')"><a-icon type="printer" />{{ $t('pubGicSet.IntersoftCancelLabel') }}</a-menu-item> -->
                <!-- <a-menu-item key="3" @click="IntersoftGenerateMainfest('pack_list')"><a-icon type="printer" />{{ $t('pubGicSet.IntersoftGenerateMainfest') }}</a-menu-item> -->
                <a-menu-item v-for="tt in item.arr" :key="tt.uid" @click="printPDFByBtnConfig(tt)">{{tt.name}}</a-menu-item>
              </a-menu>
            </a-dropdown-button>
          </div>
        </a-col>

        <!--Print-->
        <a-col  v-for="item in btnFunArr" :key="item.uid"  style="margin: 10px 0 0 0">
          <div v-if="item.code == 'Print'" id="printPackList" style="margin-left: 40px;">
            <a-dropdown-button v-if="item.arr.length  >  0">
              {{ fieldMap.tlPrint.displayName }}
              <a-menu slot="overlay" style="overflow: auto;" :style="'max-height:' + printHeight + 'px'" >
                <!-- <a-menu-item key="1" @click="printPdf('pick_list')"><a-icon type="printer" />{{ $t('pubGicSet.PrintPackingList') }}</a-menu-item>
                                <a-menu-item key="2" @click="printPdf('pack_list')"><a-icon type="printer" />{{ $t('pubGicSet.PackingList') }}</a-menu-item> -->
                <a-menu-item v-for="tt in item.arr" :key="tt.uid" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
              </a-menu>
            </a-dropdown-button>
          </div>
        </a-col>


        <a-col style="margin: 10px 0 0 0">
          <a-row type="flex" justify="start">
            <a-col v-for="item in btnFunArr" :key="item.uid">
              <div v-if="item.code == 'CourierEDI-BTN'" style="margin-left: 20px;" >
                <a-button
                    v-if="item.arr.length == 1"
                    size="small" type="primary"
                    @click="getExpressNumber(item.arr[0])">
                  {{ item.arr[0].name  }}
                </a-button>
              </div>
            </a-col>

          </a-row>
        </a-col>
      </a-row>
      <a-divider style="margin: 10px 0"></a-divider>


      <a-row  v-if="!isHiddenTable">
        <div id="wocao">
          <!-- 正常区域的框 -->
          <div class="vxe-table--cell-area" ref="cellarea">
            <span class="vxe-table--cell-main-area"></span>
            <span class="vxe-table--cell-active-area"></span>
          </div>
          <!-- 左边fixed区域的框,右边fixed没有尝试过。。。 -->
          <div id="leftcellarea" class="vxe-table--cell-area" ref="fixedcellarea">
            <span class="vxe-table--cell-main-area"></span>
            <span class="vxe-table--cell-active-area"></span>
          </div>

          <div id="rightcellarea" class="vxe-table--cell-area" ref="rightfixedcellarea">
            <span class="vxe-table--cell-main-area"></span>
            <span class="vxe-table--cell-active-area"></span>
          </div>
          <vxe-table
              border
              :data.sync="partTable"
              ref="skuTable"
              class="mytable-style un-select-vxe-table"
              :cell-class-name="cellClassName"
              max-height="280"
              show-footer
              resizable
              :footer-method="footerMethod"
              :footer-cell-class-name="footerCellClassName"
              size="mini"
              :row-style="rowStyle"
              v-bind="gridOptions"
              @keydown="tableKeydown"
              @cell-click="tableCellClick"
              :keyboard-config="{ isArrow: true }"
              stripe
              highlight-hover-row
              resizable
              show-overflow
          >
            <template v-slot:empty>
              <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>
            <vxe-table-column type="checkbox" width="50"></vxe-table-column>
            <vxe-table-column field="relId" :title="fieldMap.tbRelId.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="200"></vxe-table-column>
            <vxe-table-column field="sku" :title="fieldMap.tbSku.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="150"></vxe-table-column>
            <vxe-table-column field="scanFieldValue" :title="fieldMap.tbUpc.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="150"></vxe-table-column>
            <vxe-table-column field="descr" :title="fieldMap.tbDescr.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="200"></vxe-table-column>
            <vxe-table-column field="pickedQty" :title="fieldMap.tbAllocateQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis"  width="80"></vxe-table-column>
            <vxe-table-column field="packedQty" :title="fieldMap.tbPackedQty.displayName" show-overflow show-header-overflow width="80"></vxe-table-column>
            <vxe-table-column field="unscannQty" :title="fieldMap.tbOutstandingQty.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="80"></vxe-table-column>
            <vxe-table-column field="sscc" :title="fieldMap.tbSscc.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="200"></vxe-table-column>
            <vxe-table-column field="status" :title="fieldMap.tbStatus.displayName" show-header-overflow="ellipsis" show-overflow="ellipsis" width="80">
              <template v-slot="{row}"><span :style="colStyle(row.status)">{{row.status}}</span></template>
            </vxe-table-column>
          </vxe-table>
        </div>
      </a-row>

      <a-row class="mt">
        <a-col :span="12" style="marginTop:6px">
          <a-row>
            <a-form :form="form" class="ant-advanced-search-form">
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item v-bind="formItemLayout" :label="fieldMap.scEpc.displayName" v-if="epcVisible || this.systemParam.SCAN_IN_EPC == 'Y'|| this.systemParam.MBSHA_SCAN_IN_EPC == 'Y' ? true : false" :class="epcVisible || this.systemParam.SCAN_IN_EPC  == 'Y'|| this.systemParam.MBSHA_SCAN_IN_EPC == 'Y' ? 'genericFrom  request-form-item' : 'genericFrom'">
                    <input
                        style="width: 100%;"
                        v-model.trim="epcScanVal"
                        ref="epcScanRef"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        :disabled="epcValDisabled"
                        @keyup.enter="epcEnterEvt"/>
                  </a-form-item>
                </a-col>

                <!--Tom 2024-07-15 赠品-->
                <a-col :span="4"  v-if="this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'">
                  <a-form-item  :label="fieldMap.scGift.displayName">
                    <a-checkbox v-model="giftChecked" size="large" @change="giftCheckedChange"></a-checkbox>
                  </a-form-item>
                </a-col>

                <!--Tom 2024-12-03 special epc scan-->
                <a-col :span="4"  v-if="this.systemParam.MBSHA_SCAN_IN_EPC!=undefined&&this.systemParam.MBSHA_SCAN_IN_EPC=='Y'">
                  <a-checkbox v-model="mbshaScanInEpcCheck" size="large" @change="mbshaScanInEpcCheckChange"></a-checkbox>
                </a-col>
              </a-row>
              <a-row :gutter="24" style="margin-top: 5px">
                <a-col :span="8">
                  <a-form-item  :label="skuLabel">
                    <input
                        ref="skuScanUpcRef"
                        style="width: 100%;"
                        v-model.lazy="skuScanUpc"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        :disabled="skuabled"
                        @keyup.enter="SkuEnterEvt"/>
                  </a-form-item>
                </a-col>
                <a-col :span="5">
                  <a-form-item :label="fieldMap.scQty.displayName">
                    <a-input-number id="inputNumber"
                                    v-model="OtySaoNum"
                                    :min="1"
                                    :disabled="lockChecked"
                                    style="width: 100%;"
                                    :placeholder="$t('publicLang.PleaseEnter')"
                                    size="small"
                                    ref="SacnPackSaomaQtyNum"
                                    @pressEnter="OtySaoNumEnterEvt"

                    />
                  </a-form-item>
                </a-col>

                <a-col :span="4"  v-if="checkboxList.includes('C-LockScanQty')" >
                  <a-form-item  :label="fieldMap.scLockScanQty.displayName">
                    <a-checkbox
                        :checked="lockChecked"
                        @change="lockChangeEvnt"
                    ></a-checkbox>
                  </a-form-item>
                </a-col>


                <a-col :span="6"  v-if="checkboxList.includes('C-RemoveScanItem')" >
                  <a-form-item :label="fieldMap.scRemoveScanItem.displayName">
                    <a-checkbox
                        :checked="DeleteChecked"
                        @change="DeleteChangeEvnt"
                    ></a-checkbox>
                  </a-form-item>
                </a-col>

              </a-row>
              <a-row :gutter="24">

                <a-col :span="4" offset="1" style="margin-top: -10px;" v-if="checkboxList.includes('C-IsCarton')  &&  this.systemParam.scanpack_way != 'Y' ">
                  <a-form-item :label="fieldMap.scIsCarton.displayName">
                    <a-checkbox :checked="isCartonChecked" @change="checkIsCartonOrPrePack('isCarton')"></a-checkbox>
                  </a-form-item>
                </a-col>

                <a-col :span="4" style="margin-top: -10px;" v-if="checkboxList.includes('C-IsPre-Pack') && this.systemParam.scanpack_way != 'Y'"  >
                  <a-form-item :label="fieldMap.scIsPrePack.displayName">
                    <a-checkbox :checked="isPrePackChecked" @change="checkIsCartonOrPrePack('isPrepack')"></a-checkbox>
                  </a-form-item>
                </a-col>

                <a-col :span="4" offset="1" style="margin-top: -10px;" v-if="checkboxList.includes('C-IsTraceID') &&  this.systemParam.scanpack_way != 'Y' ">
                  <a-form-item :label="fieldMap.scIsTraceId.displayName">
                    <a-checkbox :checked="isTraceIdChecked" @change="checkIsCartonOrPrePack('isTraceId')"></a-checkbox>
                  </a-form-item>
                </a-col>

              </a-row>

            </a-form>
          </a-row>


          <a-row v-if="! scanComponentsFlag" type="flex" justify="start">
            <a-col v-if="this.systemParam.SCANPACK_SHOW_QTY == 'Y' ? false : true "  style="margin-left: 100px;margin-top: -10px;">
              <p class="scanCodeTile">{{ fieldMap.scPackedQty.displayName }}</p>
              <div style="font-size: 100px;color: #23B14D;font-weight: bold;margin-top: -30px;">
                <p>{{skuPackedQty}}</p>
              </div>
            </a-col>

            <a-col  style="margin-left: 100px;margin-top: -10px;">
              <p class="scanCodeTile">{{ fieldMap.scUnpackQty.displayName }}</p>
              <div style="color: #ED1D25;font-size: 100px;font-weight: bold;margin-top: -30px;">
                <p>{{ skuUnpackQty }}</p>
              </div>
            </a-col>

            <a-col v-if="platfromVal != null " type="flex" justify="start" style="margin-left: 30px">
              <a-col>
                <el-card class="box-card" style="margin-top: 10px;text-align: center;;font-size: 50px;color: red;background-color: #e8e8e8">
                  {{platfromVal}}
                </el-card>
              </a-col>
            </a-col>
            <a-col v-if="amrContainerValue != null " type="flex" justify="start" style="margin-left: 30px">
              <a-col>
                <el-card class="box-card" style="margin-top: 10px;text-align: center;;font-size: 50px;color: red;background-color: #e8e8e8">
                  {{amrContainerValue}}
                </el-card>
              </a-col>
            </a-col>
          </a-row>

          <a-row v-if="scanComponentsFlag" type="flex" justify="start">
            <a-col>
              <span style="display: inline-block;margin-left: 10px; font-weight: bold;font-size: 15px;border: 1px solid black;padding: 2px 5px;text-align: center;">Component Scan</span>
            </a-col>
          </a-row>

          <a-row  v-if="scanComponentsFlag" type="flex" justify="start" style="margin-left: 10px;">
            <a-col>
              <p style="font-size: 20px;margin-top: 50%;margin-bottom: 0;">{{componentSku1}}</p>
            </a-col>

            <a-col style="margin-left: 100px;">
              <template>
                <a-progress type="circle" :percent="components.length > 0 ?  scanComponents.length/components.length * 100 : 0" :format="percent => ``" />
              </template>
              <span style="position: absolute;left: 20%;;top: 30px;font-size: 28px;">{{scanComponents.length}}</span>
              <span style="position: absolute;left: 45%;top: 38px;font-size: 28px;">/</span>
              <span style="position: absolute;left: 56%;top: 51px;font-size: 28px;">{{components.length}}</span>
            </a-col>
          </a-row>

          <a-row v-if="scanComponentsFlag" type="flex"  style="margin-left: 10px;" >
            <a-col style="margin-top: 5px;">
              <div v-for="(item,index) in components" style="display: inline;">
                <button :class='scanComponents.includes(item) ? "component-btn component-btn-active-bgc":"component-btn component-btn-inactive-bgc"' >{{item}}</button>
                <br v-if="index == 4" />
              </div>
            </a-col>
          </a-row>

          <a-row style="margin-left: 10px;">
            <transition name="slide-fade">
              <a-row>
                <a-row>
                  <a-spin :spinning="editSpin">

                    <a-form :form="editForm">
                      <a-row :gutter="24" style="margin-right: 10px">
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcCartonNo.displayName">
                            <a-input
                                size="small"
                                :disabled="true"
                                v-decorator="[
                                                'cartonNo',
                                                { initialValue: newEditCartData.cartonNo }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                style="width:100%"
                            />
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcCartonType.displayName">
                            <a-select
                                show-search
                                optionFilterProp="label"
                                :placeholder="$t('publicLang.PleaseSelect')"
                                style="width: 100%"
                                size="small"
                                v-decorator="[
                                                'cartonType',
                                                { initialValue: newEditCartData.cartonType }
                                              ]" @change="cartonTypeChange2"
                            >
                              <!--                                      <a-select-option v-for="item in cartonTypeSelectData" :value="item">{{item}}</a-select-option>-->
                              <a-select-option :label="item"  :value="item.cartonType" :key="item.cartonType" v-for="item in this.systemParam.CARTON_MASTER_LIST">{{item.cartonType}}</a-select-option>
                            </a-select>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcTrackingNo.displayName">
                            <a-input
                                v-bind:disabled="trackingNoEdit"
                                v-decorator="[
                                                'logisticsid',
                                                { initialValue: newEditCartData.logisticsid }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="$t('pubGicSet.Length')">
                            <a-input-number
                                size="small"
                                :min="0"
                                v-decorator="[
                                                  'length',
                                                  { initialValue: newEditCartData.length }
                                                ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                style="width:100%"
                            />
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcWidth.displayName">
                            <a-input-number
                                size="small"
                                :min="0"
                                v-decorator="[
                                                  'width',
                                                  { initialValue: newEditCartData.width }
                                                ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcHeight.displayName">
                            <a-input-number
                                size="small"
                                :min="0"
                                v-decorator="[
                                                  'height',
                                                  { initialValue: newEditCartData.height }
                                                ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcDimUom.displayName">
                            <a-input
                                v-decorator="[
                                                  'dimensionUom',
                                                  {
                                                    initialValue: newEditCartData.dimensionUom
                                                  }
                                                ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcCbm.displayName">
                            <a-input-number
                                size="small"
                                :min="0"
                                ref="cbmRef"
                                v-decorator="[
                                                  'cbm',
                                                  { initialValue: newEditCartData.cbm }
                                                ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcWeight.displayName">
                            <a-input
                                v-decorator="[
                                                'grossWeight',
                                                { initialValue: newEditCartData.grossWeight }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                ref="weightRef"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcWeightUom.displayName">
                            <a-input
                                v-decorator="[
                                                'weightUom',
                                                { initialValue: newEditCartData.weightUom }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined1.displayName">
                            <a-input
                                v-decorator="[
                                                'userdefined1',
                                                { initialValue: newEditCartData.userdefined1 }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined2.displayName">
                            <a-input
                                v-decorator="[
                                                'userdefined2',
                                                { initialValue: newEditCartData.userdefined2 }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined3.displayName">
                            <a-input
                                v-decorator="[
                                                'userdefined3',
                                                { initialValue: newEditCartData.userdefined3 }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined4.displayName">
                            <a-input
                                v-decorator="[
                                                'userdefined4',
                                                { initialValue: newEditCartData.userdefined4 }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                        <a-col :span="8">
                          <a-form-item class="genericFrom" :label="fieldMap.pcUserdefined5.displayName">
                            <a-input
                                v-decorator="[
                                                'userdefined5',
                                                { initialValue: newEditCartData.userdefined5 }
                                              ]"
                                :placeholder="$t('publicLang.PleaseEnter')"
                                size="small"
                                style="width:100%"/>
                          </a-form-item>
                        </a-col>
                      </a-row>
                    </a-form>

                  </a-spin>
                </a-row>
              </a-row>
            </transition>
          </a-row>

        </a-col>

        <a-col :span="12">
          <a-tabs v-model="scanpackTabsTarget" @change="scanpackTabsEvent" tabPosition="top" size="small">
            <a-tab-pane :tab="$t('pubGicSet.Detail')" key="1">
              <a-row type="flex" justify="start">
                <a-col style="margin-left: 20px;">
                  <p class="scanCodeTile">{{ fieldMap.pdAllocatedQty.displayName }}</p>
                  <div class="radiusback" style="background: #009900;">
                    <i>{{scanpackDetailAllocatedQty}}</i>
                  </div>
                </a-col>
                <a-col style="margin-left: 20px;">
                  <p class="scanCodeTile">{{ fieldMap.pdPackedQty.displayName }}</p>
                  <div class="radiusback" style="background: #6666ff;">
                    <i>{{scanpackDetailPackedQty}}</i>
                  </div>
                </a-col>
                <a-col style="margin-left: 20px;">
                  <p class="scanCodeTile">{{ fieldMap.pdPercentage.displayName }}</p>
                  <div class="radiusback" style="background: #f69;"><i style="font-size: 50px">{{scanpackDetailPercentage}}</i></div>
                </a-col>
                <a-col style="margin-left: 20px;">
                  <p class="scanCodeTile">{{ fieldMap.pdNoOfCarton.displayName }}</p>
                  <div class="radiusback" style="background: #699;"><i>{{scanpackDetailNocarton}}</i></div>
                </a-col>
              </a-row>
              <a-divider style="margin: 10px 0"></a-divider>
              <a-row>
                <vxe-table
                    border
                    resizable
                    :data.sync="scanpackDetailTable"
                    size="mini"
                    max-height="330"
                    @cell-click="scanpackDetailTableEvnt"
                >
                  <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                  </template>
                  <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                  <vxe-table-column
                      width="200"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="cartonNo"
                      :title="fieldMap.tbPcCartonNo.displayName"
                  ></vxe-table-column>
                  <vxe-table-column
                      width="200"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="qty"
                      :title="fieldMap.tbPcPackedQty.displayName"
                  ></vxe-table-column>
                  <vxe-table-column
                      width="200"
                      show-header-overflow="ellipsis" show-overflow="ellipsis"
                      field="createdby"
                      :title="fieldMap.tbPcCreatedBy.displayName"
                  ></vxe-table-column>
                </vxe-table>
              </a-row>
            </a-tab-pane>
            <a-tab-pane :tab="$t('pubGicSet.Carton')" key="2">
              <a-row type="flex" justify="start">

                <!--Save按钮-->
                <a-row style="margin-top: 10px;margin-right: 5px;">
                  <div class="scanpackHeader">
                    <a-button v-if="this.showCartonSave"
                              type="primary"
                              size="small"
                              @click="editCartonSubmit"
                    >{{ $t('publicLang.Save') }}</a-button>
                  </div>
                </a-row>

                <a-col v-for="item in btnFunArr" :key="item.uid" style="margin-top: 10px">

                  <!--  <div v-if="item.code == 'ob.scan.pack.close.new'" style="margin-left: 4px;">
                                       <a-button
                                               v-if="item.arr.length == 0"
                                               size="small"
                                               type="primary"
                                               @click="closeAndNew"
                                               :disabled="closeAndNewDisab"
                                       >{{ $t('pubGicSet.CloseAndNew') }}</a-button>
                                      <a-dropdown-button v-else @click="closeAndNew" :disabled="closeAndNewDisab">
                                         {{ $t('pubGicSet.CloseAndNew') }}
                                         <a-menu slot="overlay" >
                                           <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="batchBtnconfigPrint(tt)">{{tt.btnName}}</a-menu-item>
                                         </a-menu>
                                       </a-dropdown-button>
                                    </div>-->

                  <!-- <div v-if="item.code == 'ob.scan.pack.new'" style="margin-left: 4px;">
                                      <a-button
                                              v-if="item.arr.length == 0"
                                              size="small"
                                              type="primary"
                                              @click="newCarton"
                                              :disabled="newDisab"
                                      >{{ $t('pubGicSet.New') }}</a-button>
                                      <a-dropdown-button v-else @click="newCarton" :disabled="newDisab">
                                        {{ $t('pubGicSet.New') }}
                                        <a-menu slot="overlay" >
                                          <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="batchBtnconfigPrint(tt)">{{tt.btnName}}</a-menu-item>
                                        </a-menu>
                                      </a-dropdown-button>
                                    </div> -->

                  <!--  Close  -->
                  <div v-if="item.code == 'Close'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        size="small"
                        type="primary"
                        @click="closeCarton(item.arr[0])"
                        :disabled="closeDisab"
                    > {{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length > 1"  :disabled="closeDisab">
                      {{ item.arr[0].name }}
                      <a-menu slot="overlay" >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="closeCarton(tt)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>


                  <!--  Remove  -->
                  <div v-if="item.code == 'Remove'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        @click="removeCarton(item.arr[0])"
                    > {{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length >1 " :disabled="removeDisab">
                      {{ item.arr[0].name }}
                      <a-menu slot="overlay"  >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="removeCarton(tt)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>

                  <!--  Append  -->
                  <div v-if="item.code == 'Append'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        @click="appendCarton(item.arr[0])"
                        :disabled="appendDisab"
                    >  {{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length > 1" :disabled="appendDisab">
                      {{ item.arr[0].name }}
                      <a-menu slot="overlay" >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="appendCarton(item)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>


                  <div v-if="item.code == 'ImportScanningFile' && importScanningFileDisab" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        @click="importScanningFile()"
                    >  {{ item.arr[0].name }}</a-button>
                  </div>

                  <!--  SSCC  -->
                  <div v-if="item.code == 'PrintSSCC'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        :disabled="cartonSearchVal == '' ? true : false "
                        @click="printByBtnConfig(item.arr[0])"
                    >{{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length > 1" :disabled="cartonSearchVal == '' ? true : false " >
                      {{ item.arr[0].name }}
                      <a-menu slot="overlay" >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>


                  <!--  Carton  -->
                  <div v-if="item.code == 'PrintCarton'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        :disabled="cartonSearchVal == '' ? true : false "
                        @click="printByBtnConfig(item.arr[0])"
                    > {{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length > 1"  :disabled="cartonSearchVal == '' ? true : false " >
                      {{ item.arr[0].name }}
                      <a-menu slot="overlay" >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>


                  <!--  Detail-Print  -->
                  <div v-if="item.code == 'D-Print'" style="margin-left: 4px;">
                    <a-button
                        v-if="item.arr.length == 1"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        :disabled="cartonSearchVal == '' ? true : false "
                        @click="printByBtnConfig(item.arr[0])"
                    > {{ item.arr[0].name }}</a-button>
                    <a-dropdown-button v-else-if="item.arr.length > 1"  :disabled="cartonSearchVal == '' ? true : false " >
                      {{ fieldMap.tlPrint.displayName }}
                      <a-menu slot="overlay" >
                        <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                      </a-menu>
                    </a-dropdown-button>
                  </div>



                  <!--  Other  -->
                  <div v-if="item.code == 'Other'" style="margin-left: 4px;">

                    <!-- v-if="item.arr.length == 1" -->

                    <a-button
                        v-for="tt in item.arr"
                        :key="tt.uid"
                        style="margin-left: 4px;"
                        size="small"
                        type="primary"
                        @click="printByBtnConfig(tt)"
                    >{{ tt.name }}</a-button>



                    <!-- <a-dropdown-button v-else-if="item.arr.length > 1" :disabled="cartonSearchVal == '' ? true : false " >
                                          {{ $t('pubGicSet.PrintSSCC') }}
                                          <a-menu slot="overlay" >
                                            <a-menu-item v-for="(tt,index) in item.arr" :key="index" @click="printByBtnConfig(tt)">{{tt.name}}</a-menu-item>
                                          </a-menu>
                                        </a-dropdown-button> -->
                  </div>







                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24" style="border-right: 1px solid #efefef;">
                  <a-row
                      type="flex"
                      justify="space-between"
                      style="margin: 10px 0 0 0;">
                    <a-col>
                      <div class="scanpackHeader">
                        <div class="scanpackTitle" style="width: 210px"> {{ fieldMap.scSscc.displayName }}:</div>
                        <a-input
                            :disabled="cartonNoDis"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            v-model="cartonSearchVal"
                            @pressEnter="cartonSearchEnter"
                            ref="cartonNorefs"/>
                      </div>
                    </a-col>
                  </a-row>
                  <transition name="slide-fade">
                    <a-row>
                      <a-row type="flex" justify="start" style="margin: 10px 0">
                        <a-col style="margin-left: 100px;">
                          <p class="scanCodeTile">{{ fieldMap.pcPackedQty.displayName }}</p>
                          <div style="color: black;font-size: 70px;font-weight: bold;">
                            <p>{{ carTonQty }}</p>
                          </div>
                        </a-col>
                        <a-col style="margin-left: 100px;">
                          <p class="scanCodeTile">{{ fieldMap.pcNoOfSku.displayName }}</p>
                          <div style="color: black;font-size: 70px;font-weight: bold;">
                            <p>{{ carTonOfSku }}</p>
                          </div>
                        </a-col>
                      </a-row>
                      <a-row style="margin-right: 10px;">
                        <vxe-table
                            border
                            resizable
                            :data.sync="cartonTable"
                            size="mini"
                            max-height="330"
                            class="mytable-style "
                            :cell-class-name="cartonTableClass"
                        >
                          <template v-slot:empty>
                            <span style="font-size: 12px; color: red;"> </span>
                          </template>
                          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                          <vxe-table-column
                              width="300"
                              show-header-overflow="ellipsis" show-overflow="ellipsis"
                              field="sku"
                              :title="fieldMap.tbPcSku.displayName "
                          >
                          </vxe-table-column>
                          <vxe-table-column
                              width="100"
                              show-header-overflow="ellipsis" show-overflow="ellipsis"
                              field="uom"
                              :title="fieldMap.tbPcUom.displayName ">
                          </vxe-table-column>
                          <vxe-table-column
                              show-header-overflow="ellipsis" show-overflow="ellipsis"
                              field="descr"
                              :title="fieldMap.tbPcDescr.displayName "
                          ></vxe-table-column>
                          <vxe-table-column
                              show-header-overflow="ellipsis" show-overflow="ellipsis"
                              field="scannedQty"
                              :title="fieldMap.tbPcScannedQty.displayName "
                          ></vxe-table-column>
                        </vxe-table>
                      </a-row>
                    </a-row>
                  </transition>

                  <a-row v-if="instructionDisplay">
                    <div v-html="instructionDisplay" :style="instructionDisplayStyle"></div>
                  </a-row>
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </a-col>
      </a-row>

    </a-drawer>
    <a-modal
        :title="$t('pubGicSet.Error')"
        v-model="SkuExistVis"
        width="40%"
        @cancel="handleCancelSkuTishi"
        :maskClosable="false"
        :footer="null"
    >
      <audio
          controls="controls"
          autoplay="autoplay"
          loop="loop"
          id="ScanpackmusicSKU"
          hidden
      >
        <source src="../../../assets/mm.mp3" type="audio/mpeg" />
      </audio>

      <a-alert type="error">
        <p
            slot="description"
            style="color: red;font-size: 30px;padding: 50px 0;text-align: center;line-height: 30px;"
        >
          {{errMsg}}
        </p>
      </a-alert>
    </a-modal>


    <audio
        controls="controls"
        ref="scanSuccessMusicRef"
        hidden>
      <source src="../../../assets/scan_success.mp3" type="audio/mpeg" />
    </audio>


    <!-- <a-modal title="New Carton" v-model="addCortonVisible" width="50%" :maskClosable="false">
          <template slot="footer">
            <a-button type="primary" @click="addNewCarton">{{ $t('publicLang.Save') }}</a-button>
          </template>
          <a-form :form="addform">
            <a-row :gutter="24" style="margin-right: 10px">
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.CartonType')">
                    <a-select
                        size="small"
                        style="width: 100%"
                        :placeholder="$t('publicLang.PleaseSelect')"
                        v-decorator="['cartonType']"
                        @change="cartonTypeChange"
                    >
                      <a-select-option v-for="item in cartonTypeSelectData" :value="item">{{item}}</a-select-option>
                    </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item  class="genericFrom" :label="$t('pubGicSet.Length')">
                    <a-input-number
                        size="small"
                        :min="1"
                        v-decorator="['length',{ initialValue: newCartonJson.length }]"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        style="width:100%"
                    />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.Width')">
                    <a-input-number
                        size="small"
                        :min="1"
                        v-decorator="['width',{ initialValue: newCartonJson.width }]"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        style="width:100%"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.Height')">
                    <a-input-number
                          size="small"
                          :min="1"
                          v-decorator="['height',{ initialValue: newCartonJson.width }]"
                          :placeholder="$t('publicLang.PleaseEnter')"
                          style="width:100%"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.CBM')">
                    <a-input-number
                          size="small"
                          :min="1"mess
                          v-decorator="['cbm',{ initialValue: newCartonJson.cbm }]"
                          :placeholder="$t('publicLang.PleaseEnter')"
                          style="width:100%"
                    />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.DimUOM')">
                    <a-input
                        v-decorator="['dimensionUom',{ initialValue: newCartonJson.dimensionUom }]"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        style="width:100%"/>
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.Weight')">
                    <a-input-number
                            size="small"
                            :min="1"
                            v-decorator="['grossWeight']"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            style="width:100%"
                    />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" :label="$t('pubGicSet.WeightUOM')">
                    <a-input
                        v-decorator="['weightUom',{ initialValue: newCartonJson.weightUom }]"
                        :placeholder="$t('publicLang.PleaseEnter')"
                        size="small"
                        style="width:100%"
                    />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item class="genericFrom" label="Tracking No">
                    <a-input
                            v-decorator="['logisticsid',{ initialValue: newCartonJson.logisticsid }]"
                            :placeholder="$t('publicLang.PleaseEnter')"
                            size="small"
                            style="width:100%"
                    />
                </a-form-item>
              </a-col>
            </a-row>
          </a-form>
        </a-modal> -->
    <scan-pack-move ref="adjustMove" ></scan-pack-move>
    <delivery-date ref="deliveryDate" v-on:deliverdate="getScanPackStaus"></delivery-date>
    <import-scanning-file ref="importScanningFile" v-on:cancelImport="GETcancelImport"></import-scanning-file>
    <amr-continers-data ref="amrContinersData"></amr-continers-data>
    <scan-cus-sku-window ref="refScanCusSkuWindow" v-on:confirmCusSku="confirmCusSkuCallBack"></scan-cus-sku-window>
    <select-sku ref="selectSku" @selectSku="selectSku"></select-sku>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
import axios from "axios";
import cookie from "../../../api/cookie"
import { mapState } from "vuex";
import scanPackMove from './scanPackMove.vue'
import webSocketPrint from "./webSocketPrint";
import deliveryDate from './deliverydate.vue'
import amrContinersData from './amrContainersData.vue'
import { countBy } from 'xe-utils/methods';
import importScanningFile from "./importScanningFile.vue";
import scanCusSkuWindow from "./scanCusSkuWindow.vue";
import { installPrintService } from "../../../plugins/scpPrint";
import XEClipboard from 'xe-clipboard';
import selectSku from "./selectSku";

export default {
  components: {
    scanPackMove,
    deliveryDate,
    importScanningFile,
    amrContinersData,
    scanCusSkuWindow,
    selectSku
  },
  data() {
    return {
      gridOptions:{
        //列配置 (使用列拖拽功能,必须配置useKey为true)
        "column-config":{resizable:true},
        //边框
        border:"full",
        //斑马纹
        stripe:true,
        //列信息
        //这里一定要指定true，否则row-config的height没用
        'show-overflow':true,
        //行配置,这里的行高一定需要指定
        "row-config":{isCurrent:true,height:30,isHover:true},
      },
      instructionDisplay:null,
      instructionDisplayStyle: {
        textAlign: 'left',
        fontSize: '40px',
        color: 'black',
        backgroundColor: 'rgb(232, 232, 232)'
      },
      skuabled: false, // sku输入框是否可输入
      cartonNoDis: false, // sscc 是否可输入
      btnFunArr: [
        {code: 'CheckComplete',arr:[]},
        {code: 'CancelCheckComplete',arr:[]},
        {code: 'Confirm',arr:[]},
        {code: 'SendEDI',arr:[]},
        {code: 'Re-print',arr:[]},
        {code: 'CourierEDI',arr:[]},
        {code: 'Print',arr:[]},
        {code: 'CourierEDI-BTN',arr:[]},
        {code: 'Close',arr:[]},
        {code: 'Append',arr:[]},
        {code: 'Remove',arr:[]},
        {code: 'ImportScanningFile', arr:[]},
        {code: 'PrintCarton',arr:[]},
        {code: 'PrintSSCC',arr:[]},
        {code: 'D-Print',arr:[]},
        {code: 'C-LockScanQty',arr:[]},
        {code: 'C-RemoveScanItem',arr:[]},
        {code: 'C-IsCarton',arr:[]},
        {code: 'C-IsPre-Pack',arr:[]},
        {code: 'Other',arr:[]},
        {code: 'CloseOrder',arr:[]},
        {code: 'Export',arr:[]}
      ],

      headerBtn: [],
      detailBtn: [],
      scanFieldTitle: '',
//        scanpack table 详情
      scanpackDetailTable: [],
      scanpackTabsTarget: '2',
      scanpackDetailAllocatedQty: 0,
      scanpackDetailPackedQty: 0,
      scanpackDetailPercentage: 0,
      scanpackDetailNocarton: 0,
//        按钮
      closeAndNewDisab: true,
      newDisab: false,
      closeDisab: true,
      removeDisab: true,
      appendDisab: true,
      importScanningFileDisab: false,
//        按钮

      errMsg: "Please new one carton first",
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      cartonSearchVal: "",
      SkuExistVis: false,
      addCortonVisible: false, // New 弹窗
      editForm: this.$form.createForm(this),
      addform: this.$form.createForm(this),
      form: this.$form.createForm(this),
      visible: false,
      partTable: [], // 父表数据
      upcTable: [], // upc
      tbSkuList:[],
      cartonTable: [],
      newEditCartData: {},
      editSpin: false, // 编辑加载提示
      selectRow: "", // 父表当前选中行用来样式
      carTonQty: 0, //  carton 显示的number
      carTonOfSku: 0, //  carton 显示的number

//      sku 扫码后换算后的值
      skuPackedQty: 0, // sku 显示num
      skuUnpackQty: 0, // sku 显示num
      Percentage: 0, // sku 显示num

      skuScanUpc: "", // 扫码需要输入的值
      DUDF_02:"",
      cartonTableSKU:'',//cartonTablesku，和扫码对比用
      OtySaoNum: 1, // oty 所需要操作数量
      lockChecked: true,
      DeleteChecked: false,
      SkuTableOther: {},
      newType: "",
      soheaderSearchVal: "", // so search input value
      tableRelId: '',
      cartonTypeSelectData: [],
      newCartonJson: {},
      scanpackSearchType: '', // so 还是ware 进来
      WareheaderSearchVal: '',
      PrintSsccVal: '',
      scanPackDtoList:[],// 记录扫货次数
      cartonTableXt: [],
      waveUid: null,
      soUid: null,
      trackingNoMap: {},
      trackingNoEdit: false,
      waveType: '',
      UDF: {},
      skuLabel:this.$t('pubGicSet.SKU'),
      isCartonChecked: false,
      isPrePackChecked: false,
      isTraceIdChecked: false,
      cancelCheckCompleteVisible : false,
      cancelCheckCompleteMoveVisibel :  false,
      cancelPartCheckCompleteVisibel: false,
      showCompleteTips:false,
      cancelPickConfirmVisible:false,
      cancelPickConfirmLoading:false,
      cancelPickConfirmList:[],
      pendingCheckCompleteItem:null,
      pendingCheckCompletePartialPack:false,
      componentSku1: '',
      components: [],    // 已扫描的Component 配件
      scanComponents: [],  // 未扫描的Component 配件
      scanComponentsFlag: false, // 显示扫描配件标志
      checkboxList:[],
      ip:'',
      printers:[],
      platfromVal: null,
      amrContainerValue:null,
      amrFlow:false,
      checkCompleteDisable: false,
      cancelCheckCompleteDisable: true,
      confirmDisable: true,
      closeDisable: true,
      ssccSearchVal: "",
      epcScanVal:'',
      formItemLayout: {
        labelCol: {
          xs: { span: 5 },
          sm: { span: 3 }
        },
        wrapperCol: {
          xs: { span: 5 },
          sm: { span: 3 }
        }
      },
      showCartonSave:true,
      cancelCheckCompleteRequestDisable: false,
      giftChecked: false,
      epcValDisabled:false,
      epcVisible:false,
      isHiddenTable: false,
      isSwitchDisabled: false,
      mbshaScanInEpcCheck: false,
      currentBrand: "",
      isSelecting: false, // 是否正在进行选择操作
      selectionStart:{rowIndex:-1,cellIndex:-1}, // 选择操作起始单元格位置
      selectionEnd:{rowIndex:-1,cellIndex:-1}, // 选择操作结束单元格位置
      closeCartonRelIdArr:[],
      HUDF01: '',
      printHeight: window.innerHeight / 4 * 3,
      fieldMap:{
        tlScanPack: {},
        tlRelId: {},
        tlWaveId: {},
        tlContainerNo: {},
        tlAmrContainerNo: {},
        tlIwmsContainerNo: {},
        tlHiddenTable: {},
        tlCourierEdi: {},
        tlPrint: {},
        tbRelId: {},
        tbSku: {},
        tbUpc: {},
        tbDescr: {},
        tbAllocateQty: {},
        tbPackedQty: {},
        tbOutstandingQty: {},
        tbSscc: {},
        tbStatus: {},
        scSku: {},
        scEpc: {},
        scGift: {},
        scQty: {},
        scLockScanQty: {},
        scRemoveScanItem: {},
        scCartonId: {},
        scIsCarton: {},
        scIsPrePack: {},
        scIsTraceId: {},
        scPackedQty: {},
        scUnpackQty: {},
        scSscc: {},
        pcPackedQty: {},
        pcNoOfSku: {},
        tbPcSku: {},
        tbPcUom: {},
        tbPcDescr: {},
        tbPcScannedQty: {},
        pdAllocatedQty: {},
        pdPackedQty: {},
        pdPercentage: {},
        pdNoOfCarton: {},
        tbPcCartonNo: {},
        tbPcPackedQty: {},
        tbPcCreatedBy: {},
        pcCartonNo: {},
        pcCartonType: {},
        pcTrackingNo: {},
        pcLength: {},
        pcWidth: {},
        pcHeight: {},
        pcDimUom: {},
        pcCbm: {},
        pcWeight: {},
        pcWeightUom: {},
        pcUserdefined1: {},
        pcUserdefined2: {},
        pcUserdefined3: {},
        pcUserdefined4: {},
        pcUserdefined5: {}
      }
    }
  },
  computed: {
    ...mapState(["systemParam"]),
    ...mapState(["SF_SCPPrint"]),
    ...mapState(["projectCode"]),
  },


  watch:{
    SkuExistVis(val){
      if(!val){
        let audio = document.getElementById("ScanpackmusicSKU");
        audio.pause();
      }
    },
    mbshaScanInEpcCheck(val) {
      if(val == true) {
        this.epcValDisabled = true;
      } else {
        this.epcValDisabled = false;
      }
    }
  },
  methods: {
    exportSkuTable(){
      if (this.systemParam.scanpack_way == 'Y' && this.scanPackDtoList.length > 0) {
        return;
      }
      let params = {
        waveUid: this.waveUid == undefined ? '' : this.waveUid,
        waveId: this.WareheaderSearchVal == undefined ? '' : this.WareheaderSearchVal,
        relId: this.soheaderSearchVal == undefined ? '' : this.soheaderSearchVal,
        soUid: this.soUid == undefined ? '' : this.soUid
      };
      const exportData = () => {
        this.$nextTick(() => {
          const table = this.$refs.skuTable;
          if (table) {
            const columns = table.getColumns ? table.getColumns() : (table.visibleColumn || []);
            const originalWidths = columns.map(column => column.renderWidth);
            const exportColumnWidth = 150;
            columns.forEach(column => {
              column.renderWidth = exportColumnWidth;
            });
            try {
              table.exportData({
                filename: 'Scan Pack',
                type: 'xlsx',
                isHeader: true,
                isFooter: false,
                columnFilterMethod: ({ column }) => {
                  return ['checkbox', 'selection', 'radio'].indexOf(column.type) === -1;
                }
              });
            } finally {
              columns.forEach((column, index) => {
                column.renderWidth = originalWidths[index];
              });
            }
          }
        });
      };
      const hasParams = Object.keys(params).some(key => {
        const value = params[key];
        return value !== null && value !== undefined && String(value).trim() !== '';
      });
      if (!hasParams) {
        exportData();
        return;
      }
      ajax.get(api.SCANTABLE, params).then(res => {
        if (res.code == 200) {
          this.partTable = res.data.pickTableData || [];
          this.tableRelId = res.data.relId;
          if (this.WareheaderSearchVal == '' || this.WareheaderSearchVal == undefined) {
            this.soheaderSearchVal = res.data.relId;
          }
          exportData();
        } else {
          this.$customMessage.error(res.msg);
        }
      });
    },
    selectSku(sku){
      this.skuScanUpc = sku;
      this.SkuEnterEvt("QtyEnter");
    },
    getPrinters(){
      return new Promise((resolve, reject) => {
        let that = this;
        if ("WebSocket" in window)
        {
          // Create websocket
          var ws = new WebSocket("ws://localhost:9999/print");
          ws.onopen = function()
          {
            ws.send("{'Type':'SERVER_INFO'}");
          };
          ws.onmessage = function (evt)
          {
            var msg = evt.data;
            try {
              that.printers = JSON.parse(msg).printerServer.printers;
              resolve(that.printers); // 获取到数据后 resolve
              ws.close();
            } catch (e) {
            }
          };
          ws.onerror = (err) => {
            reject(new Error("WebSocket Error:" + err.message));
          };
          ws.onclose = function()
          {

          };
        }
        else
        {
          reject(new Error("WebSocket not supported"));
        }
      });
    },
    getExpressNumber(btnConfig){

      if (this.soheaderSearchVal == null || this.soheaderSearchVal.trim() == ''){
        that.$customMessage.warning(res.msg, 3);
        return;
      };

      let params = {
        params: [{"key":"relId","value":this.soheaderSearchVal}],
      };


      ajax.post(btnConfig.externalApi, params).then(res => {
        if (res.code == 200) {
          this.trackingNoMap[this.soheaderSearchVal] = res.trackingNoMap == null ? null :  res.trackingNoMap[this.soheaderSearchVal]
          if(this.newEditCartData  != undefined && this.newEditCartData != null && this.newEditCartData  !='') {
            this.newEditCartData.logisticsid = res.trackingNoMap[this.soheaderSearchVal];
            this.editForm.logisticsid = res.trackingNoMap[this.soheaderSearchVal];
          }
          this.$message.success(res.msg, 3);
        } else {
          this.$customMessage.warning(res.msg, 3);
        }
      });
    },
    handleSwitchChange(checked){
      if (!checked) {
        this.addListener();
        this.init("SKUSCAN")
      }
    },
    ssccSearch(){

      this.WareheaderSearchVal =''
      this.soheaderSearchVal = ''
      // so 根据so状态显示
      let params = {};
      let that = this;
      params.sscc = this.ssccSearchVal
      params.relId = ''
      params.waveId = ''
      this.isHiddenTable= false;
      this.isSwitchDisabled = false;

      ajax.get(api.CARTONINFO,params).then(res=>{
        if(res.code == 200){
          if(1==1){
            let returnData = res.data;

            if(returnData==null&&this.ssccSearchVal!=null&&this.ssccSearchVal!=""){
              this.soheaderSearchVal="";
              this.partTable = [];
              this.$refs.containerNo.select();
              this.$refs.containerNo.focus();
              this.$customMessage.warning(this.$t('publicLang.NoPickedStockInContainer'), 3);
              return;
            }
            let amrOrderNo = returnData && returnData.orderNo ? returnData.orderNo : '';
            let totalContainer = returnData && returnData.totalContainer ? returnData.totalContainer : '';
            let message = returnData && returnData.message ? returnData.message : '';
            let tt = {
              totalContainer: totalContainer,
              message: message
            }


            if(null!=amrOrderNo && ''!=amrOrderNo && null!=message && ''!=message) {
              //AMR has been completed picking
              this.soheaderSearchVal=amrOrderNo;
              this.amrContainerValue = this.ssccSearchVal
              this.ssccSearchVal = '';
              this.$refs.amrContinersData.show(tt);
              this.soHeaderSearch();
            }else if((amrOrderNo==null || amrOrderNo=='') && ( null!=message && ''!=message)){
              //AMR has not finish picking
              this.$alert(message,
                  {showClose:false,
                    confirmButtonText:this.$t('publicLang.Confirm')
                  }
              );
              return;
            } else if((null!=amrOrderNo && ''!=amrOrderNo) && (message == undefined|| null==message || ''==message)){
              // 只返回order no，不返回message
              this.soheaderSearchVal=amrOrderNo;
              if(this.systemParam.DP_FLOW=='Y'&&(this.systemParam.SYS_DP_PICK_FLOW=='Y')){
                // so 根据so状态显示
                let params = {};
                let that = this;
                params.relId = this.soheaderSearchVal
                ajax.post(api.SCANPACKGETSCANPACKSTAUS,params).then(res=>{
                  if(res.code == 200){
                    this.cancelCheckCompleteDisable=res.cancelCheckCompleteDisable;
                    this.confirmDisable=res.confirmDisable;
                    this.closeDisable=res.closeDisable;
                    this.importScanningFileDisable = res.importScanningFileDisable;
                    if(this.cancelCheckCompleteDisable){
                      this.init();
                      this.checkPartialPack(this.btnFunArr[0].arr[0]);
                    }else{
                      this.soheaderSearchVal="";
                      this.partTable = [];
                      this.$refs.containerNo.select();
                      this.$refs.containerNo.focus();
                      this.$customMessage.warning(this.$t('publicLang.NoPickedStockInContainer'), 3)
                    }
                  }else{
                    that.$customMessage.warning(res.msg);
                  }
                })
              }else{
                this.soHeaderSearch();
              }
              return;
            } else{
              if(this.systemParam.DP_FLOW=='Y'&&this.ssccSearchVal!=null&&this.ssccSearchVal!=""){
                this.soheaderSearchVal=amrOrderNo;
                this.soHeaderSearch();
              }else{
                this.partTable = null

                this.$nextTick(()=>{
                  this.$refs.containerNo.select()
                })
                return;
              }
            }
          }else{//已弃用
            this.partTable = res.data;
            this.cartonSearchVal = this.ssccSearchVal

            if(this.partTable.length > 0){
              this.scanFieldTitle = this.partTable[0].scanField
              this.tableRelId = this.partTable[0].relId
              let skuUnpackQtyNum = 0

              for (let tt in this.partTable) {
                skuUnpackQtyNum = this.partTable[tt].unscannQty + skuUnpackQtyNum
                this.skuUnpackQty = skuUnpackQtyNum
                // this.scanpackDetailAllocatedQty
              }

              if(this.selectRow.sku){
                let index = this.selectRow.sku.lastIndexOf("-")
                let componentSku = this.selectRow.sku.substring(0,index);
                let skuPackedQtyNum = 0
                let pickedQtyNum = 0
                let  matchSku = false
                for (let t in this.partTable){
                  if(this.partTable[t].sku == this.selectRow.sku){ // 已经匹配上Sku
                    matchSku =true;
                    skuPackedQtyNum = skuPackedQtyNum + this.partTable[t].packedQty
                    pickedQtyNum = pickedQtyNum + this.partTable[t].pickedQty
                  }
                }

                if(! matchSku){  // 否则
                  for (let t in this.partTable){
                    if(this.partTable[t].sku == componentSku){
                      skuPackedQtyNum = skuPackedQtyNum + this.partTable[t].packedQty
                      pickedQtyNum = pickedQtyNum + this.partTable[t].pickedQty
                    }
                  }
                }

                if(!this.isCartonChecked && !this.isPrePackChecked && !this.isTraceIdChecked){
                  this.skuPackedQty = skuPackedQtyNum
                  this.Percentage = Math.round((skuPackedQtyNum / pickedQtyNum) * 10000) / 100.0 + "%";
                }
              }

              if(this.isCartonChecked || this.isPrePackChecked || this.isTraceIdChecked){
                this.$nextTick(()=>{
                  if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
                    this.epcScanVal='';
                    this.$refs.epcScanRef.focus();
                  }else{
                    this.$refs.skuScanUpcRef.focus()
                  }
                })
              }
            }
          }

        }else{
          that.$customMessage.warning(res.msg);
        }
      })

      //pack scan carton
      this.pack_scan_carton(params);

    },
    pack_scan_carton(params){
      ajax.get(api.SEARCHSCANCARTON, params).then(res => {
        this.scanPackDtoList = []
        this.skuabled = false
        if (res.code == 200) {

          if(this.isTraceIdChecked){
            // focus on sku input
            this.$nextTick(()=>{
              this.$refs.skuScanUpcRef.select();
              this.$refs.skuScanUpcRef.focus();
            })
          }
          // Tom 2024-08-22 空值页面卡死修复
          if(res.data==null || res.data=='') {
            return;
          }

          // this.init()
          this.newEditCartData = res.data.carton;
          this.cartonTable = res.data.table;
          this.cartonTableXt= res.data.table;

          if( (this.soheaderSearchVal=="" || this.soheaderSearchVal == undefined ||  this.soheaderSearchVal == null) && (this.WareheaderSearchVal == '' || this.WareheaderSearchVal == undefined ||  this.WareheaderSearchVal == null )  ){
            if(res.data.waveId != null && res.data.waveId != ''){
              this.WareheaderSearchVal = res.data.waveId
            }else{
              this.soheaderSearchVal = res.data.relId
            }
          }
          // this.cartonTableXt =JSON.parse(JSON.stringify(res.data.table));
          if( this.newEditCartData.status == 'ST_CLO'){
            this.appendDisab =false
            this.closeDisab = true
          }else if(this.newEditCartData.status =='ST_APP'){
            this.appendDisab =true
            this.closeDisab = false
          }else{
            this.newDisab = false
            this.closeDisab = false
            this.removeDisab = false
            this.appendDisab = false
            this.closeAndNewDisab = false
          }
          this.carTonOfSku = this.cartonTable.length;
          let sum = 0;
          for (let i in this.cartonTable) {
            sum = sum + this.cartonTable[i].scannedQty;
          }
          this.carTonQty = sum;
          this.editForm.resetFields()
          if(this.systemParam.scanpack_way == 'Y' && res.data.table.length > 0){
            this.showCartonSave = true;
          }
        }
      });
    },
    getScanPackStaus(){
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        this.cancelCheckCompleteDisable=false;
        this.confirmDisable=false;
        this.closeDisable=false;
      }else{
        // so 根据so状态显示
        let params = {};
        let that = this;
        params.relId = this.soheaderSearchVal
        ajax.post(api.SCANPACKGETSCANPACKSTAUS,params).then(res=>{
          if(res.code == 200){
            this.cancelCheckCompleteDisable=res.cancelCheckCompleteDisable;
            this.confirmDisable=res.confirmDisable;
            this.closeDisable=res.closeDisable;
          }else{
            that.$customMessage.warning(res.msg);
          }
        })
      }
    },
    GETcancelImport(val) {
      this.importVisible = false;
      // this.getTemplateName()
      if (val == "init") {
        this.init();
      }
    },
    getAllUpc() {
      // Tom 2023-04-21 将init部分抽出 只加载一次
      let params = {}
      params.waveUid =  this.waveUid == undefined ? '': this.waveUid
      params.waveId = this.WareheaderSearchVal == undefined ? '': this.WareheaderSearchVal
      params.relId =  this.soheaderSearchVal == undefined ? '': this.soheaderSearchVal
      params.soUid =  this.soUid == undefined ? '': this.soUid
      if( params.relId == '' &&  params.soUid == '' && params.waveUid == '' &&  params.waveId == '' ){
        this.partTable = [];
        return;
      }
      ajax.get(api.GETALLUPC, params).then(res => {
        if (res.code == 200) {
          this.upcTable = res.data.upcTable;
          this.tbSkuList = res.data.tbSkuList;
        }
      });
    },
    closeCancelCheckCompleteMoveVisibel(){
      // console.info(this.systemParam)

      this.cancelCheckCompleteMoveVisibel = false;
    },
    closeCancelPartCheckCompleteVisibel(){
      this.cancelPartCheckCompleteVisibel = false;
    },
    closeCancelCheckCompleteVisible(){
      this.cancelCheckCompleteVisible = false;
    },
    handleCancel(){
      this.cancelCheckComplete('N');
    },
    handleOk(){
      this.cancelCheckCompleteVisible = false ; // 原来的弹框关闭

      this.cancelCheckCompleteMoveVisibel =  true ; // 新的弹框显示 提示是否生成移库单

    },

    handleCancelNoCreateMove(){   // 不生成移库单
      this.cancelCheckComplete('Y-N');
    },
    handleOkCreateMove(){     // 生成移库单
      this.cancelCheckComplete('Y-Y');
    },
    cancelCheckComplete(handleType){
      // 调用AfterShip Cancel Label
      //this.printAfterShipCancelLabel('Cancel Check Complete');
      this.cancelCheckCompleteRequestDisable = true;
      let params = {}
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      params.handleType = handleType;
      let that = this;
      // Tom 20240906 REMOVE_PICK_DATA_DIALOG 为Y 弹出提示
      if(this.systemParam.REMOVE_PICK_DATA_DIALOG == 'Y') {
        this.$customConfirm({
          title: that.$t('scanPack.deletePickingData'),
          okText: that.$t('scanPack.cancelCheckCompleteYes'),
          cancelText: that.$t('scanPack.cancelCheckCompleteNo'),
          onOk() {
            params.deletePickAmr = 'Y';
            that.postCancelCheckComplete(params,handleType);
          },
          onCancel() {
            that.postCancelCheckComplete(params,handleType);
          }
        })
      } else {
        this.postCancelCheckComplete(params,handleType);
      }

    },
    // 取消部分check Complete
    cancelPartCheckComplete(){
      let params = {}
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      params.handleType = 'N';
      ajax.post(api.CANCELCHECKCOMPLETE,params).then(res=>{
        if(res.code == 200){
          if (res.warning != null&&res.warning != "") {
            this.$customMessage.warning(res.warning);
            return;
          }
          this.cancelPartCheckCompleteVisibel = false;
          this.$message.success(res.msg);
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },

    postCancelCheckComplete(params,handleType) {
      ajax.post(api.CANCELCHECKCOMPLETE,params).then(res=>{
        this.cancelCheckCompleteRequestDisable = false;
        this.cancelPartCheckCompleteVisibel = false;
        if(res.code == 200){
          if (res.warning != null&&res.warning != "") {
            this.$customMessage.warning(res.warning);
          }
          if("N" == handleType){
            this.cancelCheckCompleteVisible = false
            this.$message.success(res.msg);
          }else {
            this.cancelCheckCompleteMoveVisibel = false
            if("Y-N" == handleType){
              this.$message.success(res.msg);
            }else{
              let uid =  res.data
              this.$refs.adjustMove.show2(uid,true)
            }

          }
          this.init();
          // 重新查询箱子信息
          if(this.cartonSearchVal!=undefined &&this.cartonSearchVal!=null&& this.cartonSearchVal!='') {
            this.cartonSearchEnter();
          }
        }else{
          this.$customMessage.warning(res.msg);
          this.cancelCheckCompleteMoveVisibel = false
          this.cancelCheckCompleteVisible = false

        }
      })
    },
    printPDFByBtnConfig(btnConfig){
      let btnName = btnConfig.name;
      if(btnName == 'Intersoft Generate Label'){
        this.GenerateLabel('pack_list');
      }else if(btnName == 'Intersoft Cancel Label'){
        this.IntersoftCancelLabel('pack_list')
      }else if(btnName == 'Intersoft Generate Mainfest'){
        this.IntersoftGenerateMainfest('pack_list')
      }else if(btnName == 'AfterShip Generate Label') {
        this.printAfterShipGenerateLabel('Courier Edi')
      }else if(btnName == 'AfterShip Cancel Label') {
        this.printAfterShipCancelLabel('Courier Edi');
      }else if(btnName == 'AfterShip Generate Manifest') {
        this.$customMessage.error('System error');
      }

      let ajaxurl = ajax.ajaxUrl();
      let paramsData = [];
      // 填充信息
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        let paramsObj = {};
        paramsObj.key = "waveId";
        paramsObj.value = this.WareheaderSearchVal;
        paramsData.push(paramsObj);
      }else{
        let paramsObj = {};
        paramsObj.key = "relId"
        paramsObj.value =  this.soheaderSearchVal;
        paramsData.push(paramsObj);
      }
      let params = {
        gmcUid: btnConfig.gmcUid,
                                uid: '',
                                btnName: btnConfig.name,
                                btnUid: btnConfig.uid,
                                extValType: btnConfig.extValType,
                                params: paramsData
                            }
      if(btnConfig.externalApi =='/outbound/fedExCreateShipment'
              || btnConfig.externalApi =='/outbound/sfExpressCreateOrder'
              || btnConfig.externalApi =='/outbound/ninjavanCreateShipment'
              || btnConfig.externalApi =='/outbound/upsCreateShipment'
              || btnConfig.externalApi =='/outbound/courierEDI/dhlCreateShipment'
              || btnConfig.externalApi =='/outbound/courierEDI/dhlReturnCreateShipment'
              || btnConfig.externalApi =='/outbound/globavendCreateOrder') {
        let that = this;
        ajax.post(btnConfig.externalApi,params).then(res=>{
          if(res.code == 200){
            that.$message.success(res.msg,3);
            let data = res.data;
            if(data){
              let list = data.split(",");
              for(let url of list){
                that.previewHttpFile(url);
              }
            }
          }else{
            that.$customMessage.warning(res.msg);
          }
        })
      }else if(btnConfig.externalApi =='/outbound/fedExCancelShipment'
              || btnConfig.externalApi =='/outbound/sfExpressCancelOrder'
              || btnConfig.externalApi =='/outbound/ninjavanCancelShipment'
              || btnConfig.externalApi =='/outbound/upsCancelShipment'
              || btnConfig.externalApi =='/outbound/globavendCancelOrder') {
        let that = this;
        ajax.post(btnConfig.externalApi,params).then(res=>{
          if(res.code == 200){
            that.$message.success(res.msg,3);
          }else{
            that.$customMessage.warning(res.msg);
          }
        })
      }
    },
    printByBtnConfig(btnConfig){   // 根据用户配置打印
      console.log("print---start"+btnConfig);
      if((btnConfig.externalApi == null || btnConfig.externalApi == "") && this.WareheaderSearchVal == "" && this.soheaderSearchVal == ""){
        this.$customMessage.error("Rel Id,Wave Id " + this.$t('job.notNull'));
        return;
      }
      if( btnConfig.code == "BTN_SAVE" || btnConfig.code == "BTN_EXPORT"){
        if( btnConfig.code == "BTN_SAVE"){
          let ajaxurl = ajax.ajaxUrl();
          this.isBtnajax = true;
          let that = this
          let paramsData = [];
          // 填充信息
          if(this.scanpackSearchType == 'WAVE_HEADER'){
            // console.log(this.WareheaderSearchVal)
            let paramsObj = {};
            paramsObj.key = "waveId";
            paramsObj.value = this.WareheaderSearchVal;
            paramsData.push(paramsObj);
          }else{
            // console.log(this.soheaderSearchVal)
            let paramsObj = {};
            paramsObj.key = "relId"
            paramsObj.value =  this.soheaderSearchVal;
            paramsData.push(paramsObj);
          }
          if (this.cartonSearchVal != undefined) {
            let paramsObj = {};
            paramsObj.key = "sscc";
            paramsObj.value = this.cartonSearchVal;
            paramsData.push(paramsObj);
          }
          let params = {
            gmcUid: btnConfig.gmcUid,
            uid: '',
            btnName: btnConfig.name,
            btnUid: btnConfig.uid,
            params: paramsData
          }
          if( btnConfig.externalApi == '/cfs/so/printLabelUrl'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                let urlStr = data.data.data;
                this.soUrl = urlStr.split(",")
                // this.shipmentUrl = data.msg
                if (this.soUrl == null || this.soUrl.length == 0){
                  this.$message.success("No Data",3);
                }
                for(let i = 0 ; i < this.soUrl.length ; i++){
                  window.open(this.soUrl[i]);
                }
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          } else if( btnConfig.externalApi == '/outbound/extender/farfetchPrintDocs'){

            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              console.info(data);
              if (data.data.code == 200){
                let urlStr = data.data.msg;
                this.soUrl = urlStr.split(",")
                // this.shipmentUrl = data.msg
                if (this.soUrl == null || this.soUrl.length == 0){
                  this.$message.success("No Data",3);
                }
                for(let i = 0 ; i < this.soUrl.length ; i++){
                  window.open(this.soUrl[i]);
                }
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          } else if( btnConfig.externalApi == '/outbound/extender/printDhlLabelWPX'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
              if (res.data.code == 200) {
                // URLs
                let urlStr =  res.data.data.urls;
                if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                  let urls = urlStr.split(",");
                  this.previewHttpFiles(urls);
                }
                // error msgs
                let msgs = res.data.msgs;
                if(msgs != null && msgs != undefined && msgs.length > 0) {
                  that.$customMessage.warning(msgs, 5);
                }
              } else {
                that.$customMessage.warning(res.data.msg, 3);
              }
            });

          } else if( btnConfig.externalApi == '/outbound/extender/printDhlCargoReceipt'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
              if (res.data.code == 200) {
                // URLs
                let urlStr =  res.data.data.urls;
                if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                  let urls = urlStr.split(",");
                  this.previewHttpFiles(urls);
                }
                // error msgs
                let msgs = res.data.msgs;
                if(msgs != null && msgs != undefined && msgs.length > 0) {
                  that.$customMessage.warning(msgs, 5);
                }
              } else {
                that.$customMessage.warning(res.data.msg, 3);
              }
            });

          } else if( btnConfig.externalApi == '/outbound/extender/printDhlInvoice'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
              if (res.data.code == 200) {
                // URLs
                let urlStr =  res.data.data.urls;
                if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                  let urls = urlStr.split(",");
                  this.previewHttpFiles(urls);
                }
                // error msgs
                let msgs = res.data.msgs;
                if(msgs != null && msgs != undefined && msgs.length > 0) {
                  that.$customMessage.warning(msgs, 5);
                }
              } else {
                that.$customMessage.warning(res.data.msg, 3);
              }
            });

          } else if(btnConfig.externalApi == '/outbound/extender/printDhlShipmentLabel'
               || btnConfig.externalApi == '/outbound/extender/printDhlShipmentInvoice'
               || btnConfig.externalApi == '/outbound/extender/printDhlReturnLabel'
               || btnConfig.externalApi == '/outbound/extender/printDhlReturnInvoice') {
            axios.post(ajaxurl + btnConfig.externalApi, params).then(res => {
                if (res.data.code == 200) {
                    // URLs
                    let urlStr =  res.data.data.urls;
                    if (urlStr != null && urlStr != undefined && urlStr.length > 0) {
                        let urls = urlStr.split(",");
                        this.previewHttpFiles(urls);
                    }
                    // error msgs
                    let msgs = res.data.msgs;
                    if(msgs != null && msgs != undefined && msgs.length > 0) {
                        that.$customMessage.warning(msgs, 5);
                    }
                } else {
                    that.$customMessage.warning(res.data.msg, 3);
                }
            });

          } else if(btnConfig.externalApi =='/outbound/printCainiaoLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
                let printData = data.data.data;
                webSocketPrint.doPrint("13528",printData);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          } else if(btnConfig.externalApi =='/outbound/printJdLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
                let printData = data.data.data;
                webSocketPrint.doPrint("9113",printData);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          }else if(btnConfig.externalApi =='/outbound/printTiktokLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
                let printData = data.data.data;
                webSocketPrint.doPrint("13888",printData);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          }else  if(btnConfig.externalApi =='/outbound/printSFLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                this.printSfLabel(data.data.data,data.data.msg);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          } else if(btnConfig.externalApi =='/outbound/printXhsLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
                let printData = data.data.data;
                webSocketPrint.doPrint("10818",printData);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          } else if(btnConfig.externalApi =='/outbound/printWphLabel'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
                let printData = data.data.data;
                webSocketPrint.doPrint("12233",printData);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          }else if(btnConfig.externalApi =='/outbound/extender/cancelJdExpressNo'){
            axios.post(ajaxurl + btnConfig.externalApi, params).then(data => {
              if (data.data.code == 200){
                that.$message.success(data.data.msg, 3);
              }else {
                that.$customMessage.warning(data.data.msg, 3);
              }
            });
          }else if(btnConfig.externalApi =='/outbound/printSfIbsLabelPdf') {
            axios.post(ajaxurl + btnConfig.externalApi,params).then(res=>{
              if(res.data.code == 200){
                let data = res.data.data;
                if(data){
                  let list = data.split(",");
                  for(let url of list){
                    that.previewHttpFile(url);
                  }
                }
              }else{
                this.$customMessage.warning(res.data.msg);
              }
            })
          }else if(btnConfig.externalApi =='/outbound/fedExPrintShipmentLabels') {
            axios.post(ajaxurl + "/outbound/fedExPrintShipmentLabels",params).then(res=>{
              if(res.data.code == 200){
                let labelImageType = res.data.data;
                if(labelImageType=='ZPLII'){
                  axios.get(ajaxurl + "/outbound/fedExGetShipmentLabelsByZpl",{
                    params: {
                      relId:this.soheaderSearchVal,
                      sscc:this.cartonSearchVal != undefined?this.cartonSearchVal:""
                    },
                    headers: {
                      Authorization: cookie.getBearerToken()
                    },
                    responseType: "blob" //二进制流
                  }).then(res=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    // 用FileReader读取blob内容，判断是否为JSON错误
                    const reader = new FileReader();
                    reader.onload = (e) => {
                      try {
                        const jsonData = JSON.parse(e.target.result);
                        // 是JSON，说明后端返回错误
                        if (jsonData.code == 200) {
                          that.$customMessage.warning(jsonData.msg);
                        } else {
                          that.$customMessage.warning(jsonData.msg || 'download fail');
                        }
                      } catch (err) {
                        // 不是JSON，是正常的文件流，执行下载
                        const contentDisposition = res.headers['content-disposition'];
                        // 默认文件名格式：soheaderSearchVal + yyyyMMddHHmmssSSS
                        const now = new Date();
                        const pad = (n) => n.toString().padStart(3, '0');
                        const yyyyMMddHHmmssSSS = now.getFullYear() +
                            String(now.getMonth() + 1).padStart(2, '0') +
                            String(now.getDate()).padStart(2, '0') +
                            String(now.getHours()).padStart(2, '0') +
                            String(now.getMinutes()).padStart(2, '0') +
                            String(now.getSeconds()).padStart(2, '0') +
                            pad(now.getMilliseconds());
                        let fileName = this.soheaderSearchVal + '_' + yyyyMMddHHmmssSSS;
                        if(this.cartonSearchVal != undefined && this.cartonSearchVal != "" && this.cartonSearchVal != null){
                          fileName = this.soheaderSearchVal + '_'+this.cartonSearchVal+"_" + yyyyMMddHHmmssSSS+".zpl";
                        }
                        /* if (contentDisposition) {
                                                         const match = contentDisposition.match(/filename[^;]*=\s*"?([^";]+)"?/i);
                                                         if (match && match[1]) {
                                                             fileName = decodeURIComponent(match[1]);
                                                         }
                                                     }*/
                        const contentType = res.headers['content-type'] || 'application/octet-stream';
                        let blob = new Blob([res.data], {type: contentType});
                        let url = window.URL.createObjectURL(blob);
                        let aLink = document.createElement("a");
                        aLink.style.display = "none";
                        aLink.href = url;
                        aLink.setAttribute("download", fileName);
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink);
                        window.URL.revokeObjectURL(url);
                      }
                    };
                    reader.onerror = () => {
                      that.$customMessage.error("读取响应失败");
                    };
                    reader.readAsText(res.data);
                  }).catch(error=>{
                    this.$store.commit("updataLoading", { pbLoading: false });
                    this.$customMessage.error("下载失败");
                  });
                }else if (labelImageType=='PDF'){
                  axios.post(ajaxurl + "/outbound/fedExGetShipmentLabelsByPdf",params).then(res=>{
                    if(res.data.code == 200){
                      let data = res.data.data;
                      if(data){
                        let list = data.split(",");
                        for(let url of list){
                          that.previewHttpFile(url);
                        }
                      }
                    }else{
                      this.$customMessage.warning(res.data.msg);
                    }
                  });
                }else{
                  this.$customMessage.warning(res.data.msg);
                }
              }else{
                this.$customMessage.warning(res.data.msg);
              }
            });
          }else if(btnConfig.externalApi =='/outbound/fedExPrintCommercialInvoices') {
            axios.post(ajaxurl + btnConfig.externalApi,params).then(res=>{
              if(res.data.code == 200){
                let data = res.data.data;
                if(data){
                  let list = data.split(",");
                  for(let url of list){
                    that.previewHttpFile(url);
                  }
                }
              }else{
                this.$customMessage.warning(res.data.msg);
              }
            })
          }else if(btnConfig.externalApi =='/outbound/sfExpressLabel'
                  ||btnConfig.externalApi =='/outbound/ninjavanShipmentLabel'
                  ||btnConfig.externalApi =='/outbound/upsShipmentLabel'
                  ||btnConfig.externalApi =='/outbound/globavendShipmentLabel') {
            axios.post(ajaxurl + btnConfig.externalApi,params).then(res=>{
              if(res.data.code == 200){
                let data = res.data.data;
                if(data){
                  let list = data.split(",");
                  for(let url of list){
                    that.previewHttpFile(url);
                  }
                }
              }else{
                this.$customMessage.warning(res.data.msg);
              }
            });
          }
        }

        if( btnConfig.code == "BTN_EXPORT"){
          if( btnConfig.externalApi == '/so/exportPackingList'){

            let ajaxurl = ajax.ajaxUrl();
            this.isBtnajax = true
            let that = this
            // 构造参数
            let paramsData = [];

            // 给son params 添加信息
            if(this.scanpackSearchType == 'WAVE_HEADER'){
              // console.log(this.WareheaderSearchVal)
              let paramsObj = {};
              paramsObj.key = "waveId";
              paramsObj.value = this.WareheaderSearchVal;
              paramsData.push(paramsObj);
            }else{
              // console.log(this.soheaderSearchVal)
              let paramsObj = {};
              paramsObj.key = "relId"
              paramsObj.value =  this.soheaderSearchVal;
              paramsData.push(paramsObj);
            }
            // 给son params 添加箱号
            if (this.newEditCartData.sscc != undefined) {
              // console.log(this.newEditCartData.sscc)
              let paramsObj = {};
              paramsObj.key = "sscc";
              paramsObj.value = this.newEditCartData.sscc;
              paramsData.push(paramsObj);
            }
            let params = {
              gmcUid: btnConfig.gmcUid,
              uid: '',
              btnName: btnConfig.name,
              btnUid: btnConfig.uid,
              params: paramsData
            }

            ajax.exportExcel(ajaxurl + btnConfig.externalApi,params).then(data => {
              if(!data){
                return;
              }
              let type = data.data.type;
              let that = this;
              const relType = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
              if( type.includes('application/json')){
                let reader = new FileReader()
                reader.onload = function (event) {
                  let content = reader.result
                  let msg = JSON.parse(content).msg
                  that.$customMessage.warning(msg);
                }
                reader.readAsText(data.data)
                return
              }else{
                var blob = new Blob([data.data], {
                  type:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                });
                var url = window.URL.createObjectURL(blob);
                var aLink = document.createElement("a");
                aLink.style.display = "none";
                aLink.href = url;
                aLink.setAttribute("download", "excel.xlsx");
                document.body.appendChild(aLink);
                aLink.click();
                document.body.removeChild(aLink); //下载完成移除元素
                window.URL.revokeObjectURL(url); //释放掉blob对象
              }
            }).catch(function(error) {
              alert(error);
            })
            return
          }
        }
      }else{
        let ajaxurl = ajax.ajaxUrl();
        this.isBtnajax = true
        let that = this
        // 构造参数
        let params = {
                        gmcUid: btnConfig.gmcUid,
                        uid: '',
                        btnName: btnConfig.name,
                        btnUid: btnConfig.uid,
                        extValType: btnConfig.extValType
                    }


        // 添加 订单号
        if(this.scanpackSearchType == 'WAVE_HEADER'){
          params.waveId = this.WareheaderSearchVal
        }else{
          params.relId = this.soheaderSearchVal
        }

        //  添加箱号
        if (this.newEditCartData.sscc != undefined) {
          params.sscc = this.newEditCartData.sscc;
        }

        // console.info(params)
        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
          headers: {
            Authorization: cookie.getBearerToken()
          },
          responseType: "blob" //二进制流
        }).then(function(res) {
          let resHeader = res.headers;
          let contentType = resHeader["content-type"];
          let excelContentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
          if(excelContentType.indexOf(contentType) !=-1) {
            //excel
            that.isBtnajax = false
            var data  = res;
            if (!data) {
              return;
            }
            var blob = new Blob([data.data], {
              type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
            });
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = url;
            aLink.setAttribute("download", "excel.xlsx");
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
          } else {
            //pdf
            that.pubPdfMsgfn(res);
          }
        });
      }
    },
    printSfLabel(printDataStr,msg){
      let  printData = JSON.parse(printDataStr);
      let  that = this;
      const callback = function(result) {
        if(result.code == 1){
          that.$message.success(msg, 3);
        }
      };
      console.info(printData)
      const options = {
        lodopFn: "PRINT" // 默认打印，预览传PREVIEW
      };

      let isResetSCPPrint = false;
      if(this.systemParam.partnerID != null && this.systemParam.partnerID.length > 0){
        if(! this.SF_SCPPrint){
          isResetSCPPrint = true;
        }else {
          if(this.SF_SCPPrint.projectCode != this.projectCode ){
            isResetSCPPrint = true;
          }
        }
      }

      if (isResetSCPPrint){
        let sdkParams={
          env:  this.systemParam.env,
          partnerID: this.systemParam.partnerID,
          notips:  this.systemParam.notips == "true" ? true : false,
          projectCode: this.projectCode
        }
        let SF_SCPPrint2 = installPrintService(sdkParams);
        console.info(SF_SCPPrint2)
        // console.info( this.SCPPrint )
        this.$store.commit("updateSF_SCPPrint", SF_SCPPrint2 );
      }
      // console.info( '1111111')
      // console.info(  this.SF_SCPPrint)
      // console.info( '2222222')
      this.SF_SCPPrint.print(printData, callback, options)
    },
    // paf接口返回值处理
    pubPdfMsgfn(res){
      let data = res.data;
      let fileReader = new FileReader();
      let that = this
      fileReader.onload = function() {
        try {
          let jsonData = JSON.parse(this.result);
          if (jsonData.code) {
            that.$customMessage.warning(jsonData.msg);
            that.$store.commit("updataLoading", { pbLoading: false });
            that.isBtnajax = false
          }
        } catch (err) {
          that.pubPdfUploadOk(res)
        }
      };
      fileReader.readAsText(data)
    },
    //            pdf 成功下载方法
    pubPdfUploadOk(data){
      this.isBtnajax = false
      this.$store.commit("updataLoading", { pbLoading: false });
      let blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
      let url = window.URL.createObjectURL(blob);
      window.open(url);
    },
    batchBtnconfigPrint(item){
      let params = {
        "actionCode": item.actionCode,
        "btnName": item.btnName,
        "combHeaderUids": item.uid,
        "functionCode": item.functionCode,
        "server": item.server
      }
      if(item.actionCode == 'ob.scan.pack.confirm'){
        if(this.scanpackSearchType == 'WAVE_HEADER'){
          params.waveId = this.WareheaderSearchVal
        }else{
          params.relId = this.soheaderSearchVal
        }
      }else if(item.actionCode == 'ob.scan.pack.cancel'){
        if(this.scanpackSearchType == 'WAVE_HEADER'){
          params.waveId = this.WareheaderSearchVal
        }else{
          params.relId = this.soheaderSearchVal
        }
      }else if(item.actionCode == 'ob.scan.pack.close.new'){
        params. name = 'sscc'
        params.sscc = this.newEditCartData.sscc
      } else if(item.actionCode == 'ob.scan.pack.new'){
        return
      } else if(item.actionCode == 'ob.scan.pack.close'){
        params.name = 'sscc'
        params.sscc = this.newEditCartData.sscc
      }else if(item.actionCode == 'ob.scan.pack.remove'){
        if(this.scanpackSearchType == 'WAVE_HEADER'){
          params.waveId = this.WareheaderSearchVal
        }else{
          params.relId = this.soheaderSearchVal
        }
        if (this.newEditCartData.sscc != undefined) {
          params.sscc = this.newEditCartData.sscc;
        } else {
          this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
          return;
        }
      }else if(item.actionCode == 'ob.scan.pack.append'){
        if (this.newEditCartData.sscc != undefined) {
          params.sscc = this.newEditCartData.sscc;
        } else {
          this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
          return;
        }
      }else if(item.actionCode == 'ob.scan.pack.print.sscc'){
        params.sscc = this.newEditCartData.sscc
        params.name = 'sscc'

      }else if(item.actionCode == 'ob.scan.pack.print.carton'){
        params.sscc = this.newEditCartData.sscc
        params.name = 'carton'
      }
      if(item.server == '1'){
        ajax.get(api.PRINTPREVIEW,params).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
          }else{
            this.$customMessage.error(res.msg);
          }
        })
      }else{
        let ajaxurl = ajax.ajaxUrl();
        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
          headers: {
            Authorization: cookie.getBearerToken()
          },
          responseType: "blob" //二进制流
        }).then(data=>{
          var blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        })
      }
    },
    scanpackDetailTableEvnt({ row }){
      if(row == undefined || row == null ){
        return;
      }
      this.cartonSearchVal = row.sscc
      this.cartonSearchEnter()
      this.scanpackTabsTarget = '2'
    },
    scanpackTabsEvent(val){
      if(val == 1){
        let params = {}
        if(this.scanpackSearchType == 'WAVE_HEADER'){
          params.waveId = this.WareheaderSearchVal
        }else{
          params.relId = this.soheaderSearchVal
        }
        params.sscc =  this.cartonSearchVal
        ajax.get(api.PACKSCANDETAIL,params).then(res=>{
          this.scanpackDetailTable = res.data
          let t = 0
          if(this.scanpackDetailTable.length > 0){
            for(let i in this.scanpackDetailTable ){
              t = t + this.scanpackDetailTable[i].qty
            }
            this.scanpackDetailPackedQty = t
            if(this.scanpackDetailPackedQty == 0 || this.scanpackDetailAllocatedQty == 0  ){
              this.scanpackDetailPercentage = 0;
            }else{
              this.scanpackDetailPercentage =  Math.round((this.scanpackDetailPackedQty / this.scanpackDetailAllocatedQty) * 10000) / 100.0 + "%"
            }
          }else{
            this.scanpackDetailPercentage = 0
          }
          this.scanpackDetailPackedQty = t
          this.scanpackDetailNocarton = this.scanpackDetailTable.length
        })
      }
    },
//      footer 样式
    footerCellClassName ({ $rowIndex, column, columnIndex }) {
      return 'footerBackColor'
    },
    closeCheckCompleteTips(){
      this.showCompleteTips = false;
    },
    closeCancelPickConfirm(){
      this.cancelPickConfirmVisible = false;
      this.cancelPickConfirmLoading = false;
      this.cancelPickConfirmList = [];
      this.pendingCheckCompleteItem = null;
      this.pendingCheckCompletePartialPack = false;
    },
    checkCompleteShowMoveWindow(val){
      this.showCompleteTips = false;
      let btn = null ;
      for(let i in this.btnFunArr){
        if(this.btnFunArr[i].code == 'CheckComplete' && this.btnFunArr[i].arr.length > 0){
          btn = this.btnFunArr[i].arr[0]
        }
      }
      if(btn != null){
        this.confirmScanpack(btn,val);
      }
    },
    checkPartialPack(item){
      let params = {}
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      ajax.post(api.CHECKPARTIALPACK,params).then(res=>{
        if(res.code == 200){
          let partialPack = res.data;
          let needCancelPick = false;
          let cancelPickList = [];
          if(res.data != null && typeof res.data == 'object'){
            partialPack = res.data.partialPack;
            needCancelPick = res.data.needCancelPick;
            cancelPickList = res.data.cancelPickList || [];
          }
          if(needCancelPick && cancelPickList.length > 0){
            this.pendingCheckCompleteItem = item;
            this.pendingCheckCompletePartialPack = partialPack;
            this.cancelPickConfirmList = cancelPickList;
            this.cancelPickConfirmVisible = true;
          }else if(partialPack){//部分装箱
            this.showCompleteTips = true;
          }else{
            this.confirmScanpack(item,false);
          }
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },
    confirmCancelPickThenMove(){
      if(!this.pendingCheckCompleteItem || this.cancelPickConfirmList.length == 0){
        this.closeCancelPickConfirm();
        return;
      }
      let params = {};
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal;
      }else{
        params.relId = this.soheaderSearchVal;
      }
      params.cancelPickList = this.cancelPickConfirmList;
      this.cancelPickConfirmLoading = true;
      ajax.post(api.CANCELPICKFORCHECKCOMPLETE,params).then(res=>{
        this.cancelPickConfirmLoading = false;
        if(res.code == 200){
          let item = this.pendingCheckCompleteItem;
          let partialPack = this.pendingCheckCompletePartialPack;
          this.closeCancelPickConfirm();
          if(partialPack){
            this.showCompleteTips = true;
          }else{
            this.confirmScanpack(item,false);
          }
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },
//      confirm 提交
    confirmScanpack(item,partialPack){

      let params = {}
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      params.ip = this.ip;
      params.partialPack = partialPack;

      let extApi = item.externalApi;
      if(! extApi){
        this.$customMessage.warning("Unable to find button API");
        return
      }
      this.checkCompleteDisable = true;
      if(this.closeCartonRelIdArr!=undefined && this.closeCartonRelIdArr!=null && this.closeCartonRelIdArr.length == 1) {
        params = {}
        params.relId = this.closeCartonRelIdArr[0];
      }
      ajax.post(extApi,params).then(async res=>{
        this.checkCompleteDisable = false;
        let soheaderSearchValVar = this.soheaderSearchVal;
        if(this.closeCartonRelIdArr!=undefined && this.closeCartonRelIdArr!=null && this.closeCartonRelIdArr.length == 1) {
          soheaderSearchValVar = this.closeCartonRelIdArr[0];
          this.closeCartonRelIdArr = [];
        }
        if(res.code == 200){
          this.init();
          this.getScanPackStaus();
          //this.$message.success(res.msg);
          let data = res.data;

          if (res.warning != null&&res.warning != "") {
            this.$customMessage.warning(res.warning);
          } else {
            this.$message.success(res.msg);
          }

          if(partialPack == true && res.partialPack != undefined){
            this.$refs.adjustMove.show2(res.partialPack,true)
          }

          try {
            await this.getPrinters();
          } catch (error) {
            console.error("打印机获取失败:", error.message);
            this.printers = [];   // 重要：确保 printers 是一个数组
          }

          if (res.print != null && res.print != "") {
            let printRequest = res.print;
            await this.pushPrinter(printRequest);
          }

          if(data){
            let list = data.split(",");
            for(let url of list){
              // window.open(url);
              this.previewHttpFile(url);
            }
          }

          if(soheaderSearchValVar!=null&&soheaderSearchValVar!=""){
            //自动打印
            params = {}
            params.relId = soheaderSearchValVar;
            params.ip = this.ip;
            await ajax.get(api.AUTOPRINTPDF,params).then(res => {
              this.autoPrint(res);
            })
          }
          if((soheaderSearchValVar!=null&&soheaderSearchValVar!="")||(this.WareheaderSearchVal!=null&&this.WareheaderSearchVal!="")){
            //自动打印
            params = {
              relId: soheaderSearchValVar,
              ip: this.ip
            };
            params.waveId=this.WareheaderSearchVal;
            await ajax.get(api.AUTOPRINTCHECKCOMPLETE,params).then(res => {
              this.autoPrint(res);
            })
          }
          // this.waveUid = "";
          // this.WareheaderSearchVal = "";
          // this.soheaderSearchVal = "";
          // this.soUid = "";
          if(this.soheaderSearchVal.length > 0){
            this.$refs.relIdRef.select()
            this.$nextTick(()=>{
              this.$refs.relIdRef.focus()
            })
          }else{
            if(this.skuUnpackQty>0){
              this.$nextTick(()=>{
                this.$refs.skuScanUpcRef.focus()
              })
            }else{
              this.$refs.waveIdRef.select()
              this.$nextTick(()=>{
                this.$refs.waveIdRef.focus()
              })
            }
          }
          // 如果调用成功，尝试去调用 afterShip方法
          //this.printAfterShipGenerateLabel('Check Complete');
        }else{
          // urls
          if (res.data != null) {
            let list = res.data.split(",");
            for (let url of list) {
              window.open(url);
            }
          }

          // warnings
          if (res.warning != null && res.warning != '') {
            this.$customMessage.warning(res.warning);
          }

          // errors
          this.$customMessage.warning(res.msg);
        }
      })
    },

    // scan pack confirm 提交
    newConfirmScanpack(item){
      let params = {};
      let paramsData = [];
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        paramsData.push({key: 'moduleName', value: 'SCAN_PACK_WAVE_HEADER'})
        paramsData.push({key: 'soWaveId', value: this.WareheaderSearchVal})
      }else{
        paramsData.push({key: 'moduleName', value: 'SCAN_PACK_VSO'})
        paramsData.push({key: 'soWaveId', value: this.soheaderSearchVal})
      }


      let tt = {
        behrUid: '',
        fieldMapUid: '',
        functionUid: '',
        gmcUid: '',
        language: this.lang,
        params: paramsData,
        type: '',
        userUid: '',
      }
      if(this.systemParam.DELIVERY_DATE_NOT_PROMPT == 'Y'){ // 弹出发运确定框
        let that = this;
        this.$customConfirm({
          title: that.$t('publicLang.ConfirmShipment'),
          okText: that.$t('publicLang.Confirm'),
          cancelText: that.$t('publicLang.Cancel'),
          content: "",
          onOk() {
            ajax.post(api.SOEXTENDERCONFORM,tt).then(res=>{
              if(res.code == 200){
                that.$message.success(res.msg, 3);
                that.getScanPackStaus();
              }else{

                that.$customMessage.warning(res.msg);
              }
            })

          }
        });
      }else{
        this.$refs.deliveryDate.show(tt)
      }
    },

    // scan pack close order
    scanpackCloseOrder(item){
      let params = {}
      params.relId = this.soheaderSearchVal;
      params.waveId = this.WareheaderSearchVal;
      let that =this
      this.$customConfirm({
        title: this.$t('processActionMsg'),
        okText: this.$t('publicLang.Confirm'),
        okType: 'confirm',
        cancelText: this.$t('publicLang.Cancel'),
        onOk() {
          ajax.post(api.SCANPACKCLOSEORDER, params).then(res => {
            if (res.code == 200) {
              that.$message.success(res.msg);
              that.init();
              that.getScanPackStaus();
            } else {
              that.$customMessage.warning(res.msg);
            }
          });
        },
      })
    },
    // scan pack Send EDI
    scanpackSendEDI(item){
      if(((this.soheaderSearchVal==null||this.soheaderSearchVal=="")&&(this.WareheaderSearchVal==null||this.WareheaderSearchVal==""))){
        return;
      }
      let params = {}
      params.relId = this.soheaderSearchVal;
      params.waveId = this.WareheaderSearchVal;
      params.ip = this.ip;
      let that =this
      this.$customConfirm({
        title: this.$t('processActionMsg'),
        okText: this.$t('publicLang.Confirm'),
        okType: 'confirm',
        cancelText: this.$t('publicLang.Cancel'),
        onOk: async function() {
          try {
            await that.getPrinters();
          } catch (error) {
            console.error("打印机获取失败:", error.message);
            this.printers = [];   // 重要：确保 printers 是一个数组
          }
          await ajax.post(api.SCANPACKSENDEDI, params).then(res => {
            let ret = true;
            for (let i = 0; i < res.length; i++) {
              if (res[i].success) {
                //自动打印
                if(res[i].code==1){
                  that.autoPrint(res[i].data);
                }
                //文件预览
                if(res[i].code==2){
                  //farfetch文件预览
                  let data = res[i].data;
                  if(data){
                    let list = data.split(",");
                    for(let url of list){
                      window.open(url);
                    }
                  }
                }

              } else {
                that.$customMessage.warning(res[i].msg);
                ret = false;
              }
            }
            if(ret){
              that.$message.success("Operation succeeded!");
            }
          });
        },
      })
    },
    rePrintCloseCtnReport(){
      if((this.soheaderSearchVal==null ||  this.soheaderSearchVal=="") && (this.WareheaderSearchVal==null || this.WareheaderSearchVal=="")){
        return;
      }
     /* if(this.newEditCartData.sscc==null || this.newEditCartData.sscc=="" || this.newEditCartData.sscc == undefined){
        this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
        return;
      }*/
      this.printCloseCtnReport();
    },
    async printCloseCtnReport(){
      //自动打印
      let params = {
        relId: this.soheaderSearchVal,
        waveId: this.WareheaderSearchVal,
        sscc: this.newEditCartData.sscc,
        ip: this.ip
      };
      try {
        await this.getPrinters();
      } catch (error) {
        console.error("打印机获取失败:", error.message);
        this.printers = [];   // 重要：确保 printers 是一个数组
      }
      await ajax.get(api.AUTOPRINT,params).then(res => {
        this.autoPrint(res);
      })
    },

    autoPrint(res){
      for (let i = 0; i < res.length; i++) {
        if(res[i]==null){
          continue;
        }
        if (res[i].type == null) {
          continue;
        }
        if(res[i].errorMsg!=null&&res[i].errorMsg!=""){
          continue;
        }
        if(res[i].printerName==null||res[i].printerName==""){
          continue;
        }
        console.log("printerNames:"+res[i].printerName);
        let printerName = "";
        let printerNames = res[i].printerName.split(",");
        for(var j = 0;j<this.printers.length;j++){
          for(var k = 0;k<printerNames.length;k++){
            if(this.printers[j].name==printerNames[k]){
              printerName = printerNames[k];
              break;
            }
          }
          if(printerName!=""&&printerName!=null){
            break;
          }
        }
        console.log("printerName:"+printerName);
        if(printerName!=""){
          res[i].printerName = printerName;
          if(res[i].fileBytes.length>125000){
            let oldFileBytes = res[i].fileBytes;
            let part = Math.ceil(oldFileBytes.length/125000);//分批数
            for (let j = 0; j < part; j++)
            {
              let fileBytes = "";
              if (oldFileBytes.length>125000) {
                fileBytes = oldFileBytes.substring(0, 125000);
                oldFileBytes = oldFileBytes.substring(125000, oldFileBytes.lenght);
              } else {
                fileBytes = oldFileBytes.substring(0, oldFileBytes.lenght);
                oldFileBytes = "";
              }
              res[i].fileIndex = j;//当前发送位置
              res[i].fileCount = part;//表示发送多次已发完
              res[i].fileBytes = fileBytes;
              webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
            }
          }else{
            res[i].fileCount = 1;//1表示一次发完
            webSocketPrint.doPrint("9999",JSON.stringify(res[i]));
          }
        } else {
          // preview
          if (res[i].fileURL) {
            this.previewHttpFile(res[i].fileURL);
          }
        }
      }
    },

    showSelectBox (){
      this.cancelCheckCompleteVisible = true
    },

    footerMethod({ columns, data }) {
      let that = this;
      return [
        columns.map((column, columnIndex) => {
          if (["pickedQty", "packedQty", "unscannQty",'sscc'].includes(column.property)) {
            return that.sumPubFn(column.property);
          }
        })
      ];
    },
    sumPubFn(val) {
      let arr = this.partTable;
      let sum = 0;
      for (let index in arr) {
        sum += parseInt(arr[index][val]);
      }
      if(val == "pickedQty"){
        this.scanpackDetailAllocatedQty = sum
      }
      if(val == "sscc"){
        let arr = []
        for(let i in this.partTable){
          if(this.partTable[i].sscc != '*'){
            if(arr.indexOf(this.partTable[i].sscc) == -1){
              arr.push(this.partTable[i].sscc)
            }
          }
        }
        sum =  arr.length
      }
      return sum;
    },

    //            Carton 切换
    scanpackConfig() {
      //获取UDF1-UDF5的显示值
      ajax.get(api.GETSCANPACKUDFDISNAME, null).then(res => {
        if (res.code == 200) {
          this.UDF = res.data;
        }
        if(this.systemParam.DP_FLOW=='Y'){
          this.$nextTick(()=>{
            this.$refs.containerNo.select();
            this.$refs.containerNo.focus();
          })
        }else if ( (this.soheaderSearchVal=="" || this.soheaderSearchVal == undefined ||  this.soheaderSearchVal == null) && (this.WareheaderSearchVal == '' || this.WareheaderSearchVal == undefined ||  this.WareheaderSearchVal == null ) ){
          this.$nextTick(()=>{
            this.$refs.relIdRef.focus()
          })
        }else{
          this.$nextTick(()=>{
            if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
              this.epcScanVal='';
              this.$refs.epcScanRef.focus();
            }else{
              this.$refs.skuScanUpcRef.focus()
            }
          })
        }
      });
    },
    //            关闭弹窗
    onClose() {
      // clear cache
      this.currentBrand = "";

      this.platfromVal = null;
      this.amrContainerValue = null;
      this.visible = false;
      this.scanComponentsFlag = false;
      this.clearCarTonData()
      this.lockChecked =  true
      this.DeleteChecked = false
      this.closeAndNewDisab = true
      this.newDisab = false
      this.closeDisab = true
      this.removeDisab = true
      this.appendDisab = true
      this.WareheaderSearchVal = ''
      this.soheaderSearchVal = ''
      this.cartonSearchVal = ''
      this.scanpackTabsTarget = '2'
      this.selectRow = ''
      this.cartonNoDis = false
      this.skuabled = false
      this.OtySaoNum = 1
      this.isCartonChecked = false;
      this.isPrePackChecked = false;
      this.isTraceIdChecked = false;
      this.isHiddenTable= false;
      this.isSwitchDisabled = false;
      this.skuLabel = this.$t('pubGicSet.SKU');
      this.editForm.resetFields();
      this.ssccSearchVal = "";
      this.epcVisible = false;
      this.epcScanVal = "";
    },

    //            打开弹窗
    show(id,type) {
      // TODSSH show project code
      this.scanpackAlterMsg();
      this.scanpackConfig();
      this.btnFunArr = [
        {code: 'CheckComplete',arr:[]},
        {code: 'CancelCheckComplete',arr:[]},
        {code: 'Confirm',arr:[]},
        {code: 'SendEDI',arr:[]},
        {code: 'Re-print',arr:[]},
        {code: 'CourierEDI',arr:[]},
        {code: 'Print',arr:[]},
        {code: 'CourierEDI-BTN',arr:[]},
        {code: 'Close',arr:[]},
        {code: 'Append',arr:[]},
        {code: 'Remove',arr:[]},
        {code: 'ImportScanningFile', arr:[]},
        {code: 'PrintCarton',arr:[]},
        {code: 'PrintSSCC',arr:[]},
        {code: 'D-Print',arr:[]},
        {code: 'C-LockScanQty',arr:[]},
        {code: 'C-RemoveScanItem',arr:[]},
        {code: 'C-IsCarton',arr:[]},
        {code: 'C-IsPre-Pack',arr:[]},
        {code: 'C-IsTraceID',arr:[]},
        {code: 'Other',arr:[]},
        {code: 'CloseOrder',arr:[]},
        {code: 'Export',arr:[]}
      ]

      ajax.get(api.GENERICPRINTNODEALLBTNFORLOAD,{module_code:"SCAN_PACK"}).then(res=>{
        this.fieldMap = res.data.fieldMap;
        let btnMap = res.data.behrMap;

        if (btnMap != null ) {
          // 遍历 Map，判断值是否为 null
          for (let key in  btnMap) {
            if (btnMap[key] !== null) {
              for(let i in this.btnFunArr){
                if(this.btnFunArr[i].code == key){
                  this.btnFunArr[i].arr = btnMap[key];
                  this.checkboxList.push(this.btnFunArr[i].code)
                  if (this.btnFunArr[i].code == 'ImportScanningFile') {
                    this.importScanningFileDisab = true;
                  }
                }
              }
            }
          }
        }
      })
      this.visible = true
      this.scanpackSearchType = type
      let params = {}
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveUid =  id
        this.waveUid = id
      }else if(this.scanpackSearchType == 'VSO'){
        params.soUid = id
        this.soUid = id
      }
      if(this.systemParam.amrFlow=='Y'){
        this.amrFlow=true;
      }
      this.closeCartonRelIdArr = [];


      if(id != null && id != ''){
        ajax.get(api.GETSCANPACKORDERINFO,params).then(res=>{
          if(res.code == 200){
            if(this.scanpackSearchType == 'WAVE_HEADER'){
              this.WareheaderSearchVal = res.data.waveId
            }else if(this.scanpackSearchType == 'VSO'){
              this.soheaderSearchVal = res.data.relId
            }
            this.trackingNoMap = res.data.trackingNoMap
            this.trackingNoEdit = res.data.trackingNoEdit
            this.platfromVal =  res.data.platfromVal
            this.instructionDisplay= res.data.instructionDisplay;
            this.waveType = res.data.waveType
            this.HUDF01= res.data.HUDF01;
            this.init();
            this.getScanPackStaus();
          }
        })
      }
      this.vefifyOrder();
//        new carton 下拉数据
      ajax.get(api.PACKCARTONTYPELIST).then(res=>{
        this.cartonTypeSelectData = res.data
      })
      //  console.info('获取页面按钮')



      this.addListener();

      // Tom 2023-04-21 将init部分抽出 只加载一次
      params = {}
      params.waveUid =  this.waveUid == undefined ? '': this.waveUid
      params.waveId = this.WareheaderSearchVal == undefined ? '': this.WareheaderSearchVal
      params.relId =  this.soheaderSearchVal == undefined ? '': this.soheaderSearchVal
      params.soUid =  this.soUid == undefined ? '': this.soUid
      if( params.relId == '' &&  params.soUid == '' && params.waveUid == '' &&  params.waveId == '' ){
        this.partTable = [];
        return;
      }
      ajax.get(api.GETALLUPC, params).then(res => {
        if (res.code == 200) {
          this.upcTable = res.data.upcTable;
          this.tbSkuList = res.data.tbSkuList;
        }
      });
    },

    scanpackAlterMsg() {
      if (this.currentBrand == null || this.currentBrand == '') {
        ajax.get(api.GETSCANPACKALERTMSGFLAG, null).then(res => {
          if (res.code == 200) {
            if ('true' == res.data.alertMsgFlag) {
              // show current project code
              this.currentBrand = this.projectCode;
              //this.$message.success(this.$t('scanPack.currentBrand') + ": " + this.currentBrand);
              var tips = this.$t('scanPack.currentBrand') + ": " + this.currentBrand;
              this.$alert(tips,
                  {showClose:false,
                    confirmButtonText:this.$t('publicLang.Confirm')
                  }
              );
              //return;
            }
          }
        })
      }
    },

    orderSearch(type){
      if(this.ssccSearchVal != null && this.ssccSearchVal != ''){
        this.ssccSearch();
      }else if(this.soheaderSearchVal != null && this.soheaderSearchVal != ''){
        this.soHeaderSearch();
        this.destroyAreaBox();
      }else {
        this.WareHeaderSearch();
        this.destroyAreaBox();
      }
    },
    //            so 头部搜索
    soHeaderSearch() {
      this.scanpackSearchType = 'VSO'
      this.cartonSearchVal = null
      this.scanPackDtoList = []
      this.cartonTable = []
      this.carTonQty = 0
      this.carTonOfSku = 0
      this.Percentage = 0
      this.skuPackedQty = 0
      this.isHiddenTable= false;
      this.isSwitchDisabled = false;

      this.init();
      this.getScanPackStaus();
      this.getAllUpc();
      this.findTrackingNo(this.scanpackSearchType,this.soheaderSearchVal);
      this.$nextTick(()=>{
        if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
          this.epcScanVal='';
          this.$refs.epcScanRef.focus();
        }else{
          this.$refs.skuScanUpcRef.focus()
        }
        if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
          this.epcScanVal = '';
          this.epcVisible = false;
        }
      })
      this.cartonNoDis = false
      this.editForm.resetFields()
      this.vefifyOrder();
    },
    vefifyOrder(){
      //检查订单是否截单
      let params = {}
      params.waveUid =  this.waveUid == undefined ? '': this.waveUid
      params.waveId = this.WareheaderSearchVal == undefined ? '': this.WareheaderSearchVal
      params.relId =  this.soheaderSearchVal == undefined ? '': this.soheaderSearchVal
      params.soUid =  this.soUid == undefined ? '': this.soUid
      ajax.get(api.CHECKSOSTATUS, params).then(res => {
        if (res.code != 200) {
          if(res.msg.startsWith('ORDER_CANCEL')){
            var returnMsg = res.msg.substring("ORDER_CANCEL".length,res.msg.length)
            //this.$customMessage.warning(this.$t('cfs.OrderCancel'));
            this.$alert(returnMsg,
                {showClose:false,
                  confirmButtonText:this.$t('publicLang.Confirm')
                }
            );
          }else{
            this.$customMessage.error(res.msg);
          }

        }
      });
    },

    WareHeaderSearch(){
      this.scanpackSearchType = 'WAVE_HEADER'
      this.cartonSearchVal = null
      this.scanPackDtoList = []
      this.cartonTable = []
      this.carTonQty = 0
      this.carTonOfSku = 0
      this.Percentage = 0
      this.skuPackedQty = 0
      this.isHiddenTable= false;
      this.isSwitchDisabled = false;

      this.$nextTick(()=>{
        if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
          this.epcScanVal='';
          this.$refs.epcScanRef.focus();
        }else{
          this.$refs.skuScanUpcRef.focus()
        }
      })
      this.cartonNoDis = false
      this.init();
      this.getScanPackStaus();
      this.getAllUpc();
      this.findTrackingNo(this.scanpackSearchType,this.WareheaderSearchVal);
      this.editForm.resetFields()
      this.vefifyOrder();
    },
// 根据单号获取快递单号
    findTrackingNo(searchType,id){
      let params = {}
      if('WAVE_HEADER' == searchType){
        params.waveId = id;
        params.relId = '';
      }else{
        params.relId = id;
        params.waveId ='';
      }
      ajax.get(api.GETSCANPACKORDERINFO, params).then(res => {
        if(res.code == 200 ){
          this.trackingNoMap = res.data.trackingNoMap
          this.trackingNoEdit = res.data.trackingNoEdit
          this.platfromVal =  res.data.platfromVal
          this.waveType = res.data.waveType
          this.instructionDisplay= res.data.instructionDisplay;
          this.HUDF01= res.data.HUDF01;
        }
      })

    },





    //            父table
    init(type) {
      if(this.systemParam.scanpack_way == 'Y'){
        this.showCartonSave = false;
      }

      let params = {}
      params.waveUid =  this.waveUid == undefined ? '': this.waveUid
      params.waveId = this.WareheaderSearchVal == undefined ? '': this.WareheaderSearchVal
      params.relId =  this.soheaderSearchVal == undefined ? '': this.soheaderSearchVal
      params.soUid =  this.soUid == undefined ? '': this.soUid
      params.scanSku = ''
      if( params.relId == '' &&  params.soUid == '' && params.waveUid == '' &&  params.waveId == '' ){
        this.partTable = [];
        return;
      }

      ajax.get(api.SCANTABLE, params).then(res => {
        if (res.code == 200) {

          this.partTable = res.data.pickTableData;
          if(this.WareheaderSearchVal=="" || this.WareheaderSearchVal == undefined){
            this.soheaderSearchVal= res.data.relId
          }
          this.tableRelId = res.data.relId
          if(this.partTable.length > 0){
            this.scanFieldTitle = this.partTable[0].scanField
            let skuUnpackQtyNum = 0
            for (let tt in this.partTable) {
              skuUnpackQtyNum = this.partTable[tt].unscannQty + skuUnpackQtyNum
              this.skuUnpackQty = skuUnpackQtyNum
            }
            if(this.selectRow.sku){
              let index = this.selectRow.sku.lastIndexOf("-")
              let componentSku = this.selectRow.sku.substring(0,index);
              let skuPackedQtyNum = 0
              let pickedQtyNum = 0
              let  matchSku = false
              for (let t in this.partTable){
                if(this.partTable[t].sku == this.selectRow.sku){ // 已经匹配上Sku
                  matchSku =true;
                  skuPackedQtyNum = skuPackedQtyNum + this.partTable[t].packedQty
                  pickedQtyNum = pickedQtyNum + this.partTable[t].pickedQty
                }
              }

              if(! matchSku){  // 否则
                for (let t in this.partTable){
                  if(this.partTable[t].sku == componentSku){
                    skuPackedQtyNum = skuPackedQtyNum + this.partTable[t].packedQty
                    pickedQtyNum = pickedQtyNum + this.partTable[t].pickedQty
                  }
                }
              }

              if(!this.isCartonChecked && !this.isPrePackChecked && !this.isTraceIdChecked){
                this.skuPackedQty = skuPackedQtyNum
                this.Percentage = Math.round((skuPackedQtyNum / pickedQtyNum) * 10000) / 100.0 + "%";
              }
            }
            let SCAN_PACK_LAST_SKU_PROMP = this.systemParam.SCAN_PACK_LAST_SKU_PROMP == undefined ? "N" : this.systemParam.SCAN_PACK_LAST_SKU_PROMP;
            if("SKUSCAN"==type && "Y"==SCAN_PACK_LAST_SKU_PROMP){
              if(skuUnpackQtyNum==0){
                this.$alert(this.$t('publicLang.LastSKUCheckCompletePrompt'),
                    {showClose:false,
                      confirmButtonText:this.$t('publicLang.Confirm')
                    }
                );
              }
            }
            if(this.systemParam.DP_FLOW=='Y'&&this.ssccSearchVal!=null&&this.ssccSearchVal!=""){
              if(this.systemParam.SYS_DP_PICK_FLOW!='Y' && this.soheaderSearchVal!=null && this.partTable.length > 0){
                this.$refs.skuScanUpcRef.focus()
              }else{
                this.$refs.containerNo.select();
                this.$refs.containerNo.focus();
              }
            }else if(this.isCartonChecked || this.isPrePackChecked || this.isTraceIdChecked){
              this.$nextTick(()=>{
                if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
                  this.epcScanVal='';
                  this.$refs.epcScanRef.focus();
                }else{
                  this.$refs.skuScanUpcRef.focus()
                }
              })
            }

//                add carton 焦点去SKU
            if(type == 'addNew'){
              this.$refs.skuScanUpcRef.focus()
            }
          }
        } else {
          this.$customMessage.error(res.msg);
        }
        if(this.DeleteChecked){
          this.DeleteChecked = false;
        }
      });
      //this.getScanPackStaus();
    },
    //      扫货
    sacnpackAjax(){
      this.cartonNoDis = true
      this.$nextTick(()=>{
        if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
          this.epcScanVal='';
          if(this.mbshaScanInEpcCheck) {
            this.$nextTick(()=>{
              this.$refs.skuScanUpcRef.focus()
            })
          } else {
            this.$nextTick(()=>{
              this.$refs.epcScanRef.focus()
            })
          }
        }else{
          this.$refs.skuScanUpcRef.focus()
        }
      })

      //Liyy 2022-6-17 添加按箱批量扫描和按Bom批量扫描
      let scanBy = '';
      if(this.isCartonChecked){
        scanBy = 'isCarton'
      }
      if(this.isPrePackChecked){
        scanBy = 'isPrepack'
      }
      if(this.isTraceIdChecked){
        scanBy = 'isTraceId'
      }

      let todsScanSkuLength =   this.systemParam.SCAN_SKU_12_LETTER == undefined ? 'N' : this.systemParam.SCAN_SKU_12_LETTER;
      let  scanpackWay =  this.systemParam.scanpack_way  == undefined ? 'N' : this.systemParam.scanpack_way;
      let  SCAN_SKU_SHOW =  this.systemParam.SCAN_SKU_SHOW  == undefined ? 'N' : this.systemParam.SCAN_SKU_SHOW;
      // 2022-11-04 截取前12位作为SKU进行扫描
      if("Y" == todsScanSkuLength || "y" == todsScanSkuLength){
        if (this.skuScanUpc.length >= 12 && scanBy != "isCarton"){
          this.skuScanUpc = this.skuScanUpc.substring(0,12);
        }
        // else{
        //     this.$refs.skuScanUpcRef.select()
        //     this.$refs.skuScanUpcRef.focus();
        //     this.audioPubFun();
        //     this.SkuExistVis = true;
        //     this.errMsg =  this.$i18n.t('pubGicSet.InvalidSKU',{"0":this.skuScanUpc})
        //     return
        // }
      }
      this.cartonTableSKU = this.skuScanUpc;


      if(scanpackWay == 'N'){
        let index = this.skuScanUpc.lastIndexOf("-")
        let componentSku = this.skuScanUpc.substring(0,index);

        let selectRowBySku = null;     // 扫描的是 SKU
        let selectRowByComponent = null;  // 扫描的是 SKU  的配件
        let SCAN_PACK_DECODE = this.systemParam.SCAN_PACK_DECODE;
        let upcDecode = this.skuScanUpc;
        if('Y'==SCAN_PACK_DECODE && upcDecode.length==14){
          /*   if(upcDecode.length!=14){
                            this.errMsg = this.$t('pubGicSet.ScanPackDecodeError');
                            this.audioPubFun();
                            this.SkuExistVis = true;
                            return;
                        }*/
          this.skuScanUpc = upcDecode.substring(0,6);
          this.DUDF_02=upcDecode.substring(6,12);
          this.OtySaoNum=upcDecode.substring(12,14);
          //console.log(this.skuScanUpc+">>"+this.DUDF_02+">>"+this.OtySaoNum);
        }

        for (let t in this.partTable) {
          if (this.partTable[t].sku == this.skuScanUpc) {   // 表格的数据 SKU 与输入的一样
            if(this.partTable[t].sscc == this.newEditCartData.sscc){
              selectRowBySku = this.partTable[t];
            }else{
              selectRowBySku = {sku: this.partTable[t].sku,relId: this.partTable[t].relId,descr:this.partTable[t].descr,uom:this.partTable[t].uom}
            }
            break;
          }
        }

        if (selectRowBySku == null){
          for (let t in this.partTable) {
            if(this.partTable[t].sku == componentSku){   // 扫描的是配件
              if(this.partTable[t].sscc == this.newEditCartData.sscc){
                selectRowByComponent = {sku: this.skuScanUpc,relId: this.partTable[t].relId,descr:this.partTable[t].descr,uom:this.partTable[t].uom,sscc : this.newEditCartData.sscc}
              }else{
                selectRowByComponent = {sku: this.skuScanUpc,relId: this.partTable[t].relId,descr:this.partTable[t].descr,uom:this.partTable[t].uom}
              }
              break;
            }
          }
        }



        if ( selectRowBySku != null || selectRowByComponent != null  || scanBy.length > 0){

          if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
            if(!this.epcVisible){
              for (let t in this.partTable) {
                if (this.partTable[t].sku === this.skuScanUpc && (this.partTable[t].isSnControl === 'true' || this.partTable[t].isSnControl === 'Y')) {
                  this.epcVisible = true;
                  this.$nextTick(() => {
                    this.epcScanVal = '';
                    if (this.$refs.epcScanRef) {
                      this.$refs.epcScanRef.focus();
                    } else {
                      setTimeout(() => {
                        this.$refs.epcScanRef.focus();
                      }, 20)
                    }
                  })
                  return;
                }
              }
            }
          }

          this.selectRow =  {};

          if( selectRowBySku != null ){
            this.selectRow = selectRowBySku;
          } else if(selectRowByComponent != null){
            this.selectRow = selectRowByComponent
          }

          let params = {
            sscc : this.newEditCartData.sscc,
            cartonUid : this.newEditCartData.uid,
            relId :  this.selectRow.relId,
            sku : this.selectRow.sku,
            serialNo:this.epcScanVal,
            delete : this.DeleteChecked,
            scanPackQty : parseInt(this.OtySaoNum),
            dudf02:this.DUDF_02
          };

          if(this.scanpackSearchType == 'WAVE_HEADER'){
            params.waveId = this.WareheaderSearchVal
          }else{
            params.relId = this.soheaderSearchVal
            // Tom 2025-03-21 When empty, select the selected 'so'
            if(null == this.soheaderSearchVal || ''==this.soheaderSearchVal) {
              params.relId = this.selectRow.relId
            }
          }

          if(scanBy.length > 0){
            this.selectRow.sku = this.skuScanUpc;
            params.sku = this.skuScanUpc;
            params.isCartonOrPrePack = scanBy;
          }
          this.skuScanUpc= ''

          this.DUDF_02 = '';
          let skuRow = this.selectRow;// 暂时存 扫描SKU
          params.isHiddenTable = this.isHiddenTable ? "1" : "0"
          ajax.noLoadingPostAjax(api.SCANPACK, params).then(res=>{
            if(res.code == 200){

              this.$refs.scanSuccessMusicRef.play();
              //carton table 计算
              let resSku = skuRow.sku;
              if( selectRowBySku == null ){
                resSku = componentSku;
              };


              this.$nextTick(()=>{
                let result =   this.cartonTable.some(item=>{
                  if (item.sku == skuRow.sku || item.sku ==  componentSku) {
                    return true
                  }
                })

                if(result){

                  let matchSkuFlag = false;
                  for(let j in this.cartonTable) {
                    if (this.cartonTable[j].sku == resSku) {
                      matchSkuFlag = true ;
                      if(params.delete){
                        let resScannedQty = this.cartonTable[j].scannedQty - parseInt(this.OtySaoNum)
                        if(resScannedQty == 0){ // 减少为0 即删除该记录
                          this.cartonTable.splice(j,1)
                        }else{
                          this.cartonTable[j].scannedQty =resScannedQty
                        }
                      }else{
                        this.cartonTable[j].scannedQty = this.cartonTable[j].scannedQty + parseInt(this.OtySaoNum)
                      }
                    }
                  }
                  if(! matchSkuFlag){
                    let createCarton = {};
                    if( selectRowBySku == null ){  // 扫描的是配件
                      createCarton.sku = componentSku  // 使用配件截取出来的SKU
                    }else{
                      createCarton.sku = skuRow.sku   //扫描的是SKU
                    }
                    createCarton.scannedQty=parseInt(this.OtySaoNum);
                    createCarton.uom = skuRow.uom
                    createCarton.descr = skuRow.descr
                    // this.cartonTable.push(createCarton);

                    let scanedCartonTable = new Array();
                    let createCartonArray = new Array();
                    createCartonArray.push(createCarton);
                    for (let t in this.cartonTable) {
                      scanedCartonTable.push(this.cartonTable[t])
                    }
                    this.cartonTable = createCartonArray.concat(scanedCartonTable);
                  }

                }else{
                  if( ! (scanBy == 'isCarton' ||  scanBy == 'isTraceId')){
                    let createCarton = {};
                    if( selectRowBySku == null ){  // 扫描的是配件
                      createCarton.sku = componentSku  // 使用配件截取出来的SKU
                    }else{
                      createCarton.sku = skuRow.sku   //扫描的是SKU
                    }
                    createCarton.scannedQty=parseInt(this.OtySaoNum);
                    createCarton.uom = skuRow.uom
                    createCarton.descr = skuRow.descr
                    //this.cartonTable.push(createCarton)

                    let scanedCartonTable = new Array();
                    let createCartonArray = new Array();
                    createCartonArray.push(createCarton);

                    for (let t in this.cartonTable) {
                      scanedCartonTable.push(this.cartonTable[t])
                    }
                    this.cartonTable = createCartonArray.concat(scanedCartonTable);

                  }
                }
                // this.OtySaoNum=1;
                this.carTonOfSku = this.cartonTable.length;
                let sum = 0;
                for(let i in this.cartonTable) {
                  sum = sum + this.cartonTable[i].scannedQty;
                }
                this.carTonQty = sum;
              })

              if(this.newEditCartData != null && res.data.cartonUid != null ){
                this.newEditCartData.uid = res.data.cartonUid
                if(this.newEditCartData.rowVersion == null){
                  this.newEditCartData.rowVersion = res.data.cartonRowVersion
                }
              }

              // if(scanBy == 'isCarton' || scanBy == 'isTraceId'){
              //     this.newEditCartData.sscc == null;

              //     this.cartonSearchVal = '';
              //     this.cartonNoDis = false;

              //     // Tom 2024-08-27 重新加载箱列表
              //     this.scanpackTabsEvent(1);

              // }
              // if( > 0){
              //    ;
              // }

              if(res.data.componentSku != null){  // 返回成功，把快递单号放置Carton#的位置显示
                this.componentSku1 = res.data.componentSku;
                this.components = res.data.components;
                this.scanComponents = res.data.scanComponents;
                this.scanComponentsFlag = true
                return;
              }else{

                if(selectRowBySku == null && params.delete){
                  let params2 = {};
                  if(this.scanpackSearchType == 'WAVE_HEADER'){
                    params2.waveId = this.WareheaderSearchVal
                  }else{
                    params2.relId = this.soheaderSearchVal
                  }
                  params2.sku = componentSku
                  ajax.get(api.GETCOMPONENT, params2).then(res => {
                    this.componentSku1 = res.data.componentSku;
                    this.components = res.data.components;
                    this.scanComponents = res.data.scanComponents;
                    this.scanComponentsFlag = true
                  })
                }else{
                  this.scanComponentsFlag = false
                }

              }
              let relId = res.data.relId
              this.newEditCartData.logisticsid = this.trackingNoMap[relId]

              if("1" == params.isHiddenTable){
                let rowBySku = null;
                let rowBySkuAndSscc = null;
                let itemIndex = -1;
                for(let i in this.partTable){
                  let item = this.partTable[i];
                  if(item.sku == resSku ){
                    if(item.sscc == '*'){
                      rowBySku = item ;
                    }else if(item.sscc == this.newEditCartData.sscc){
                      rowBySkuAndSscc = item;
                      itemIndex = i;
                      break;
                    }
                  }
                }

                if(itemIndex > 0){
                  if(params.delete){
                    rowBySkuAndSscc.packedQty -= params.scanPackQty;
                    rowBySkuAndSscc.pickedQty -= params.scanPackQty;
                  }else{
                    rowBySkuAndSscc.packedQty += params.scanPackQty;
                    rowBySkuAndSscc.pickedQty += params.scanPackQty;
                  }
                  this.partTable[itemIndex] = rowBySkuAndSscc;
                }else{
                  const newRow = JSON.parse(JSON.stringify(rowBySku));
                  newRow.sscc = this.newEditCartData.sscc;
                  newRow.unscannQty = 0;
                  newRow.pickedQty = params.scanPackQty;
                  newRow.packedQty = params.scanPackQty;
                  this.partTable.push(newRow)
                }
                this.skuUnpackQty = res.data.unscannQty
                let packedQtyBySku = 0;
                for(let i in this.partTable){
                  let item = this.partTable[i];

                  if(item.sku == resSku ){
                    packedQtyBySku += item.packedQty;
                  }
                }
                this.skuPackedQty = packedQtyBySku;
                this.Percentage = Math.round((this.skuPackedQty / this.scanpackDetailAllocatedQty) * 10000) / 100.0 + "%";
                //   this.resortPartTable()

              }else{
                this.init("SKUSCAN")
              }



              this.scanPackDtoList = []

              if(scanBy == 'isPrepack'){
                this.cartonSearchEnter()
                this.skuPackedQty = res.data.packedQty;
                this.skuUnpackQty = res.data.unscannQty
                this.Percentage = Math.round((this.skuPackedQty / this.scanpackDetailAllocatedQty) * 10000) / 100.0 + "%";
              }else if(scanBy == 'isTraceId' ||  scanBy == 'isCarton'){
                this.newEditCartData = {};
                this.cartonSearchVal = '';
                this.cartonNoDis = false;

                // Tom 2024-08-27 重新加载箱列表
                // this.scanpackTabsEvent(1);

                if((this.soheaderSearchVal!=null&&this.soheaderSearchVal!="")||(this.WareheaderSearchVal!=null&&this.WareheaderSearchVal!="")||(this.newEditCartData.sscc!=null&&this.newEditCartData.sscc!="")){
                  //自动打印
                  this.printCloseCtnReport();
                }
              }

              if(scanBy == 'isTraceId'){
                // clean carton
                // this.clearCarTonData();
                // this.newEditCartData.sscc == null;
                // this.cartonSearchVal = '';
                // this.cartonNoDis = false;

                // focus on sku input
                this.$nextTick(()=>{
                  this.$refs.skuScanUpcRef.select();
                  this.$refs.skuScanUpcRef.focus();
                })
              }

              if(this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'&&this.giftChecked==true) {
                this.$nextTick(()=>{
                  this.$refs.skuScanUpcRef.focus();
                })
              }

              if(this.systemParam.AUTO_CLOSE_CARTON == 'Y' && this.waveType == 'Single'){
                this.$nextTick(()=>{
                  let btn = null ;
                  for(let i in this.btnFunArr){
                    if(this.btnFunArr[i].code == 'Close' && this.btnFunArr[i].arr.length > 0){
                      btn = this.btnFunArr[i].arr[0]
                    }
                  }
                  if(btn != null){
                    this.closeCarton(btn);
                    this.skuScanUpc = '';
                    this.$refs.skuScanUpcRef.focus();
                  }
                  return;
                })
              }
            }else{
              if("CANCEL_CHECK_COMPLETE" == res.msg ){
                this.cancelPartCheckCompleteVisibel = true;
                return;
              }

              this.audioPubFun();
              this.SkuExistVis = true;
              this.errMsg = res.msg
            }
            if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y'){
              this.$nextTick(() => {
                this.epcScanVal = '';
                this.epcVisible = false;
                if (this.$refs.skuScanUpcRef) {
                  this.$refs.skuScanUpcRef.focus();
                } else {
                  setTimeout(() => {
                    this.$refs.skuScanUpcRef.focus();
                  }, 20)
                }
              })
            }
          })

        }else{
          this.$refs.skuScanUpcRef.select()
          this.audioPubFun();
          this.SkuExistVis = true;
          this.errMsg =  this.$i18n.t('pubGicSet.InvalidSKU',{"0":this.skuScanUpc})
        }
        if(this.DeleteChecked){
          this.DeleteChecked = false;
        }
      }

      //  scanpack  采用缓存扫描执行下面的
      else {
        if(this.newEditCartData != undefined && this.newEditCartData.status == '99') {
          this.$refs.skuScanUpcRef.select()
          this.audioPubFun();
          this.SkuExistVis = true;
          this.errMsg = this.$i18n.t('pubGicSet.CartonClose',{"0":this.newEditCartData.sscc})
          return
        }

        // 1. 判断标志位是做减法还是加法
        // this.OtySaoNum 用户输入的数量
        let allPackQty = 0;  // 传入来的sku已扫描总数数量
        let allUnscannQty = 0;  // 传入来的sku未扫描总数数量
        let exsitSku = false;
        // 2. for 循环计算上面的数量
        let unscanQty = 0;// 未扫描总数数量
        for (let t in this.partTable) {
          if(this.partTable[t].sku == this.skuScanUpc){
            exsitSku = true;
            allPackQty +=  parseInt(this.partTable[t].packedQty);
            allUnscannQty +=  parseInt(this.partTable[t].unscannQty);
          }
          unscanQty +=  parseInt(this.partTable[t].unscannQty);
        }
        if(unscanQty==1){
          let SCAN_PACK_LAST_SKU_PROMP = this.systemParam.SCAN_PACK_LAST_SKU_PROMP == undefined ? "N" : this.systemParam.SCAN_PACK_LAST_SKU_PROMP;
          if("Y"==SCAN_PACK_LAST_SKU_PROMP){
            this.$alert(this.$t('publicLang.LastSKUCheckCompletePrompt'),
                {showClose:false,
                  confirmButtonText:this.$t('publicLang.Confirm')
                }
            );
          }
        }

        if(!exsitSku){
          this.$refs.skuScanUpcRef.select()
          this.audioPubFun();
          this.SkuExistVis = true;
          this.errMsg = this.$i18n.t('pubGicSet.InvalidSKU',{"0":this.skuScanUpc})
          return
        }

        // 3. 判断扫描的数量是否合理
        if(this.DeleteChecked){
          if(this.OtySaoNum > allPackQty){
            this.$refs.skuScanUpcRef.select();
            // 回退的数量过大 提示
            this.audioPubFun();
            this.SkuExistVis = true;
            this.errMsg = this.$i18n.t('pubGicSet.NotEnoughSkuRemoved',{"0":this.skuScanUpc});
            return
          }
        }else{
          if(this.OtySaoNum > allUnscannQty){
            this.$refs.skuScanUpcRef.select();
            // 扫描的数量过大 提示
            this.audioPubFun();
            this.SkuExistVis = true;
            this.errMsg =this.$i18n.t('pubGicSet.NotAllowOverPack',{"0":this.skuScanUpc}) ;
            return

          }
        }
        // 找出页面所有有关扫描的sku的row
        let rowsBysku = new Array();
        for (let t in this.partTable) {
          if ( this.partTable[t].sku == this.skuScanUpc) {
            rowsBysku.push(this.partTable[t])
          }
        }

        if (this.DeleteChecked) {
          let qty = parseInt(this.OtySaoNum);
          while(qty > 0){
            let row1 ; // 取出一条并且sscc != * 的数据，并且与 现在当前sscc 是一致的
            let row2 ; // 居于上面的relId 找出一个条sscc = '*'
            for(let t in rowsBysku){
              if ( rowsBysku[t].sscc == this.newEditCartData.sscc && rowsBysku[t].packedQty > 0) {
                row1 = rowsBysku[t]
                break;
              }
            }
            // 根据row1 找出 sscc = '*' 的 row2

            for(let t in rowsBysku){
              if(row1 == null || row1 == undefined){
                if(rowsBysku[t].sscc == '*' && this.skuScanUpc==rowsBysku[t].sku){
                  row2 = rowsBysku[t]
                  break;
                }
              }else if (rowsBysku[t].sscc == '*' && row1.relId == rowsBysku[t].relId && this.skuScanUpc==rowsBysku[t].sku) {
                row2 = rowsBysku[t]
                break;
              }
            }
            // 根据row1 算出该条sku 能回退的数量
            let actualQty = 0;
            if(row1 == null || row1 == undefined){
              if(qty != 0){
                this.$refs.skuScanUpcRef.select();
                // 回退的数量过大 提示
                this.audioPubFun();
                this.SkuExistVis = true;
                this.errMsg = this.$i18n.t('pubGicSet.NotEnoughSkuRemoved',{"0":this.skuScanUpc});
                return
              }
            }else  if (qty > parseInt(row1.packedQty)) {
              actualQty = parseInt(row1.packedQty);
            }else{
              actualQty = qty;
            }
            qty -= actualQty;
            // 显示选中的数据
            this.selectRow = row1;
            // row2 如果没有数据即第一次回退，手动克隆一条 sscc 为* 的数据
            if(row2 == null || row2 == undefined)  {
              row2 = {
                descr: row1.descr,
                pickedQty: actualQty,
                packedQty: 0,
                relId: row1.relId,
                scanField: row1.scanField,
                scanFieldValue: row1.scanFieldValue,
                sku: row1.sku,
                sscc: '*',
                status: 'N',
                unscannQty: actualQty,
                uom: row1.uom,
              }
              this.partTable.unshift(row2)
            }else{
              row2.pickedQty = parseInt(row2.pickedQty)+actualQty;
              row2.unscannQty =parseInt(row2.unscannQty)+ actualQty;
            }
            row1.pickedQty = parseInt(row1.pickedQty) - actualQty
            row1.packedQty = parseInt(row1.packedQty) - actualQty
            this.$refs.scanSuccessMusicRef.play();
          }
        }else{
          // 装箱扫描
          let qty = this.OtySaoNum
          let p = 0
          while(parseInt(qty) > 0){
            let row1 ; // 取出一条并且sscc != * 的数据，并且与 现在当前sscc 是一致的
            let row2 ; // 居于上面的relId 找出一个条sscc = '*'

            //  先找出 sscc = '*' 的 row2
            for(let t in rowsBysku){
              if (rowsBysku[t].sscc == '*' && parseInt(rowsBysku[t].unscannQty) > 0 ) {
                row2 = rowsBysku[t]
                break;
              }
            }

            // 根据row2 找出匹配上sscc =  this.newEditCartData.sscc 并relId 相等的row1
            for(let t in rowsBysku){
              if ( rowsBysku[t].sscc == this.newEditCartData.sscc && row2.relId == rowsBysku[t].relId  && this.skuScanUpc==rowsBysku[t].sku) {
                row1 = rowsBysku[t]
                break;
              }
            }
            // 显示选中的数据
            this.selectRow = row2;
            // 根据row1 算出该条sku 能回退的数量
            let actualQty = 0;
            if (parseInt(qty) > parseInt(row2.unscannQty)) {
              actualQty = parseInt(row2.unscannQty);
              qty = parseInt(qty) - parseInt(actualQty);
            }else{
              actualQty = parseInt(qty);
              qty = 0
            }

            // row2 如果没有数据即第一次扫描，手动克隆一条 sscc 为该sscc 的数据
            if(row1 == null || row1 == undefined)  {
              row1 = {
                descr: row2.descr,
                pickedQty: parseInt(actualQty),
                packedQty: parseInt(actualQty),
                relId: row2.relId,
                scanField: row2.scanField,
                scanFieldValue: row2.scanFieldValue,
                sku: row2.sku,
                sscc: this.newEditCartData.sscc,
                status: row2.status,
                unscannQty: 0,
                uom: row2.uom,
              }
              this.partTable.unshift(row1)
            }else{
              row1.pickedQty = parseInt(row1.pickedQty ) + parseInt(actualQty);
              row1.packedQty = parseInt( row1.packedQty) + parseInt(actualQty);
            }
            row2.unscannQty = parseInt(row2.unscannQty) - parseInt(actualQty)
            row2.pickedQty = parseInt(row2.pickedQty) - parseInt(actualQty)
            this.$refs.scanSuccessMusicRef.play();
          }

        }


        if(this.newEditCartData.logisticsid == undefined || this.newEditCartData.logisticsid == null  ){
          this.newEditCartData.logisticsid = this.trackingNoMap[this.selectRow.relId];
        }
        //  统计选中的数据，计算绿色球的数量及百分比
        let skuPickQty = 0;
        this.skuPackedQty = 0; // 绿色球的数量
        this.skuUnpackQty = 0; // 红色球的数量
        this.carTonQty = 0;    // 浅蓝色的数量
        this.carTonOfSku = 0;
        for(let t in this.partTable){
          if ( this.selectRow.sku == this.partTable[t].sku && this.selectRow.relId == this.partTable[t].relId) {
            this.skuPackedQty += parseInt(this.partTable[t].packedQty);  // 统计绿球数量
            skuPickQty += parseInt(this.partTable[t].pickedQty)
          }
          this.skuUnpackQty +=  parseInt(this.partTable[t].unscannQty);  // 统计红球数量
          if(this.partTable[t].sscc == this.newEditCartData.sscc){
            this.carTonQty += parseInt(this.partTable[t].packedQty)  // 统计浅蓝色球数量
          }
        }
        // 往carton table 添加数据

        let skuCarton = undefined;
        for(let t in  this.cartonTable){
          if(this.cartonTable[t].sku == this.skuScanUpc){
            skuCarton = this.cartonTable[t];
            break;
          }
        }
        if(skuCarton == undefined ){
          this.selectRow.scannedQty = parseInt(this.OtySaoNum)
          if(this.DeleteChecked){
            this.selectRow.currentScanQty = 0 - parseInt(this.OtySaoNum)
          }else{
            this.selectRow.currentScanQty = parseInt(this.OtySaoNum)
          }
          //this.cartonTable.push(  this.selectRow)
          let scanedCartonTable = new Array();
          let selectRowArray = new Array()
          for (let t in this.cartonTable) {
            scanedCartonTable.push(this.cartonTable[t])
          }
          selectRowArray.push(this.selectRow)

          this.cartonTable = selectRowArray.concat(scanedCartonTable);
        }else{
          let relId =  skuCarton.relId == undefined ? this.selectRow.relId : skuCarton.relId
          let waveId =  skuCarton.waveId == undefined ? this.selectRow.waveId : skuCarton.waveId
          skuCarton.relId = relId;
          skuCarton.waveId = waveId;
          let qty = skuCarton.scannedQty == undefined ? 0 : parseInt(skuCarton.scannedQty)
          let qty2 = skuCarton.currentScanQty == undefined ? 0 : parseInt(skuCarton.currentScanQty)

          if(this.DeleteChecked){
            skuCarton.scannedQty =  qty - parseInt(this.OtySaoNum)
            skuCarton.currentScanQty = qty2 - parseInt(this.OtySaoNum)
          }else{
            skuCarton.scannedQty =  qty + parseInt(this.OtySaoNum)
            skuCarton.currentScanQty = qty2  + parseInt(this.OtySaoNum)
          }
        }

        this.carTonOfSku = this.cartonTable.length;  // 浅绿色的球体
        this.Percentage =  parseInt(this.skuPackedQty) == 0 ? 0 :  Math.round((parseInt( this.skuPackedQty) / parseInt(skuPickQty)) * 10000) / 100.0 + "%"
        //                  系统参数Y新增
        this.scanPackDtoList = []
        if(this.scanPackDtoList.length == 0){
          for(let i in this.cartonTable){
            if(this.cartonTable[i].relId != undefined){
              if(this.cartonTable[i].currentScanQty==0){
                let obj = {
                  "cartonUid":this.newEditCartData.uid,
                  "delete": false,
                  "relId": this.cartonTable[i].relId,
                  "scanPackQty": parseInt(this.cartonTable[i].scannedQty),
                  "sku":  this.cartonTable[i].sku,
                  "waveId":  this.WareheaderSearchVal
                }
                this.scanPackDtoList.push(obj)
              }else if(this.cartonTable[i].currentScanQty<0){
                let cQty=0-parseInt(this.cartonTable[i].currentScanQty);
                let obj = {
                  "cartonUid":this.newEditCartData.uid,
                  "delete": true,
                  "relId": this.cartonTable[i].relId,
                  "scanPackQty": parseInt(cQty),
                  "sku":  this.cartonTable[i].sku,
                  "waveId":  this.WareheaderSearchVal
                }
                this.scanPackDtoList.push(obj)
              }else{
                let obj = {
                  "cartonUid":this.newEditCartData.uid,
                  "delete": false,
                  "relId": this.cartonTable[i].relId,
                  "scanPackQty": parseInt(this.cartonTable[i].currentScanQty),
                  "sku":  this.cartonTable[i].sku,
                  "waveId":  this.WareheaderSearchVal
                }
                this.scanPackDtoList.push(obj)
              }
            }
          }
        }


        this.resortPartTable()
        this.skuScanUpc ="";
        if(this.DeleteChecked){
          this.DeleteChecked = false;
        }
      }
    },
    resortPartTable(){
      // 重新排序 含有* 的排在前面
      let sortTable1 = new Array()
      // 重新排序 不含有* 的排在前面
      let sortTable2 = new Array()

      let sortTable3 = new Array()
      for (let t in this.partTable) {
        if(this.partTable[t].sscc == '*' ){
          if (parseInt(this.partTable[t].unscannQty) > 0){
            sortTable1.push(this.partTable[t])
          }
        }else if(this.partTable[t].sscc == this.newEditCartData.sscc){
          sortTable2.push(this.partTable[t])
        }else if(parseInt(this.partTable[t].packedQty) > 0){
          sortTable3.push(this.partTable[t])
        }
      }
      // 合并sortTable1、sortTable2
      this.partTable = sortTable1.concat(sortTable2,sortTable3)

    },
    async epcEnterEvt(){
      if(!this.epcScanVal){
        return
      }

      if(this.systemParam.SCAN_IN_EPC == 'Y' || this.systemParam.SCAN_IN_EPC_BY_SKU == 'Y' || this.systemParam.MBSHA_SCAN_IN_EPC == 'Y'){
        if(this.epcScanVal == 'SWEIGHTS'){
          this.$nextTick(()=>{
            this.$refs.weightRef.select();
            this.$refs.weightRef.focus()

          })
          this.epcScanVal = ''
          return
        }
        if(this.epcScanVal == 'SCBMS'){
          this.$nextTick(()=>{
            this.$refs.cbmRef.focus()
          })
          this.epcScanVal = ''
          return
        }
        if("CLOSECTN" == this.epcScanVal ){
          let closeBtn = null ;
          for(let i in this.btnFunArr){
            if(this.btnFunArr[i].code == 'Close' && this.btnFunArr[i].arr.length > 0){
              closeBtn = this.btnFunArr[i].arr[0]
            }
          }
          if(closeBtn != null){
            this.closeCarton(closeBtn);
            this.epcScanVal = '';
            this.$refs.cbmRef.focus();
          }
          return;
        }
        if(this.epcScanVal.startsWith("CT_")){
          let cartonTypeLen = this.epcScanVal.split("_").length;
          let cartonTypeValue = cartonTypeLen>1?this.epcScanVal.split("_")[1]:"";
          for(let t in this.cartonTypeSelectData){
            if(cartonTypeValue === this.cartonTypeSelectData[t]){
              this.epcScanVal = '';
              this.editForm.setFieldsValue({"cartonType":cartonTypeValue});
              this.cartonTypeChange2(cartonTypeValue);
              return;
            }
          }
        }
        if(this.epcScanVal.startsWith("PS_")){
          let deskNumber = this.epcScanVal.substring(3,this.epcScanVal.length);
          this.epcScanVal = '';
          this.editForm.setFieldsValue({"userdefined1":deskNumber});
          this.newEditCartData.userdefined1 = deskNumber;
          return;
        }
        if("CHECKCOMPLETE" == this.epcScanVal.toUpperCase() ){
          let btn = null ;
          for(let i in this.btnFunArr){
            if(this.btnFunArr[i].code == 'CheckComplete' && this.btnFunArr[i].arr.length > 0){
              btn = this.btnFunArr[i].arr[0]
            }
          }
          if(btn != null){
            this.checkPartialPack(btn);
            this.epcScanVal = '';
          }
          return;
        }
      }

      if(this.systemParam.SCAN_PACK_CHECK_EPC_FOR_ORDERTYPE === 'Y') {
        const pass = await this.checkEpcByOrderType();
        if(!pass) return;
      }
      if(this.systemParam.SCAN_IN_EPC_BY_SKU === 'Y') {
        this.sacnpackAjax();
        return;
      }
      if(this.systemParam.SCAN_IN_EPC=='Y' && this.projectCode=='MKKSHA' && this.HUDF01!='C6'){
        if(this.epcScanVal.length!=24){
          let that = this;
          this.$customMessage.error(this.$t('pubGicSet.EPCFormatError'),function () {
            that.epcScanVal=''
            that.$refs.epcScanRef.focus();
          });
          return;
        }
      }
      this.$refs.skuScanUpcRef.focus();
    },
    checkEpcByOrderType() {
      let params = {
        serialNo : this.epcScanVal,
      };
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      let that = this;
      return ajax.post(api.SCANPACKCHECKEPCBYORDERTYPE, params).then(res=>{
        if(res.code != 200){
          that.$customMessage.error(res.msg,function () {
            that.epcScanVal=''
            that.$refs.epcScanRef.focus();
          });
          return false;
        }
        return true;
      }).catch(()=>{
        return false;
      });
    },
    //            enter事件
    async SkuEnterEvt(enterType) {
      if(!this.skuScanUpc){
        return
      }
      if(this.systemParam.SCAN_PACK_CHECK_EPC_FOR_ORDERTYPE === 'Y' && this.epcScanVal) {
        const pass = await this.checkEpcByOrderType();
        if(!pass){
          this.skuScanUpc = ''
          return;
        }
      }
      let SCAN_IN_EPC = this.systemParam.SCAN_IN_EPC;
      let MBSHA_SCAN_IN_EPC = this.systemParam.MBSHA_SCAN_IN_EPC;
      if(SCAN_IN_EPC== 'Y'){
        // Tom 2024-07-15 新增勾选框【赠品】，勾选后防伪码处扫描框即为灰色，光标自动跳到SKU扫描框，可以直接扫描商品 如扫描的商品为非GWP开头的商品条码时，则弹出提示框 提示：非赠品，需扫描防伪码
        if(this.systemParam.SCAN_IN_EPC!=undefined&&this.systemParam.SCAN_IN_EPC=='Y'&&this.giftChecked==true) {
          if(!this.skuScanUpc.startsWith("GWP")) {
            this.$refs.skuScanUpcRef.select()
            this.$customMessage.error(this.$t('pubGicSet.notGiftScanAntiCode'));
            return;
          }
        } else {
          // 默认流程
          if(!this.epcScanVal){
            //this.errMsg =  this.$t('pubGicSet.EPCIsEmpty');
            return
          }
        }

      }

      // Tom 2024-12-11 当防伪码扫描框为可扫描状态时，未扫描防伪码直接扫描SKU时弹出提示：请扫描防伪码
      if(MBSHA_SCAN_IN_EPC == 'Y' && this.mbshaScanInEpcCheck==false && (this.epcScanVal==null || this.epcScanVal.length == 0)) {
        this.$refs.skuScanUpcRef.select()
        this.$customMessage.error(this.$t('pubGicSet.pleaseScanAntiCode'));
        return;
      }

      if(this.OtySaoNum < 1 || this.OtySaoNum == null  || (enterType != 'QtyEnter' && !this.lockChecked)){
        this.$refs.SacnPackSaomaQtyNum.focus()
        this.OtySaoNum = null
        return
      }
      if(this.skuScanUpc == 'SWEIGHTS'){
        this.$nextTick(()=>{
          this.$refs.weightRef.select();
          this.$refs.weightRef.focus()

        })
        this.skuScanUpc = ''
        // this.editForm.resetFields()
        return
      }
      if(this.skuScanUpc == 'SCBMS'){
        this.$nextTick(()=>{
          this.$refs.cbmRef.focus()
        })
        this.skuScanUpc = ''
        // this.editForm.resetFields()
        return
      }
      // if(this.skuScanUpc == 'SCLOSES'){
      //     this.skuScanUpc = ''
      //     this.closeCarton({arr:[]})
      //     return
      // }
      if("CLOSECTN" == this.skuScanUpc ){
        let closeBtn = null ;
        for(let i in this.btnFunArr){
          if(this.btnFunArr[i].code == 'Close' && this.btnFunArr[i].arr.length > 0){
            closeBtn = this.btnFunArr[i].arr[0]
          }
        }
        if(closeBtn != null){
          this.closeCarton(closeBtn);
          this.skuScanUpc = '';
          this.$refs.cbmRef.focus();
        }
        return;
      }

      //扫码箱型 自动设置箱型及长宽高体积等数据
      if(this.skuScanUpc.startsWith("CT_")){
        let cartonTypeLen = this.skuScanUpc.split("_").length;
        let cartonTypeValue = cartonTypeLen>1?this.skuScanUpc.split("_")[1]:"";
        for(let t in this.cartonTypeSelectData){
          if(cartonTypeValue === this.cartonTypeSelectData[t]){
            this.skuScanUpc = '';
            this.editForm.setFieldsValue({"cartonType":cartonTypeValue});
            this.cartonTypeChange2(cartonTypeValue);
            return;
          }
        }
      }
      if(this.skuScanUpc.startsWith("PS_")){
        let deskNumber = this.skuScanUpc.substring(3,this.skuScanUpc.length);
        this.skuScanUpc = '';
        this.editForm.setFieldsValue({"userdefined1":deskNumber});
        this.newEditCartData.userdefined1 = deskNumber;
        return;
      }

      //扫描CHECKCOMPLETE执行复核完成功能
      if("CHECKCOMPLETE" == this.skuScanUpc.toUpperCase() ){
        let btn = null ;
        for(let i in this.btnFunArr){
          if(this.btnFunArr[i].code == 'CheckComplete' && this.btnFunArr[i].arr.length > 0){
            btn = this.btnFunArr[i].arr[0]
          }
        }
        if(btn != null){
          this.checkPartialPack(btn);
          this.skuScanUpc = '';
        }
        return;
      }

      let skuEx=0;
      //转化为SKU

      let arraySkuList = [];
      if(this.partTable.length>0){
        for(let i in this.partTable){
          if(this.skuScanUpc==this.partTable[i].sku ){
            this.skuScanUpc=this.partTable[i].sku
            skuEx=1;
            break;
          }else if (this.skuScanUpc == this.partTable[i].scanFieldValue && (! arraySkuList.includes(this.partTable[i].sku))) {
            arraySkuList.push(this.partTable[i].sku);
          }
        }
      }


      if(skuEx==0){
        if(this.upcTable != null &&  Object.keys(this.upcTable).length > 0){
          let key = this.skuScanUpc == null ? "" : this.skuScanUpc.toLocaleLowerCase();
          let skuList  = this.upcTable[key];
          if ( skuList != null ){
            if (skuList.length == 1){
              this.skuScanUpc = skuList[0];
            }else {
              let selectSkuList = [];
              for(let i in skuList){
                let sku =  skuList[i];
                for(let t in this.tbSkuList){
                  if(this.tbSkuList[t].toLowerCase() == sku.toLowerCase()) {
                    selectSkuList.push(this.tbSkuList[t]);
                    break;
                  }
                }
              }
              if (selectSkuList.length == 1){
                skuEx = 1;
                this.skuScanUpc = selectSkuList[0];
              }else {
                let qtyGtZeroSku = [];
                for(let i in this.partTable){
                  let unscanQty =  this.partTable[i].unscannQty;
                  let packedQty =  this.partTable[i].packedQty;
                  let sku =  this.partTable[i].sku;
                  let sscc =  this.partTable[i].sscc;
                  if (this.DeleteChecked){
                    if (packedQty > 0 && sscc == this.cartonSearchVal  && selectSkuList.concat(sku)){
                      qtyGtZeroSku.push(sku)
                    }
                  }else {
                    if (unscanQty > 0 && selectSkuList.concat(sku)){
                      qtyGtZeroSku.push(sku)
                    }
                  }
                }
                if (qtyGtZeroSku.length == 1){
                  skuEx = 1;
                  this.skuScanUpc = qtyGtZeroSku[0];
                }else {
                  if (qtyGtZeroSku.length == 0 && selectSkuList.length > 0 ){
                    skuEx = 1;
                    this.skuScanUpc = selectSkuList[0]
                  }else {
                    this.$refs.selectSku.showModal(qtyGtZeroSku);
                    return;
                  }

                }
              }
            }
          }
        }
      }


      if (skuEx == 0 && arraySkuList.length > 0){
        if (arraySkuList.length == 1){
          this.skuScanUpc = arraySkuList[0];
        }else {
          let qtyGtZeroSku = [];
          for(let i in this.partTable){
            let unscanQty =  this.partTable[i].unscannQty;
            let packedQty =  this.partTable[i].packedQty;
            let sscc =  this.partTable[i].sscc;
            let sku =  this.partTable[i].sku;
            if (this.DeleteChecked){
              if (packedQty > 0 && sscc == this.cartonSearchVal && selectSkuList.concat(sku)){
                qtyGtZeroSku.push(sku)
              }
            }else {
              if (unscanQty > 0 && selectSkuList.concat(sku)){
                qtyGtZeroSku.push(sku)
              }
            }
          }
          if (qtyGtZeroSku.length == 1){
            skuEx = 1;
            this.skuScanUpc = qtyGtZeroSku[0];
          }else {
            if (qtyGtZeroSku.length == 0 && arraySkuList.length > 0 ){
              skuEx = 1;
              this.skuScanUpc = arraySkuList[0]
            }else {
              this.$refs.selectSku.showModal(qtyGtZeroSku);
              return;
            }
          }
        }
      }



      // Tom 2024-06-05 MKKSHA WMS新增弹出扫描框 扫描毛领子条码，扫描完成后才允许正常扫描商品条码
      let CHECK_CUS_SKU = this.systemParam.CHECK_CUS_SKU;
      if(CHECK_CUS_SKU==undefined || CHECK_CUS_SKU==null|| CHECK_CUS_SKU==''|| CHECK_CUS_SKU=='N') {
        // 走原流程
        this.SkuEnterEvtAfter();
      } else {
        // 走检查是否扫毛领子条码流程
        this.checkCscSku();
      }

    },
    SkuEnterEvtAfter() {
      if ( this.newEditCartData.sscc == undefined ||this.cartonSearchVal == null) {
        this.addNewCarton('sku')
        return
      }
      this.sacnpackAjax();
    },
    SkuEnterEvtQty() {
      if(!this.skuScanUpc){
        return
      }
      if(this.OtySaoNum < 1 || this.OtySaoNum == null){
        this.$refs.SacnPackSaomaQtyNum.focus()
        this.OtySaoNum = null
        return
      }
      if(this.skuScanUpc == 'SWEIGHTS'){
        this.$nextTick(()=>{
          this.$refs.weightRef.focus()
        })
        this.skuScanUpc = ''
        this.editForm.resetFields()
        return
      }
      if(this.skuScanUpc == 'SCBMS'){
        this.$nextTick(()=>{
          this.$refs.cbmRef.focus()
        })
        this.skuScanUpc = ''
        this.editForm.resetFields()
        return
      }
      if(this.skuScanUpc == 'SCLOSES'){
        this.skuScanUpc = ''
        this.closeCarton({arr:[]})
        return
      }

      this.SkuEnterEvt("QtyEnter");
      //转化为SKU
      // if(this.partTable.length>0){
      //     for(let i in this.partTable){
      //         if(this.skuScanUpc==this.partTable[i].sku || this.skuScanUpc==this.partTable[i].scanFieldValue){
      //             this.skuScanUpc=this.partTable[i].sku
      //             break;
      //         }
      //     }
      // }
      //
      //
      // if (this.newEditCartData.sscc == undefined || this.cartonSearchVal == null) {
      //     this.addNewCarton('sku')
      //     return
      // }
      // this.sacnpackAjax()
    },
    xuzijisuan(){

      let allocationQty = 0    // 总数量
      let pickQty = 0   // 已扫描总数

      //   总箱子赋值
      for(let t in this.partTable){
        if(this.partTable[t].sku == this.selectRow.sku && this.partTable[t].relId == this.selectRow.relId){

          if(this.partTable[t].sscc == '*'){
            if(this.DeleteChecked){
              this.partTable[t].pickedQty = this.partTable[t].pickedQty + parseInt(this.actualQty)
              this.partTable[t].unscannQty = this.partTable[t].unscannQty + parseInt(this.actualQty)
            }else{
              this.partTable[t].pickedQty = this.partTable[t].pickedQty - parseInt(this.actualQty)
              this.partTable[t].unscannQty = this.partTable[t].unscannQty - parseInt(this.actualQty)
            }
          }
          allocationQty += this.partTable[t].pickedQty
          pickQty += this.partTable[t].packedQty
        }
      }
      this.skuPackedQty = pickQty
      this.Percentage = this.pickQty == 0 ? 0 :  Math.round((pickQty / allocationQty) * 10000) / 100.0 + "%"

    },
    clearZero(){
      //                            总箱子赋值
      for(let t in this.partTable){
        if(this.partTable[t].sku == this.selectRow.sku){
          if(this.partTable[t].pickedQty==0 && this.partTable[t].packedQty==0){
            this.partTable.splice(t,1)
          }
        }
      }
    },
    //            编辑carton
    editCartonSubmit() {
      this.editSpin = true;
      this.editForm.validateFields((err, values) => {
        if (!err) {
          let params = values;
          if(this.scanpackSearchType == 'WAVE_HEADER'){
            params.waveId = this.WareheaderSearchVal
          }else{
            params.relId = this.soheaderSearchVal
          }
          params.cartonUid = this.newEditCartData.uid;
          params.rowVersion = this.newEditCartData.rowVersion;

          ajax.post(api.SAVECARTON, params).then(res => {
            this.editSpin = false;
            if (res.code == 200) {
              this.newEditCartData = res.data;
              let uom = 1;
              if(this.newEditCartData.dimensionUom == null){
                uom=1;
              }else if(this.newEditCartData.dimensionUom == 'm' || this.newEditCartData.dimensionUom == 'M'){
                uom=1;
              }else if(this.newEditCartData.dimensionUom == 'dm' || this.newEditCartData.dimensionUom == 'DM'){
                uom=10;
              }else if(this.newEditCartData.dimensionUom == 'cm' || this.newEditCartData.dimensionUom == 'CM'){
                uom=100;
              }
              let cbm = (this.newEditCartData.length / uom)*(this.newEditCartData.width / uom)*(this.newEditCartData.height / uom);
              let newCartypeCbmJs = this.systemParam.CBM
              if(newCartypeCbmJs == null){
                this.newEditCartData.cbm = cbm;
              }else{
                this.newEditCartData.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs);
              }

            } else {
              const refreshCarton = res.cartonDataExpired === true;
              this.$customMessage.warning(
                res.msg || this.$t('publicLang.Error'),
                refreshCarton ? () => this.cartonSearchEnter() : undefined
              );
            }
          });
        } else {
          this.editSpin = false;
        }
      });
    },
    closeCartonSubmit() {
      this.editSpin = true;
      this.editForm.validateFields((err, values) => {
        if (!err) {
          let params = values;
          if(this.scanpackSearchType == 'WAVE_HEADER'){
            params.waveId = this.WareheaderSearchVal
          }else{
            params.relId = this.soheaderSearchVal
          }
          params.cartonUid = this.newEditCartData.uid;
          ajax.post(api.SAVECARTON, params).then(res => {
            this.editSpin = false;
            if (res.code == 200) {
              // this.newEditCartData = res.data;
            }
          });
        } else {
          this.editSpin = false;
        }
      });
    },
    //            lock Enter Event
    OtySaoNumChange(){
      var regNumber = /^\+?[1-9][0-9]*$/;
      if(!regNumber.test(this.OtySaoNum)){
        this.OtySaoNum = null
      }
    },
    OtySaoNumEnterEvt() {
      const reg = /^[1-9][0-9]*$/;
      let value = this.OtySaoNum;
      if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
        this.$refs.skuScanUpcRef.focus();
        this.SkuEnterEvtQty();
      } else {
        this.$customMessage.error(value +" is not an integer.");
      }
    },
    //            扫货错误提示
    handleCancelSkuTishi() {
      this.audioPubFun();
      this.SkuExistVis = false;
      // this.errMsg = this.$t('pubGicSet.PleaseNewOneCartonFirst')
    },
    //            播放提示声
    audioPubFun() {
      let audio = document.getElementById("ScanpackmusicSKU");
      if (audio !== null) {
        if (audio.paused) {
          audio.play();
        } else {
          audio.pause();
        }
      }
    },
    //            lock扫码数量事件
    lockChangeEvnt(e) {
      this.lockChecked = !this.lockChecked;
      if(!this.lockChecked){
        this.OtySaoNum = null
      }else{
        this.OtySaoNum = 1
      }
    },
    //            回退扫码数量
    DeleteChangeEvnt() {
      this.DeleteChecked = !this.DeleteChecked;
      this.lockChecked = true
      this.OtySaoNum = 1
    },
    checkIsCartonOrPrePack(val){//Is Carton/Is Pre-Pack改变事件
      if("isCarton" == val){
        this.isCartonChecked = !this.isCartonChecked;
        if(this.isCartonChecked){
          this.isPrePackChecked = false;
          this.isTraceIdChecked = false;
          this.skuLabel = this.$t('batchReceive.CartonID');
        }
      }else if("isPrepack" == val){
        this.isPrePackChecked = !this.isPrePackChecked;
        if(this.isPrePackChecked){
          this.isCartonChecked = false;
          this.isTraceIdChecked = false;
          this.skuLabel = this.$t('cfs.barcode');
        }
      }else if ("isTraceId" == val) {
        this.isTraceIdChecked = !this.isTraceIdChecked;
        if(this.isTraceIdChecked){
          this.isCartonChecked = false;
          this.isPrePackChecked = false;
          this.skuLabel = this.$t('batchReceive.TraceID');
        }
      }
      if(!this.isCartonChecked && !this.isPrePackChecked && !this.isTraceIdChecked){
        this.skuLabel = this.$t('pubGicSet.SKU');
      }
      if(this.isCartonChecked || this.isPrePackChecked || this.isTraceIdChecked){
        this.isHiddenTable = false
        this.isSwitchDisabled = true
      }else{
        this.isSwitchDisabled = false
      }
    },
    //            表格样式
    cellClassName({ row }) {
      if (row === this.selectRow) {
        return "col-orange";
      }
    },
    cartonTableClass({ row }) {
      if(row.sku ===this.cartonTableSKU){
        return "col-orange";
      }
    },
    rowStyle ({ row }) {
      if(row.sscc == '*'){
        return {
          color: 'red'
        }
      }
    },
    colStyle (status) {
      if(status == 'N'){
        return {
          color: 'red'
        }
      }
    },
    //            search carton
    cartonSearchEnter() {
      let params = {
        sscc: this.cartonSearchVal
      };
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
        this.epcScanVal='';
        this.$refs.epcScanRef.focus();
      }else{
        this.$refs.skuScanUpcRef.focus()
      }
      this.skuabled = true

      //pack_scan_carton
      this.pack_scan_carton(params);
    },
    // enter事件结束

    //            cartonbtnEvent
    PrintSsccEvnt(type){
      let ajaxurl = ajax.ajaxUrl();
      let params = {
        sscc: this.newEditCartData.sscc,
      }
      if(type == 1){
        params.server = 1
        params.name = 'sscc'

        for(let i in this.btnFunArr){
          if(this.btnFunArr[i].code == 'ob.scan.pack.print.sscc'){
            if(this.btnFunArr[i].arr.length > 0){
              let arrUids = []
              let arr = this.btnFunArr[i].arr
              for(let i in arr){
                arrUids.push(arr[i].uid)
              }
              params.combHeaderUids = arrUids.join(',')
              ajax.get(api.PRINTPREVIEW,params).then(res=>{
                if(res.code == 200){
                  this.$message.success(res.msg);
                }else{
                  this.$customMessage.error(res.msg);
                }
              })
            }
          }
        }

      }else{
        params.name = 'carton'

        for(let i in this.btnFunArr){
          if(this.btnFunArr[i].code == 'ob.scan.pack.print.carton'){
            if(this.btnFunArr[i].arr.length > 0){
              let arrUids = []
              let arr = this.btnFunArr[i].arr
              for(let i in arr){
                arrUids.push(arr[i].uid)
              }
              params.combHeaderUids = arrUids.join(',')
              ajax.get(api.PRINTPREVIEW,params).then(res=>{
                if(res.code == 200){
                  this.$message.success(res.msg);
                }else{
                  this.$customMessage.error(res.msg);
                }
              })
            }
          }
        }
      }
      axios.post(ajaxurl + api.PRINTPREVIEW, params, {
        headers: {
          Authorization: cookie.getBearerToken()
        },
        responseType: "blob" //二进制流
      }).then((data)=>{
        if(type == 0){
          var blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
          var url = window.URL.createObjectURL(blob);
          window.open(url);
        }else{
          if(data.code == 200){
            this.$message.success(data.msg);
          }
        }

      })
    },
    closeCarton(item) {

      let extApi = item.externalApi;
      if(! extApi){
        this.$customMessage.warning("Unable to find button API");
        return
      }

      // 保存箱子信息
      // this.closeCartonSubmit();
      // 校对箱子的属性格式
      this.editForm.validateFields((err, values) => {
        if (!err) {
          let params = values;
          if(this.scanpackSearchType == 'WAVE_HEADER'){
            params.waveId = this.WareheaderSearchVal
          }else{
            params.relId = this.soheaderSearchVal;
          }
          params.cartonUid = this.newEditCartData.uid;
          params.rowVersion = this.newEditCartData.rowVersion;

          if (this.newEditCartData.sscc != undefined) {
            params.sscc = this.newEditCartData.sscc;
          } else {
            this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
            return;
          }

          // 关闭箱子
          params.scanPackDtoList = this.scanPackDtoList
          ajax.post(extApi, params).then(res => {
            if (res.code == 200) {
              this.editForm.resetFields()
              this.$nextTick(()=>{
                if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
                  this.epcScanVal='';
                  this.$refs.epcScanRef.focus();
                }else{
                  this.$refs.skuScanUpcRef.focus()
                }
              })
              // this.newEditCartData = {}
              this.init()
              // if(this.systemParam.scanpack_way == 'Y'){
              //     this.showCartonSave = true;
              // }
              this.cartonSearchVal = null
              this.cartonNoDis = false
              this.scanPackDtoList = []
              this.cartonTable = []
              this.carTonQty = 0
              this.carTonOfSku = 0
              this.Percentage = 0
              this.skuPackedQty = 0

              this.appendDisab =false
              this.closeDisab = true
              this.$message.success(res.msg)
              let ajaxurl = ajax.ajaxUrl();
              let params = {
                name: 'sscc',
                sscc: this.newEditCartData.sscc,
                server: 1
              }
              axios.post(ajaxurl + api.PRINTPREVIEW, params, {
                headers: {
                  Authorization: cookie.getBearerToken()
                },
                responseType: "blob" //二进制流
              }).then((res)=>{
//                this.$message.success(res.msg);
              })

              let CAINIAO_JD_AUTO_PRINT = this.systemParam.CAINIAO_JD_AUTO_PRINT == undefined ? 'N' : this.systemParam.CAINIAO_JD_AUTO_PRINT;

              if("Y" == CAINIAO_JD_AUTO_PRINT || "y" == CAINIAO_JD_AUTO_PRINT){
                //京东菜鸟自动打印
                params = {
                  relId: this.soheaderSearchVal
                };
                ajax.post(api.AUPRINTCAINIAOJDLABEL, params).then(data => {
                  if (data.code == 200){
                    let printData = data.data.printData;
                    if(null!=printData && ""!=printData){
                      // this.$message.success(data.msg, 3);
                      if (data.data.printType != null && "SF" == data.data.printType ){
                        this.printSfLabel(printData,data.data.msg);
                      }else {
                        let port = data.data.port;
                        webSocketPrint.doPrint(port,printData);
                      }
                    }
                  }else {
                    this.$customMessage.warning(data.msg, 3);
                  }
                });
              }
              if((this.soheaderSearchVal!=null&&this.soheaderSearchVal!="")||(this.WareheaderSearchVal!=null&&this.WareheaderSearchVal!="")||(this.newEditCartData.sscc!=null&&this.newEditCartData.sscc!="")){
                //自动打印
                this.printCloseCtnReport();
              }
              this.clearCarTonData();

              if(this.systemParam.AUTO_CHECK_COMPLETE == 'Y' && this.waveType == 'Single'){
                this.$nextTick(()=>{
                  if(res.data!=undefined && res.data!=null && res.data.relIdList!=undefined &&  res.data.relIdList!=null) {
                    this.closeCartonRelIdArr = res.data.relIdList;
                  }
                  let btn = null ;
                  for(let i in this.btnFunArr){
                    if(this.btnFunArr[i].code == 'CheckComplete' && this.btnFunArr[i].arr.length > 0){
                      btn = this.btnFunArr[i].arr[0]
                    }
                  }
                  if(btn != null){
                    this.checkPartialPack(btn);
                    this.skuScanUpc = '';
                    this.$refs.skuScanUpcRef.focus();
                  }
                  return;
                })
              }
            } else {
              if(extApi == '/pack/scan/close' && 'CANCEL_CHECK_COMPLETE' == res.msg){
                this.cancelPartCheckCompleteVisibel = true;
                return;
              }
              const refreshCarton = res.cartonDataExpired === true;
              this.$customMessage.error(
                res.msg,
                refreshCarton ? () => this.cartonSearchEnter() : undefined
              );
            }
          });




        } else {
          this.editSpin = false;
        }
      });




    },
    //      open carton
    appendCarton(item) {

      let extApi = item.externalApi;
      if(! extApi){
        this.$customMessage.warning("Unable to find button API");
        return
      }

      let params = {};
      if (this.newEditCartData.sscc != undefined) {
        params.sscc = this.newEditCartData.sscc;
      } else {
        this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
        return;
      }
      ajax.post(extApi, params).then(res => {
        if (res.code == 200) {
          // 设置当前Carton
          this.newEditCartData.status = "00";
          this.closeDisab = false
          this.appendDisab = true
          for (let i in this.partTable){
            if(this.partTable[i].sscc == this.newEditCartData.sscc){
              this.partTable[i].status='N'
            }
          }
          this.$message.success(res.msg)
        } else {
          this.$customMessage.error(res.msg);
        }
      });

      // for(let i in this.btnFunArr){
      //     if(this.btnFunArr[i].code == 'ob.scan.pack.append'){
      //         if(this.btnFunArr[i].arr.length > 0){
      //             let arrUids = []
      //             let arr = this.btnFunArr[i].arr
      //             for(let i in arr){
      //                 arrUids.push(arr[i].uid)
      //             }
      //             params.combHeaderUids = arrUids.join(',')
      //             ajax.get(api.PRINTPREVIEW,params).then(res=>{
      //                 if(res.code == 200){
      //                     this.$message.success(res.msg);
      //                 }else{
      //                     this.$customMessage.error(res.msg);
      //                 }
      //             })
      //         }
      //     }
      // }



      this.$nextTick(()=>{
        if(this.systemParam.SCAN_IN_EPC=='Y'||this.systemParam.MBSHA_SCAN_IN_EPC=='Y'){
          this.epcScanVal='';
          this.$refs.epcScanRef.focus();
        }else{
          this.$refs.skuScanUpcRef.focus()
        }
      })
    },
    //            新增carton
    newCarton() {
      this.addCortonVisible = true
    },
    addNewCarton(type) {
      this.addform.validateFields((err, values) => {
        if (!err) {
          let params = values;
//            params.packHeaderUid = this.tablepackUid
          if(this.scanpackSearchType == 'WAVE_HEADER'){
            params.waveId = this.WareheaderSearchVal
          }else{
            params.relId = this.soheaderSearchVal
          }

          if (this.newType == "closeNew") {
            params.sscc = this.newEditCartData.sscc;
          }
          this.skuabled = true
          ajax.post(api.SAVECARTON, params).then(res => {
            this.skuabled = false
            if (res.code == 200) {
              this.newEditCartData = res.data;

              let uom = 1;
              if(this.newEditCartData.dimensionUom == null){
                uom=1;
              }else if(this.newEditCartData.dimensionUom == 'm' || this.newEditCartData.dimensionUom == 'M'){
                uom=1;
              }else if(this.newEditCartData.dimensionUom == 'dm' || this.newEditCartData.dimensionUom == 'DM'){
                uom=10;
              }else if(this.newEditCartData.dimensionUom == 'cm' || this.newEditCartData.dimensionUom == 'CM'){
                uom=100;
              }
              let cbm = (this.newEditCartData.length / uom)*(this.newEditCartData.width / uom)*(this.newEditCartData.height / uom);
              let newCartypeCbmJs = this.systemParam.CBM
              if(newCartypeCbmJs == null){
                this.newEditCartData.cbm = cbm;
              }else{
                this.newEditCartData.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs);
              }

              this.cartonNoDis = false
              if(type == 'sku'){
                this.cartonNoDis = true
                this.$nextTick(()=>{
                  this.sacnpackAjax()
                })
              }else{
                if(this.systemParam.scanpack_way == 'N'){
                  this.init('addNew')
                }
              }
              this.addCortonVisible = false;
              this.newCartonJson = {}
              this.closeAndNewDisab = false
              this.newDisab =  false
              this.closeDisab = false
              this.removeDisab = false
              this.addform.resetFields();
              this.carTonQty = 0
              this.carTonOfSku = 0
              this.cartonTable = []
              this.cartonTableXt = []
              this.cartonSearchVal =this.newEditCartData.sscc
            }else{
              this.$customMessage.error(res.msg);
            }
          });
        }
      });
    },
    //             closeAndnew
    closeAndNew() {
      if (this.newEditCartData.sscc != undefined) {
        this.addCortonVisible = true;
        this.newType = "closeNew";
        let ajaxurl = ajax.ajaxUrl();
        let params = {
          name: 'sscc',
          sscc: this.newEditCartData.sscc,
          server: 1
        }

        for(let i in this.btnFunArr){
          if(this.btnFunArr[i].code == 'ob.scan.pack.close.new'){
            if(this.btnFunArr[i].arr.length > 0){
              let arrUids = []
              let arr = this.btnFunArr[i].arr
              for(let i in arr){
                arrUids.push(arr[i].uid)
              }
              params.combHeaderUids = arrUids.join(',')
              ajax.get(api.PRINTPREVIEW,params).then(res=>{
                if(res.code == 200){
                  this.$message.success(res.msg);
                }else{
                  this.$customMessage.error(res.msg);
                }
              })
            }
          }
        }
        axios.post(ajaxurl + api.PRINTPREVIEW, params, {
          headers: {
            Authorization: cookie.getBearerToken()
          },
          responseType: "blob" //二进制流
        }).then((res)=>{
        })

      } else {
//        this.$customMessage.error("请选取new 数据");
        return
      }
    },
    //            remove carton
    removeCarton(item) {
      let extApi = item.externalApi;
      if(! extApi){
        this.$customMessage.warning("Unable to find button API");
        return
      }


      let params = {};
//        params.packHeaderUid = this.tablepackUid
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      if (this.newEditCartData.sscc != undefined) {
        params.sscc = this.newEditCartData.sscc;
      } else {
        this.$customMessage.error(this.$t('pubGicSet.Nosscc'));
        return;
      }
      let that = this;
      // Tom 20240906 REMOVE_PICK_DATA_DIALOG 为Y 弹出提示
      if(this.systemParam.REMOVE_PICK_DATA_DIALOG == 'Y') {
        this.$customConfirm({
          title: this.$t('scanPack.deletePickingData'),
          okText: this.$t('scanPack.cancelCheckCompleteYes'),
          cancelText: this.$t('scanPack.cancelCheckCompleteNo'),
          onOk() {
            params.deletePickAmr = 'Y';
            that.postRemoveCarton(extApi,params);
          },
          onCancel() {
            that.postRemoveCarton(extApi,params);
          }
        })
      } else {
        this.postRemoveCarton(extApi,params);
      }
    },
    postRemoveCarton(extApi,params) {
      ajax.post(extApi, params).then(res => {
        if (res.code == 200) {
          if(this.systemParam.scanpack_way == 'Y'){
            this.showCartonSave = false;
          }
          this.scanComponentsFlag = false;
          this.init()
          this.clearCarTonData()
          this.cartonNoDis = false
          this.lockChecked = true
          this.OtySaoNum = 1
          this.editForm.resetFields()
        }else{
          this.$customMessage.error(res.msg);
        }
      });
    },
    removeCancelPck(){
      let params = {};
//          params.packHeaderUid = this.tablepackUid
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      ajax.post(api.SCANCANCELPACK,params).then(res =>{
        if(res.code == 200){
          this.init()
          this.clearCarTonData()
        }else{
          this.$customMessage.error(res.msg);
        }
      })
    },
    importScanningFile(){
      // let uid = this.soUid == undefined ? '': this.soUid;
      let relId = this.soheaderSearchVal
      this.$refs.importScanningFile.show(relId);
      return;
    },
    clearCarTonData(){
      this.carTonQty = 0
      this.carTonOfSku =0
      this.skuPackedQty = 0
      this.skuUnpackQty = 0
      this.Percentage = 0
      this.cartonSearchVal = null
      this.skuScanUpc = ''
      this.cartonTable = []
      this.newEditCartData = {};
      //this.lockChecked = false
      this.DeleteChecked = false
      this.skuabled = false
    },


    printPdf(val){
      let ajaxurl = ajax.ajaxUrl();
      let params = {
        name: val,
      }
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveUid = this.soUid
      }else{
        params.soRelId = this.tableRelId
      }
      axios.post(ajaxurl + api.PRINTPREVIEW, params, {
        headers: {
          Authorization: cookie.getBearerToken()
        },
        responseType: "blob" //二进制流
      })
          .then(function(data) {
            var blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
            var url = window.URL.createObjectURL(blob);
            window.open(url);
          });
    },
    GenerateLabel(val){
      let params = {
        relId: this.tableRelId
      }

      ajax.post(api.GENERATELABEL,params).then(res=>{
        if(res.code == 200){
          //this.init()
          //this.$message.success(res.msg);
          // var blob = new Blob([data.data], {type: "application/pdf;charset=utf-8"});
          // console.log(">>>>"+res.msg)
          window.open(res.msg);
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },
    IntersoftCancelLabel(val){
      let params = {
        relId: this.tableRelId
      }
      ajax.post(api.CANCELLABEL,params).then(res=>{
        if(res.code == 200){
          //this.init()
          this.$message.success(res.msg);
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },
    IntersoftGenerateMainfest(val){
      let params = {
        relId: this.tableRelId
      }
      ajax.post(api.GENERATEMAINFEST,params).then(res=>{
        if(res.code == 200){
          //this.init()
          window.open(res.msg);
          this.$message.success("success");
        }else{
          this.$customMessage.warning(res.msg);
        }
      })
    },
    cartonTypeChange(val){
      ajax.get(api.GENERICPROJECTINFO).then(res=>{
        let newCartypeCbmJs = res.data.CBM
        ajax.get(api.PACKCARTONTYPE,{cartonType: val}).then(res=>{
          this.newCartonJson = res.data
          if(newCartypeCbmJs == null){
            let cbm = (this.newCartonJson.length / 100)*(this.newCartonJson.width / 100)*(this.newCartonJson.height / 100)
            this.newCartonJson.cbm = cbm
          }else{
            let cbm = (this.newCartonJson.length / 100)*(this.newCartonJson.width / 100)*(this.newCartonJson.height / 100)
            this.newCartonJson.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs)
          }
          ajax.get(api.PACKSCANWGTUOM).then(res=>{
            this.newCartonJson.weightUom = res.data.weightUom
          })
        })
      })
    },
    cartonTypeChange2(val){
      let cartonTypeList =  this.systemParam.CARTON_MASTER_LIST;
      let newCartypeCbmJs = this.systemParam.CBM
      cartonTypeList.forEach((item, index) => {
        if(item.cartonType == val){
          this.$set(this.newEditCartData,'length',item.length)
          this.$set(this.newEditCartData,'width',item.width)
          this.$set(this.newEditCartData,'height',item.height)
          this.$set(this.newEditCartData,'dimensionUom',item.dimensionUom)
          this.$set(this.newEditCartData,'weightUom',item.weightUom)


          let uom = 1;
          if(this.newEditCartData.dimensionUom == null){
            uom=1;
          }else if(this.newEditCartData.dimensionUom == 'm' || this.newEditCartData.dimensionUom == 'M'){
            uom=1;
          }else if(this.newEditCartData.dimensionUom == 'dm' || this.newEditCartData.dimensionUom == 'DM'){
            uom=10;
          }else if(this.newEditCartData.dimensionUom == 'cm' || this.newEditCartData.dimensionUom == 'CM'){
            uom=100;
          }


          let cbm = (this.newEditCartData.length / uom)*(this.newEditCartData.width / uom)*(this.newEditCartData.height / uom)
          if(newCartypeCbmJs == null){
            this.newEditCartData.cbm = cbm
          }else{
            this.newEditCartData.cbm = this.pub_decimaltoFixed(cbm,newCartypeCbmJs)
          }

        }
      })
    },
    pub_decimaltoFixed(params,num) {
      let newpar = parseFloat(params);
      let reg = /^[0-9]+.?[0-9]*$/;
      if(reg.test(newpar)){
        let newNum = newpar.toFixed(num);
        return newNum
      }else{
        return
      }
    },
    // 获取用户本地ip的方法
    getUserIP (onNewIP) {
      let MyPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection
      let pc = new MyPeerConnection({
        iceServers: []
      })
      let noop = () => {

      }
      let localIPs = {}
      let ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
      let iterateIP = (ip) => {
        if (!localIPs[ip]) onNewIP(ip)
        localIPs[ip] = true
      }
      pc.createDataChannel('')
      pc.createOffer().then((sdp) => {
        sdp.sdp.split('\n').forEach(function (line) {
          if (line.indexOf('candidate') < 0) return
          line.match(ipRegex).forEach(iterateIP)
        })
        pc.setLocalDescription(sdp, noop, noop)
      }).catch((reason) => {
      })
      pc.onicecandidate = (ice) => {
        if (!ice || !ice.candidate || !ice.candidate.candidate || !ice.candidate.candidate.match(ipRegex)) return
        ice.candidate.candidate.match(ipRegex).forEach(iterateIP)
      }
    },

    previewHttpFile(url) {
      let ajaxurl = ajax.ajaxUrl();
      let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
      window.open(previewUrl, '_blank');
    },

    previewHttpFiles(urls) {
      for (const url of urls) {
        let ajaxurl = ajax.ajaxUrl();
        let previewUrl = ajaxurl + "/printViewFile?filePath=" + url;
        window.open(previewUrl, '_blank');
      }
    },

    pushPrinter(printRequest) {
      let printRequests = [];
      printRequests.push(printRequest);
      this.autoPrint(printRequests);
    },

    async printAfterShipGenerateLabel(type) {
      // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为 Check Complete
      if ((this.soheaderSearchVal != undefined && this.soheaderSearchVal != '') || type == 'Courier Edi') {
        let paramsData = [];
        let paramsRelId = {};
        paramsRelId.key = "relId";
        paramsRelId.value = this.soheaderSearchVal,
            paramsData.push(paramsRelId);

        // ip
        let paramsIP = {};
        paramsIP.key = "IP";
        paramsIP.value = this.ip;
        paramsData.push(paramsIP);

        let tt = {
          language: this.lang,
          params: paramsData,
        }
        try {
          await this.getPrinters();
        } catch (error) {
          console.error("打印机获取失败:", error.message);
          this.printers = [];   // 重要：确保 printers 是一个数组
        }
        await ajax.post(api.AFTERSHIPCREATELABEL, tt).then(res => {
          if (res.code == 200) {
            if (res.print != undefined && res.print != null && res.print != '') {
              this.$message.success('success');
              let printRequest = res.print;
              this.pushPrinter(printRequest);

            } else if (res.data != undefined && res.data != '') {
              this.$message.success('success');
              let pdfUrl = res.data;
              this.previewHttpFile(pdfUrl);

              // 重新查询箱子信息
              if(this.cartonSearchVal!=undefined &&this.cartonSearchVal!=null&& this.cartonSearchVal!='') {
                this.cartonSearchEnter();
              }

            } else {
              if ('Courier Edi' === type) {
                // Courier Edi (暂时改动，ServiceType为Null不报错，也不调用ApiRequest)
                if (res.msg != undefined && res.msg != '') {
                  this.$customMessage.error(res.msg);
                }
              }
            }

            /*if (res.print) {
                                let printRequest = res.print;
                                this.pushPrinter(printRequest);
                            }*/

          } else {
            this.$customMessage.error(res.msg);
          }
        });
      }
    },

    printAfterShipCancelLabel(type) {
      // 只有当RelId不为Null 又或者 调用是Courier Edi的时候才调用 => 当type为Cancel Check Complete
      if ((this.soheaderSearchVal != undefined && this.soheaderSearchVal != '') || type == 'Courier Edi') {
        let paramsData = [];
        let paramsRelId = {};
        paramsRelId.key = "relId";
        paramsRelId.value = this.soheaderSearchVal;
        paramsData.push(paramsRelId);
        let tt = {
          language: this.lang,
          params: paramsData,
        }
        ajax.post(api.AFTERSHIPCANCELLABEL, tt).then(res => {
          if (res.code == 200) {
            if (res.data != undefined && res.data != '') {
              this.$message.success(res.data);
              // 重新查询箱子信息
              if(this.cartonSearchVal!=undefined &&this.cartonSearchVal!=null&& this.cartonSearchVal!='') {
                this.cartonSearchEnter();
              }

            } else {
              if ('Courier Edi' === type) {
                this.$customMessage.error(res.msg);
              }
            }
          } else {
            this.$customMessage.error(res.msg);
          }
        });
      }
    },
    // Tom 2024-06-05 检查是否扫描毛领子条码
    checkCscSku() {

      let params = {
        sku : this.skuScanUpc,
      };
      if(this.scanpackSearchType == 'WAVE_HEADER'){
        params.waveId = this.WareheaderSearchVal
      }else{
        params.relId = this.soheaderSearchVal
      }
      ajax.post(api.SCANPACKCHECKSCSSKU, params).then(res=>{
        if(res.code == 200){
          let cusSku = res.data;
          if(cusSku!=undefined&&cusSku!=null&&cusSku!='') {
            // 有值 弹框扫描毛领子条码
            this.$refs.refScanCusSkuWindow.show(cusSku);
          } else {
            // 走原流程
            this.SkuEnterEvtAfter();
          }
        }else{
          this.audioPubFun();
          this.SkuExistVis = true;
          this.errMsg = res.msg
        }
      })


    },
    // 确认毛领子条码回调
    confirmCusSkuCallBack() {
      // 继续原流程
      this.SkuEnterEvtAfter();
    },

    giftCheckedChange() {
      this.epcValDisabled = this.giftChecked;
      // 选中
      if(this.giftChecked) {
        this.$nextTick(()=>{
          this.$refs.skuScanUpcRef.focus()
        })
      } else {
        this.$nextTick(()=>{
          this.$refs.epcScanRef.focus()
        })
      }
    },
    mbshaScanInEpcCheckChange() {
      this.epcValDisabled = this.mbshaScanInEpcCheck;
      // 选中
      if(this.mbshaScanInEpcCheck) {
        this.$nextTick(()=>{
          this.$refs.skuScanUpcRef.focus()
        })
      } else {
        this.$nextTick(()=>{
          this.$refs.epcScanRef.focus()
        })
      }
    },
    /*===================================Slide to select start======================================================*/
    //表格单元格点击事件
    tableCellClick(e){
      let {row,column}=e;
      if(!this.isSelecting){
        this.closeAreaBox();
        this.selectionStart = this.getCellPosition(e.$event.target);
        this.selectionEnd =this.selectionStart;
        //设置样式
        this.setselectedCellArea();
      }
    },
    //返回table的ref名称
    getTablexGrid(){
      return this.$refs.skuTable;
    },
    //添加事件
    addListener(){
      //添加多选列
      this.$nextTick(()=>{
        this.closeAreaBox();

        let tbody=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper table tbody");
        if(tbody){
          tbody.addEventListener("mousedown",this.tbodymousedown);
          tbody.addEventListener("mouseup",this.tbodymouseup);
          tbody.addEventListener("mousemove",this.tbodymousemove);
          tbody.addEventListener("paste",this.tbodykeydown);
        }
        let bodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper");
        if(bodyWrapper){
          //注意这里的ref名称，这里是非fixed区域的框的名称
          bodyWrapper.appendChild(this.$refs.cellarea);
        }

        setTimeout(()=>{
          let leftfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper table tbody");
          if(leftfixedtbody){
            leftfixedtbody.addEventListener("mousedown",this.tbodymousedown);
            leftfixedtbody.addEventListener("mouseup",this.tbodymouseup);
            leftfixedtbody.addEventListener("mousemove",this.tbodymousemove);
            leftfixedtbody.addEventListener("paste",this.tbodykeydown);
          }

          let leftfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper");
          if(leftfixedBodyWrapper){
            //注意这里的ref名称，这里是fixed区域的框的名称
            leftfixedBodyWrapper.appendChild(this.$refs.fixedcellarea);
          }
        })


        setTimeout(()=>{
          let rightfixedtbody=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper table tbody");

          if(rightfixedtbody){
            rightfixedtbody.addEventListener("mousedown",this.tbodymousedown);
            rightfixedtbody.addEventListener("mouseup",this.tbodymouseup);
            rightfixedtbody.addEventListener("mousemove",this.tbodymousemove);
            rightfixedtbody.addEventListener("paste",this.tbodykeydown);
          }

          let rightfixedBodyWrapper=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper");
          if(rightfixedBodyWrapper){
            //注意这里的ref名称，这里是fixed区域的框的名称
            rightfixedBodyWrapper.appendChild(this.$refs.rightfixedcellarea);
          }
        })
      })
    },
    //鼠标按下事件
    tbodymousedown(event){
      //左键
      if(event.button === 0){
        this.closeAreaBox();
        // 记录选择操作起始位置,
        this.selectionStart = this.getCellPosition(event.target);
        this.tempselectionStart = this.getCellPosition(event.target);
        this.isSelecting = true;
      }
    },
    //鼠标移动事件
    tbodymousemove(event){
      //左键
      if(event.button === 0){
        if (!this.isSelecting) return;
        var x = event.clientX;
        // 记录选择操作结束位置
        this.selectionEnd = this.getCellPosition(event.target);
        //设置样式
        this.setselectedCellArea();
        //持续向右滚动
        var x = event.clientX;
        var table=this.getTablexGrid().$el.querySelector(".vxe-table--body-wrapper table");
        if(table){
          let tableRect=table.parentElement.getBoundingClientRect();
          if (x > tableRect.right - 20){
            table.parentElement.scrollLeft+=20;
          }
        }
      }
    },
    //鼠标按键结束事件
    tbodymouseup(event) {
      //左键
      if(event.button === 0){
        this.isSelecting = false;
      }
    },
    // 获取单元格位置
    getCellPosition(cell) {
      try{
        while(cell.tagName !== 'TD'){
          cell = cell.parentElement;
        }
        const rowIndex2 = cell.parentElement.rowIndex;
        const cellIndex2 = cell.cellIndex;
        const test = cell.getAttribute("data-colid");
        let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
        const cellIndex = visibleColumn.findIndex((col)=>{
          return col.id==cell.getAttribute("data-colid");
        })
        let visibleData=this.getTablexGrid().getTableData()["visibleData"];
        const rowIndex =visibleData.findIndex((row)=>{
          return row._XID==cell.parentElement.getAttribute("data-rowid");
        })
        return { rowIndex, cellIndex };
      }catch(e){
        return { rowIndex:-1,cellIndex:-1};
      }
    },
    //设置框打开
    setselectedCellArea(){
      //this.$nextTick(()=>{
      try{

        let startRowIndex=this.selectionStart["rowIndex"];
        let endRowIndex=this.selectionEnd["rowIndex"];
        let startColumnIndex=this.selectionStart["cellIndex"];
        let endColumnIndex=this.selectionEnd["cellIndex"];
        let {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft}=this.getAreaBoxPostion();
        // .vxe-table--fixed-wrapper .vxe-table--body-wrapper
        // .vxe-table--main-wrapper .vxe-table--body-wrapper
        var activeElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
        var mainElement=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
        var leftfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
        var leftfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
        var rightfixedActiveElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-active-area");
        var rightfixedMainElement=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-main-area");
        //获取固定列宽度fixed--hidden
        var fixedWidth=0;
        let flexDiv=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-left-wrapper");
        if(flexDiv){
          fixedWidth=flexDiv.offsetWidth;
        }
        var elements=[activeElement,mainElement,leftfixedActiveElement,leftfixedMainElement];
        elements.forEach((element)=>{
          if(element){
            element.style.width=`${width}px`;
            element.style.height=`${height}px`;
            element.style.top=`${top}px`;
            element.style.left=`${left}px`;
            element.style.display="block";
          }
        })
        //如果选择的索引位置大于等于右侧固定的位置
        //获取右侧固定的索引位置
        let rightFixedIndex=this.getrightFixedIndex();
        if(rightFixedIndex>-1&&endColumnIndex>=rightFixedIndex){
          elements=[rightfixedActiveElement,rightfixedMainElement];
          elements.forEach((element)=>{
            if(element){
              element.style.width=`${rightFixedWidth}px`;
              element.style.height=`${height}px`;
              element.style.top=`${top}px`;
              element.style.left=`${rightFixedLeft}px`;
              element.style.display="block";
            }
          })
        }
        this.openAreaBox();
        this.selectionStart={"cellIndex":startColumnIndex,"rowIndex":startRowIndex};
        this.selectionEnd={"cellIndex":endColumnIndex,"rowIndex":endRowIndex};
      }catch(e){

      }
      //});

    },
    getrightFixedIndex(){
      let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
      return visibleColumn.findIndex((col)=>{
        return col.fixed=="right";
      })
    },
    //根据开始位置和结束位置的索引计算框的width,height,left,top
    getAreaBoxPostion(){
      let startRowIndex=this.selectionStart["rowIndex"];
      let endRowIndex=this.selectionEnd["rowIndex"];
      let startColumnIndex=this.selectionStart["cellIndex"];
      let endColumnIndex=this.selectionEnd["cellIndex"];
      let visibleColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
      let visibleData=this.getTablexGrid().getTableData()["visibleData"];
      if(startColumnIndex<0||endColumnIndex<0||startRowIndex<0||endRowIndex<0)return;
      var maxColumnIndex=visibleColumn.length-1;
      var maxRowIndex=visibleData.length-1;
      if(endColumnIndex>maxColumnIndex){
        endColumnIndex=maxColumnIndex;
      }
      if(endRowIndex>maxRowIndex){
        endRowIndex=maxRowIndex;
      }
      // height width left top display
      // cellarea
      let width=0,height=0,left=0,top=0,leftFixedWidth=0,rightFixedWidth=0,mainWidth=0,rightFixedLeft=0,leftFixedLeft=0;
      let fixedwidth=0,fixedheight=0,fixedleft=0,fixedtop=0;

      for (let index = 0; index < visibleColumn.length; index++) {
        let col = visibleColumn[index]
        let colid = col.id;
        let columnWidthTemp = this.getTablexGrid().getColumnById(colid).renderWidth;
        if(columnWidthTemp == undefined) {
          columnWidthTemp = 0;
        }
        if(index<startColumnIndex){
          left+=columnWidthTemp;
          if(col.fixed=="left"){
            leftFixedLeft+=columnWidthTemp;
          }else if(col.fixed=="right"){
            rightFixedLeft+=columnWidthTemp;
          }
        }
        if(index<=endColumnIndex&&startColumnIndex<=index){
          width+=columnWidthTemp;
          if(col.fixed=="left"){
            leftFixedWidth+=columnWidthTemp;
          }else if(col.fixed=="right"){
            rightFixedWidth+=columnWidthTemp;
          }else{
            mainWidth+=columnWidthTemp;
          }
        }
      }

      height=(endRowIndex-startRowIndex+1)*this.gridOptions["row-config"]["height"];
      if(height<=0||width<=0){
        this.destroyAreaBox();
        return;
      }
      top=startRowIndex*this.gridOptions["row-config"]["height"];
      return {width,height,left,top,leftFixedWidth,rightFixedWidth,mainWidth,rightFixedLeft,leftFixedLeft};
    },
    //显示范围框
    openAreaBox(){
      var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
      if(element){
        element.style.display="block";
      }
      element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
      if(element){
        element.style.display="block";
      }
      let rightFixedIndex=this.getrightFixedIndex();
      if(rightFixedIndex>-1&&this.selectionEnd["cellIndex"]>=rightFixedIndex){
        element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
        if(element){
          element.style.display="block";
        }
      }
    },
    //关闭范围框
    closeAreaBox(){
      var element=this.getTablexGrid().$el.querySelector(".vxe-table--main-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
      if(element){
        element.style.display="none";
      }
      element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-left-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
      if(element){
        element.style.display="none";
      }
      element=this.getTablexGrid().$el.querySelector(".vxe-table--fixed-wrapper .vxe-table--fixed-right-wrapper .vxe-table--body-wrapper .vxe-table--cell-area");
      if(element){
        element.style.display="none";
      }
    },
    //销毁范围框
    destroyAreaBox(){
      this.selectionStart={"rowIndex":-1,"cellIndex":-1};
      this.selectionEnd={"rowIndex":-1,"cellIndex":-1};
      this.closeAreaBox();
    },
    tableKeydown({$event}){
      this.tbodykeydown($event);
    },
    tbodykeydown(event){
      let tablexgrid=this.getTablexGrid();
      let tableColumn=this.getTablexGrid().getTableColumn()["visibleColumn"];
      let tableData=this.getTablexGrid().getTableData()["visibleData"];
      let startRowIndex=this.selectionStart["rowIndex"];
      let endRowIndex=this.selectionEnd["rowIndex"];
      let startColumnIndex=this.selectionStart["cellIndex"];
      let endColumnIndex=this.selectionEnd["cellIndex"];
      var maxColumnIndex=tableColumn.length-1;
      var maxRowIndex=tableData.length-1;
      var minColumnIndex=0;
      var minRowIndex=0;

      if (event.ctrlKey && event.keyCode === 67) {
        //ctrl+c 复制
        this.contextMenuClickEvent({menu:{code:"cellCopy"}});
        event.preventDefault();
      }
    },
    contextMenuClickEvent({menu,row,column,rowIndex,columnIndex,$event}){
      let startRowIndex=this.selectionStart["rowIndex"];
      let endRowIndex=this.selectionEnd["rowIndex"];
      let startColumnIndex=this.selectionStart["cellIndex"];
      let endColumnIndex=this.selectionEnd["cellIndex"];
      let visibleColumnData = this.getTablexGrid().getTableColumn()["visibleColumn"];
      var tableData=this.getTablexGrid().getTableData()["visibleData"];
      switch(menu.code){
          //复制
        case "cellCopy":
          let enterStr="\r\n";
          let spaceStr="\t";
          let data=[];
          for(var i=startRowIndex;i<=endRowIndex;i++){
            let value=[];
            for(var j=startColumnIndex;j<=endColumnIndex;j++){
              value.push(tableData[i][visibleColumnData[j].property]);
            }
            data.push(value);
          }
          let finalStr=data.map((value)=>{
            return value.join(spaceStr);
          }).join(enterStr);
          this.copyValue(finalStr);
          break;

      }
    },

    //复制的工具方法
    copyValue(value){
      if (XEClipboard.copy(value)) {
        this.$message.success(this.$t('generic.copySuccess'));
      }
    },
    /*===================================Slide to select end========================================================*/
    handleResize() {
      this.$nextTick(() => {
        this.printHeight = window.innerHeight / 4 * 3;
      });
    },
  },
  mounted(){
    this.getUserIP((ip) => {
      this.ip = ip;
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>
<style lang="less">

.confirm-icon {
  display: inline-block;
  .anticon {
    margin-left: 6px;
    font-size: 24px;
    color: #faad14;

  }
}

.cancel-pick-confirm-message {
  display: flex;
  align-items: flex-start;
  line-height: 1.5;
  word-break: break-word;

  .confirm-icon {
    flex: 0 0 auto;
    margin-right: 8px;
  }
}

.cancel-pick-confirm-text {
  font-size: 16px;
  //font-weight: 600;
  //color: #7A7A7A;
}

.check-complete-confirm-text {
  text-align: center;
  margin: 0px;
  margin-left: 4px;
  font-size: 16px;
  //font-weight: 600;
  //color: #7A7A7A;
}

.cancel-pick-confirm-list {
  margin-top: 12px;
  margin-left: 38px;
  max-height: 160px;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: 16px;
  line-height: 1.8;
  word-break: break-word;
}

.cancel-pick-confirm-sku {
  display: inline-block;
  padding-right: 40px;
}

.cancel-pick-confirm-value {
  font-size: 16px !important;
}

.ant-message span {
  white-space:pre-wrap;
}






.ant-btn-group > .ant-btn:first-child:not(:last-child), .ant-btn-group > span:first-child:not(:last-child) > .ant-btn {
  border: 0px;
}

.ant-dropdown-button>.ant-btn-default{
  padding: 0 7px;
  font-size: 14px;
  border-radius: 4px;
  height: 24px;
}
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}
#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

#scanpack {
  background: #fff;
}
.scanCodeTile {
  font-size: 12px;
  text-align: center;
}
.radiusback {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  i {
    font-size: 70px;
    color: #fff;
  }
}
.scanpackHeader {
  display: flex;
  align-items: center;
  justify-content: left;
}
.scanpackTitle {
  font-size: 12px;
  margin: 0 10px;
  width: 120px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: right;
  color: rgba(0, 0, 0, 0.85);
  font-weight: bold;
}
.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.mytable-style .vxe-body--row.row-green {
  background-color: darkseagreen;
  color: #333;
}

.component-btn{
  font-size: 10px;
  padding: 3px;
  margin-right: 5px;
  border-radius: 3px;
  margin-top: 5px;
  border: 1px solid black;
  pointer-events: none;
}
.component-btn-inactive-bgc{
  background-color: #ABA7A7;
}
.component-btn-active-bgc{
  background-color: #9FFF8C;
}
.platfrom-sty{
  display: inline-block;
  font-weight: 500;
  font-size: 43px;
  /* border: 2px solid red; */
  padding: 50px 100px;
  text-align: center;
  color: red;
  background-color: #d9d9d9;
}

</style>
<style scoped>
.un-select-vxe-table {
  -webkit-user-select: none; /* Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}
</style>
